import C, { useRef as k, useCallback as z, useState as W, useContext as H, useEffect as O, createContext as Y, useMemo as V, version as Lr, cloneElement as xl, forwardRef as ve, isValidElement as Mr } from "react";
import Nr, { flushSync as on, createPortal as Rr } from "react-dom";
function El(t) {
  var e, n, l = "";
  if (typeof t == "string" || typeof t == "number") l += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var i = t.length;
    for (e = 0; e < i; e++) t[e] && (n = El(t[e])) && (l && (l += " "), l += n);
  } else for (n in t) t[n] && (l && (l += " "), l += n);
  return l;
}
function Or() {
  for (var t, e, n = 0, l = "", i = arguments.length; n < i; n++) (t = arguments[n]) && (e = El(t)) && (l && (l += " "), l += e);
  return l;
}
const Z = typeof document < "u" ? C.useLayoutEffect : () => {
};
var Ft;
const zr = (Ft = C.useInsertionEffect) !== null && Ft !== void 0 ? Ft : Z;
function ne(t) {
  const e = k(null);
  return zr(() => {
    e.current = t;
  }, [
    t
  ]), z((...n) => {
    const l = e.current;
    return l?.(...n);
  }, []);
}
function Hr(t) {
  let [e, n] = W(t), l = k(null), i = ne(() => {
    if (!l.current) return;
    let o = l.current.next();
    if (o.done) {
      l.current = null;
      return;
    }
    e === o.value ? i() : n(o.value);
  });
  Z(() => {
    l.current && i();
  });
  let r = ne((o) => {
    l.current = o(e), i();
  });
  return [
    e,
    r
  ];
}
const dt = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, Sl = /* @__PURE__ */ C.createContext(dt), Vr = /* @__PURE__ */ C.createContext(!1);
let jr = !!(typeof window < "u" && window.document && window.document.createElement), It = /* @__PURE__ */ new WeakMap();
function Ur(t = !1) {
  let e = H(Sl), n = k(null);
  if (n.current === null && !t) {
    var l, i;
    let r = (i = C.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || i === void 0 || (l = i.ReactCurrentOwner) === null || l === void 0 ? void 0 : l.current;
    if (r) {
      let o = It.get(r);
      o == null ? It.set(r, {
        id: e.current,
        state: r.memoizedState
      }) : r.memoizedState !== o.state && (e.current = o.id, It.delete(r));
    }
    n.current = ++e.current;
  }
  return n.current;
}
function Wr(t) {
  let e = H(Sl);
  e === dt && !jr && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = Ur(!!t), l = e === dt && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${e.prefix}`;
  return t || `${l}-${n}`;
}
function _r(t) {
  let e = C.useId(), [n] = W(Oe()), l = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${dt.prefix}`;
  return t || `${l}-${e}`;
}
const Gr = typeof C.useId == "function" ? _r : Wr;
function qr() {
  return !1;
}
function Yr() {
  return !0;
}
function Xr(t) {
  return () => {
  };
}
function Oe() {
  return typeof C.useSyncExternalStore == "function" ? C.useSyncExternalStore(Xr, qr, Yr) : H(Vr);
}
let Zr = !!(typeof window < "u" && window.document && window.document.createElement), Me = /* @__PURE__ */ new Map(), je;
typeof FinalizationRegistry < "u" && (je = new FinalizationRegistry((t) => {
  Me.delete(t);
}));
function ae(t) {
  let [e, n] = W(t), l = k(null), i = Gr(e), r = k(null);
  if (je && je.register(r, i), Zr) {
    const o = Me.get(i);
    o && !o.includes(l) ? o.push(l) : Me.set(i, [
      l
    ]);
  }
  return Z(() => {
    let o = i;
    return () => {
      je && je.unregister(r), Me.delete(o);
    };
  }, [
    i
  ]), O(() => {
    let o = l.current;
    return o && n(o), () => {
      o && (l.current = null);
    };
  }), i;
}
function Jr(t, e) {
  if (t === e) return t;
  let n = Me.get(t);
  if (n)
    return n.forEach((i) => i.current = e), e;
  let l = Me.get(e);
  return l ? (l.forEach((i) => i.current = t), t) : e;
}
function Wt(t = []) {
  let e = ae(), [n, l] = Hr(e), i = z(() => {
    l(function* () {
      yield e, yield document.getElementById(e) ? e : void 0;
    });
  }, [
    e,
    l
  ]);
  return Z(i, [
    e,
    i,
    ...t
  ]), n;
}
function Xe(...t) {
  return (...e) => {
    for (let n of t) typeof n == "function" && n(...e);
  };
}
const X = (t) => {
  var e;
  return (e = t?.ownerDocument) !== null && e !== void 0 ? e : document;
}, le = (t) => t && "window" in t && t.window === t ? t : X(t).defaultView || window;
function Qr(t) {
  return t !== null && typeof t == "object" && "nodeType" in t && typeof t.nodeType == "number";
}
function eo(t) {
  return Qr(t) && t.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in t;
}
let to = !1;
function xt() {
  return to;
}
function _(t, e) {
  if (!xt()) return e && t ? t.contains(e) : !1;
  if (!t || !e) return !1;
  let n = e;
  for (; n !== null; ) {
    if (n === t) return !0;
    n.tagName === "SLOT" && n.assignedSlot ? n = n.assignedSlot.parentNode : eo(n) ? n = n.host : n = n.parentNode;
  }
  return !1;
}
const Te = (t = document) => {
  var e;
  if (!xt()) return t.activeElement;
  let n = t.activeElement;
  for (; n && "shadowRoot" in n && (!((e = n.shadowRoot) === null || e === void 0) && e.activeElement); ) n = n.shadowRoot.activeElement;
  return n;
};
function U(t) {
  return xt() && t.target.shadowRoot && t.composedPath ? t.composedPath()[0] : t.target;
}
class no {
  get currentNode() {
    return this._currentNode;
  }
  set currentNode(e) {
    if (!_(this.root, e)) throw new Error("Cannot set currentNode to a node that is not contained by the root node.");
    const n = [];
    let l = e, i = e;
    for (this._currentNode = e; l && l !== this.root; ) if (l.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      const o = l, u = this._doc.createTreeWalker(o, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      n.push(u), u.currentNode = i, this._currentSetFor.add(u), l = i = o.host;
    } else l = l.parentNode;
    const r = this._doc.createTreeWalker(this.root, this.whatToShow, {
      acceptNode: this._acceptNode
    });
    n.push(r), r.currentNode = i, this._currentSetFor.add(r), this._walkerStack = n;
  }
  get doc() {
    return this._doc;
  }
  firstChild() {
    let e = this.currentNode, n = this.nextNode();
    return _(e, n) ? (n && (this.currentNode = n), n) : (this.currentNode = e, null);
  }
  lastChild() {
    let n = this._walkerStack[0].lastChild();
    return n && (this.currentNode = n), n;
  }
  nextNode() {
    const e = this._walkerStack[0].nextNode();
    if (e) {
      if (e.shadowRoot) {
        var n;
        let i;
        if (typeof this.filter == "function" ? i = this.filter(e) : !((n = this.filter) === null || n === void 0) && n.acceptNode && (i = this.filter.acceptNode(e)), i === NodeFilter.FILTER_ACCEPT)
          return this.currentNode = e, e;
        let r = this.nextNode();
        return r && (this.currentNode = r), r;
      }
      return e && (this.currentNode = e), e;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let l = this.nextNode();
      return l && (this.currentNode = l), l;
    } else return null;
  }
  previousNode() {
    const e = this._walkerStack[0];
    if (e.currentNode === e.root) {
      if (this._currentSetFor.has(e))
        if (this._currentSetFor.delete(e), this._walkerStack.length > 1) {
          this._walkerStack.shift();
          let i = this.previousNode();
          return i && (this.currentNode = i), i;
        } else return null;
      return null;
    }
    const n = e.previousNode();
    if (n) {
      if (n.shadowRoot) {
        var l;
        let r;
        if (typeof this.filter == "function" ? r = this.filter(n) : !((l = this.filter) === null || l === void 0) && l.acceptNode && (r = this.filter.acceptNode(n)), r === NodeFilter.FILTER_ACCEPT)
          return n && (this.currentNode = n), n;
        let o = this.lastChild();
        return o && (this.currentNode = o), o;
      }
      return n && (this.currentNode = n), n;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let i = this.previousNode();
      return i && (this.currentNode = i), i;
    } else return null;
  }
  /**
   * @deprecated
   */
  nextSibling() {
    return null;
  }
  /**
   * @deprecated
   */
  previousSibling() {
    return null;
  }
  /**
   * @deprecated
   */
  parentNode() {
    return null;
  }
  constructor(e, n, l, i) {
    this._walkerStack = [], this._currentSetFor = /* @__PURE__ */ new Set(), this._acceptNode = (o) => {
      if (o.nodeType === Node.ELEMENT_NODE) {
        const s = o.shadowRoot;
        if (s) {
          const c = this._doc.createTreeWalker(s, this.whatToShow, {
            acceptNode: this._acceptNode
          });
          return this._walkerStack.unshift(c), NodeFilter.FILTER_ACCEPT;
        } else {
          var u;
          if (typeof this.filter == "function") return this.filter(o);
          if (!((u = this.filter) === null || u === void 0) && u.acceptNode) return this.filter.acceptNode(o);
          if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
        }
      }
      return NodeFilter.FILTER_SKIP;
    }, this._doc = e, this.root = n, this.filter = i ?? null, this.whatToShow = l ?? NodeFilter.SHOW_ALL, this._currentNode = n, this._walkerStack.unshift(e.createTreeWalker(n, l, this._acceptNode));
    const r = n.shadowRoot;
    if (r) {
      const o = this._doc.createTreeWalker(r, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      this._walkerStack.unshift(o);
    }
  }
}
function lo(t, e, n, l) {
  return xt() ? new no(t, e, n, l) : t.createTreeWalker(e, n, l);
}
function L(...t) {
  let e = {
    ...t[0]
  };
  for (let n = 1; n < t.length; n++) {
    let l = t[n];
    for (let i in l) {
      let r = e[i], o = l[i];
      typeof r == "function" && typeof o == "function" && // This is a lot faster than a regex.
      i[0] === "o" && i[1] === "n" && i.charCodeAt(2) >= /* 'A' */
      65 && i.charCodeAt(2) <= /* 'Z' */
      90 ? e[i] = Xe(r, o) : (i === "className" || i === "UNSAFE_className") && typeof r == "string" && typeof o == "string" ? e[i] = Or(r, o) : i === "id" && r && o ? e.id = Jr(r, o) : e[i] = o !== void 0 ? o : r;
    }
  }
  return e;
}
function Pl(...t) {
  return t.length === 1 && t[0] ? t[0] : (e) => {
    let n = !1;
    const l = t.map((i) => {
      const r = Tn(i, e);
      return n || (n = typeof r == "function"), r;
    });
    if (n) return () => {
      l.forEach((i, r) => {
        typeof i == "function" ? i() : Tn(t[r], null);
      });
    };
  };
}
function Tn(t, e) {
  if (typeof t == "function") return t(e);
  t != null && (t.current = e);
}
const io = /* @__PURE__ */ new Set([
  "id"
]), ro = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), oo = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), uo = /* @__PURE__ */ new Set([
  "dir",
  "lang",
  "hidden",
  "inert",
  "translate"
]), kn = /* @__PURE__ */ new Set([
  "onClick",
  "onAuxClick",
  "onContextMenu",
  "onDoubleClick",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onTouchCancel",
  "onTouchEnd",
  "onTouchMove",
  "onTouchStart",
  "onPointerDown",
  "onPointerMove",
  "onPointerUp",
  "onPointerCancel",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerOver",
  "onPointerOut",
  "onGotPointerCapture",
  "onLostPointerCapture",
  "onScroll",
  "onWheel",
  "onAnimationStart",
  "onAnimationEnd",
  "onAnimationIteration",
  "onTransitionCancel",
  "onTransitionEnd",
  "onTransitionRun",
  "onTransitionStart"
]), so = /^(data-.*)$/;
function ee(t, e = {}) {
  let { labelable: n, isLink: l, global: i, events: r = i, propNames: o } = e, u = {};
  for (const s in t) Object.prototype.hasOwnProperty.call(t, s) && (io.has(s) || n && ro.has(s) || l && oo.has(s) || i && uo.has(s) || r && kn.has(s) || s.endsWith("Capture") && kn.has(s.slice(0, -7)) || o?.has(s) || so.test(s)) && (u[s] = t[s]);
  return u;
}
function pe(t) {
  if (ao()) t.focus({
    preventScroll: !0
  });
  else {
    let e = co(t);
    t.focus(), fo(e);
  }
}
let nt = null;
function ao() {
  if (nt == null) {
    nt = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return nt = !0, !0;
        }
      });
    } catch {
    }
  }
  return nt;
}
function co(t) {
  let e = t.parentNode, n = [], l = document.scrollingElement || document.documentElement;
  for (; e instanceof HTMLElement && e !== l; )
    (e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth) && n.push({
      element: e,
      scrollTop: e.scrollTop,
      scrollLeft: e.scrollLeft
    }), e = e.parentNode;
  return l instanceof HTMLElement && n.push({
    element: l,
    scrollTop: l.scrollTop,
    scrollLeft: l.scrollLeft
  }), n;
}
function fo(t) {
  for (let { element: e, scrollTop: n, scrollLeft: l } of t)
    e.scrollTop = n, e.scrollLeft = l;
}
function Et(t) {
  var e;
  if (typeof window > "u" || window.navigator == null) return !1;
  let n = (e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.brands;
  return Array.isArray(n) && n.some((l) => t.test(l.brand)) || t.test(window.navigator.userAgent);
}
function un(t) {
  var e;
  return typeof window < "u" && window.navigator != null ? t.test(((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.platform) || window.navigator.platform) : !1;
}
function he(t) {
  if (process.env.NODE_ENV === "test") return t;
  let e = null;
  return () => (e == null && (e = t()), e);
}
const ke = he(function() {
  return un(/^Mac/i);
}), po = he(function() {
  return un(/^iPhone/i);
}), Cl = he(function() {
  return un(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  ke() && navigator.maxTouchPoints > 1;
}), sn = he(function() {
  return po() || Cl();
}), vo = he(function() {
  return ke() || sn();
}), wl = he(function() {
  return Et(/AppleWebKit/i) && !ho();
}), ho = he(function() {
  return Et(/Chrome/i);
}), Dl = he(function() {
  return Et(/Android/i);
}), bo = he(function() {
  return Et(/Firefox/i);
}), Tl = /* @__PURE__ */ Y({
  isNative: !0,
  open: $o,
  useHref: (t) => t
});
function fa(t) {
  let { children: e, navigate: n, useHref: l } = t, i = V(() => ({
    isNative: !1,
    open: (r, o, u, s) => {
      Kl(r, (c) => {
        kl(c, o) ? n(u, s) : ye(c, o);
      });
    },
    useHref: l || ((r) => r)
  }), [
    n,
    l
  ]);
  return /* @__PURE__ */ C.createElement(Tl.Provider, {
    value: i
  }, e);
}
function Ze() {
  return H(Tl);
}
function kl(t, e) {
  let n = t.getAttribute("target");
  return (!n || n === "_self") && t.origin === location.origin && !t.hasAttribute("download") && !e.metaKey && // open in new tab (mac)
  !e.ctrlKey && // open in new tab (windows)
  !e.altKey && // download
  !e.shiftKey;
}
function ye(t, e, n = !0) {
  var l, i;
  let { metaKey: r, ctrlKey: o, altKey: u, shiftKey: s } = e;
  bo() && (!((i = window.event) === null || i === void 0 || (l = i.type) === null || l === void 0) && l.startsWith("key")) && t.target === "_blank" && (ke() ? r = !0 : o = !0);
  let c = wl() && ke() && !Cl() && process.env.NODE_ENV !== "test" ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: r,
    ctrlKey: o,
    altKey: u,
    shiftKey: s
  }) : new MouseEvent("click", {
    metaKey: r,
    ctrlKey: o,
    altKey: u,
    shiftKey: s,
    bubbles: !0,
    cancelable: !0
  });
  ye.isOpening = n, pe(t), t.dispatchEvent(c), ye.isOpening = !1;
}
ye.isOpening = !1;
function Kl(t, e) {
  if (t instanceof HTMLAnchorElement) e(t);
  else if (t.hasAttribute("data-href")) {
    let n = document.createElement("a");
    n.href = t.getAttribute("data-href"), t.hasAttribute("data-target") && (n.target = t.getAttribute("data-target")), t.hasAttribute("data-rel") && (n.rel = t.getAttribute("data-rel")), t.hasAttribute("data-download") && (n.download = t.getAttribute("data-download")), t.hasAttribute("data-ping") && (n.ping = t.getAttribute("data-ping")), t.hasAttribute("data-referrer-policy") && (n.referrerPolicy = t.getAttribute("data-referrer-policy")), t.appendChild(n), e(n), t.removeChild(n);
  }
}
function $o(t, e) {
  Kl(t, (n) => ye(n, e));
}
function Bl(t) {
  let e = Ze();
  var n;
  const l = e.useHref((n = t.href) !== null && n !== void 0 ? n : "");
  return {
    "data-href": t.href ? l : void 0,
    "data-target": t.target,
    "data-rel": t.rel,
    "data-download": t.download,
    "data-ping": t.ping,
    "data-referrer-policy": t.referrerPolicy
  };
}
function mo(t) {
  let e = Ze();
  var n;
  const l = e.useHref((n = t?.href) !== null && n !== void 0 ? n : "");
  return {
    href: t?.href ? l : void 0,
    target: t?.target,
    rel: t?.rel,
    download: t?.download,
    ping: t?.ping,
    referrerPolicy: t?.referrerPolicy
  };
}
function yo(t, e, n, l) {
  !e.isNative && t.currentTarget instanceof HTMLAnchorElement && t.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
  !t.isDefaultPrevented() && kl(t.currentTarget, t) && n && (t.preventDefault(), e.open(t.currentTarget, t, n, l));
}
let me = /* @__PURE__ */ new Map(), _t = /* @__PURE__ */ new Set();
function Kn() {
  if (typeof window > "u") return;
  function t(l) {
    return "propertyName" in l;
  }
  let e = (l) => {
    if (!t(l) || !l.target) return;
    let i = me.get(l.target);
    i || (i = /* @__PURE__ */ new Set(), me.set(l.target, i), l.target.addEventListener("transitioncancel", n, {
      once: !0
    })), i.add(l.propertyName);
  }, n = (l) => {
    if (!t(l) || !l.target) return;
    let i = me.get(l.target);
    if (i && (i.delete(l.propertyName), i.size === 0 && (l.target.removeEventListener("transitioncancel", n), me.delete(l.target)), me.size === 0)) {
      for (let r of _t) r();
      _t.clear();
    }
  };
  document.body.addEventListener("transitionrun", e), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? Kn() : document.addEventListener("DOMContentLoaded", Kn));
function go() {
  for (const [t] of me)
    "isConnected" in t && !t.isConnected && me.delete(t);
}
function Al(t) {
  requestAnimationFrame(() => {
    go(), me.size === 0 ? t() : _t.add(t);
  });
}
function St() {
  let t = k(/* @__PURE__ */ new Map()), e = z((i, r, o, u) => {
    let s = u?.once ? (...c) => {
      t.current.delete(o), o(...c);
    } : o;
    t.current.set(o, {
      type: r,
      eventTarget: i,
      fn: s,
      options: u
    }), i.addEventListener(r, s, u);
  }, []), n = z((i, r, o, u) => {
    var s;
    let c = ((s = t.current.get(o)) === null || s === void 0 ? void 0 : s.fn) || o;
    i.removeEventListener(r, c, u), t.current.delete(o);
  }, []), l = z(() => {
    t.current.forEach((i, r) => {
      n(i.eventTarget, i.type, r, i.options);
    });
  }, [
    n
  ]);
  return O(() => l, [
    l
  ]), {
    addGlobalListener: e,
    removeGlobalListener: n,
    removeAllGlobalListeners: l
  };
}
function xo(t, e) {
  let { id: n, "aria-label": l, "aria-labelledby": i } = t;
  return n = ae(n), i && l ? i = [
    .../* @__PURE__ */ new Set([
      n,
      ...i.trim().split(/\s+/)
    ])
  ].join(" ") : i && (i = i.trim().split(/\s+/).join(" ")), !l && !i && e && (l = e), {
    id: n,
    "aria-label": l,
    "aria-labelledby": i
  };
}
function Pt(t) {
  const e = k(null), n = k(void 0), l = z((i) => {
    if (typeof t == "function") {
      const r = t, o = r(i);
      return () => {
        typeof o == "function" ? o() : r(null);
      };
    } else if (t)
      return t.current = i, () => {
        t.current = null;
      };
  }, [
    t
  ]);
  return V(() => ({
    get current() {
      return e.current;
    },
    set current(i) {
      e.current = i, n.current && (n.current(), n.current = void 0), i != null && (n.current = l(i));
    }
  }), [
    l
  ]);
}
function Eo(t, e) {
  const n = k(!0), l = k(null);
  O(() => (n.current = !0, () => {
    n.current = !1;
  }), []), O(() => {
    let i = l.current;
    n.current ? n.current = !1 : (!i || e.some((r, o) => !Object.is(r, i[o]))) && t(), l.current = e;
  }, e);
}
function Bn(t, e) {
  const n = k(!0), l = k(null);
  Z(() => (n.current = !0, () => {
    n.current = !1;
  }), []), Z(() => {
    n.current ? n.current = !1 : (!l.current || e.some((i, r) => !Object.is(i, l[r]))) && t(), l.current = e;
  }, e);
}
function So() {
  return typeof window.ResizeObserver < "u";
}
function An(t) {
  const { ref: e, box: n, onResize: l } = t;
  O(() => {
    let i = e?.current;
    if (i)
      if (So()) {
        const r = new window.ResizeObserver((o) => {
          o.length && l();
        });
        return r.observe(i, {
          box: n
        }), () => {
          i && r.unobserve(i);
        };
      } else
        return window.addEventListener("resize", l, !1), () => {
          window.removeEventListener("resize", l, !1);
        };
  }, [
    l,
    e,
    n
  ]);
}
function Fl(t, e) {
  Z(() => {
    if (t && t.ref && e)
      return t.ref.current = e.current, () => {
        t.ref && (t.ref.current = null);
      };
  });
}
function _e(t, e) {
  if (!t) return !1;
  let n = window.getComputedStyle(t), l = /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
  return l && e && (l = t.scrollHeight !== t.clientHeight || t.scrollWidth !== t.clientWidth), l;
}
function De(t, e) {
  let n = t;
  for (_e(n, e) && (n = n.parentElement); n && !_e(n, e); ) n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
function Po(t, e) {
  const n = [];
  for (; t && t !== document.documentElement; )
    _e(t, e) && n.push(t), t = t.parentElement;
  return n;
}
let Co = 0;
const Lt = /* @__PURE__ */ new Map();
function an(t) {
  let [e, n] = W();
  return Z(() => {
    if (!t) return;
    let l = Lt.get(t);
    if (l)
      n(l.element.id);
    else {
      let i = `react-aria-description-${Co++}`;
      n(i);
      let r = document.createElement("div");
      r.id = i, r.style.display = "none", r.textContent = t, document.body.appendChild(r), l = {
        refCount: 0,
        element: r
      }, Lt.set(t, l);
    }
    return l.refCount++, () => {
      l && --l.refCount === 0 && (l.element.remove(), Lt.delete(t));
    };
  }, [
    t
  ]), {
    "aria-describedby": t ? e : void 0
  };
}
function lt(t, e, n, l) {
  let i = ne(n), r = n == null;
  O(() => {
    if (r || !t.current) return;
    let o = t.current;
    return o.addEventListener(e, i, l), () => {
      o.removeEventListener(e, i, l);
    };
  }, [
    t,
    e,
    l,
    r,
    i
  ]);
}
function Il(t, e) {
  let n = Fn(t, e, "left"), l = Fn(t, e, "top"), i = e.offsetWidth, r = e.offsetHeight, o = t.scrollLeft, u = t.scrollTop, { borderTopWidth: s, borderLeftWidth: c, scrollPaddingTop: f, scrollPaddingRight: d, scrollPaddingBottom: p, scrollPaddingLeft: h } = getComputedStyle(t), b = o + parseInt(c, 10), x = u + parseInt(s, 10), m = b + t.clientWidth, g = x + t.clientHeight, E = parseInt(f, 10) || 0, T = parseInt(p, 10) || 0, K = parseInt(d, 10) || 0, F = parseInt(h, 10) || 0;
  n <= o + F ? o = n - parseInt(c, 10) - F : n + i > m - K && (o += n + i - m + K), l <= x + E ? u = l - parseInt(s, 10) - E : l + r > g - T && (u += l + r - g + T), t.scrollLeft = o, t.scrollTop = u;
}
function Fn(t, e, n) {
  const l = n === "left" ? "offsetLeft" : "offsetTop";
  let i = 0;
  for (; e.offsetParent && (i += e[l], e.offsetParent !== t); ) {
    if (e.offsetParent.contains(t)) {
      i -= t[l];
      break;
    }
    e = e.offsetParent;
  }
  return i;
}
function $e(t, e) {
  if (t && document.contains(t)) {
    let o = document.scrollingElement || document.documentElement;
    if (window.getComputedStyle(o).overflow === "hidden") {
      let s = Po(t);
      for (let c of s) Il(c, t);
    } else {
      var n;
      let { left: s, top: c } = t.getBoundingClientRect();
      t == null || (n = t.scrollIntoView) === null || n === void 0 || n.call(t, {
        block: "nearest"
      });
      let { left: f, top: d } = t.getBoundingClientRect();
      if (Math.abs(s - f) > 1 || Math.abs(c - d) > 1) {
        var l, i, r;
        e == null || (i = e.containingElement) === null || i === void 0 || (l = i.scrollIntoView) === null || l === void 0 || l.call(i, {
          block: "center",
          inline: "center"
        }), (r = t.scrollIntoView) === null || r === void 0 || r.call(t, {
          block: "nearest"
        });
      }
    }
  }
}
function Gt(t) {
  return t.mozInputSource === 0 && t.isTrusted ? !0 : Dl() && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function wo(t) {
  return !Dl() && t.width === 0 && t.height === 0 || t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "mouse";
}
function Do(t, e) {
  let { collection: n, onLoadMore: l, scrollOffset: i = 1 } = t, r = k(null), o = ne((u) => {
    for (let s of u)
      s.isIntersecting && l && l();
  });
  Z(() => (e.current && (r.current = new IntersectionObserver(o, {
    root: De(e?.current),
    rootMargin: `0px ${100 * i}% ${100 * i}% ${100 * i}%`
  }), r.current.observe(e.current)), () => {
    r.current && r.current.disconnect();
  }), [
    n,
    o,
    e,
    i
  ]);
}
function To(t) {
  const e = Lr.split(".");
  return parseInt(e[0], 10) >= 19 ? t : t ? "true" : void 0;
}
const ko = "react-aria-clear-focus", Ko = "react-aria-focus";
function Ie(t) {
  return ke() ? t.metaKey : t.ctrlKey;
}
function Bo(t, e = !0) {
  let [n, l] = W(!0), i = n && e;
  return Z(() => {
    if (i && t.current && "getAnimations" in t.current)
      for (let r of t.current.getAnimations()) r instanceof CSSTransition && r.cancel();
  }, [
    t,
    i
  ]), Ll(t, i, z(() => l(!1), [])), i;
}
function Ao(t, e) {
  let [n, l] = W(e ? "open" : "closed");
  switch (n) {
    case "open":
      e || l("exiting");
      break;
    case "closed":
    case "exiting":
      e && l("open");
      break;
  }
  let i = n === "exiting";
  return Ll(t, i, z(() => {
    l((r) => r === "exiting" ? "closed" : r);
  }, [])), i;
}
function Ll(t, e, n) {
  Z(() => {
    if (e && t.current) {
      if (!("getAnimations" in t.current)) {
        n();
        return;
      }
      let l = t.current.getAnimations();
      if (l.length === 0) {
        n();
        return;
      }
      let i = !1;
      return Promise.all(l.map((r) => r.finished)).then(() => {
        i || on(() => {
          n();
        });
      }).catch(() => {
      }), () => {
        i = !0;
      };
    }
  }, [
    t,
    e,
    n
  ]);
}
const Fo = typeof Element < "u" && "checkVisibility" in Element.prototype;
function Io(t) {
  const e = le(t);
  if (!(t instanceof e.HTMLElement) && !(t instanceof e.SVGElement)) return !1;
  let { display: n, visibility: l } = t.style, i = n !== "none" && l !== "hidden" && l !== "collapse";
  if (i) {
    const { getComputedStyle: r } = t.ownerDocument.defaultView;
    let { display: o, visibility: u } = r(t);
    i = o !== "none" && u !== "hidden" && u !== "collapse";
  }
  return i;
}
function Lo(t, e) {
  return !t.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !t.hasAttribute("data-react-aria-prevent-focus") && (t.nodeName === "DETAILS" && e && e.nodeName !== "SUMMARY" ? t.hasAttribute("open") : !0);
}
function cn(t, e) {
  return Fo ? t.checkVisibility() : t.nodeName !== "#comment" && Io(t) && Lo(t, e) && (!t.parentElement || cn(t.parentElement, t));
}
const dn = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])',
  "permission"
], Mo = dn.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
dn.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const No = dn.join(':not([hidden]):not([tabindex="-1"]),');
function fn(t) {
  return t.matches(Mo) && cn(t) && !Ml(t);
}
function Ro(t) {
  return t.matches(No) && cn(t) && !Ml(t);
}
function Ml(t) {
  let e = t;
  for (; e != null; ) {
    if (e instanceof e.ownerDocument.defaultView.HTMLElement && e.inert) return !0;
    e = e.parentElement;
  }
  return !1;
}
function pn(t, e, n) {
  let [l, i] = W(t || e), r = k(t !== void 0), o = t !== void 0;
  O(() => {
    let c = r.current;
    c !== o && process.env.NODE_ENV !== "production" && console.warn(`WARN: A component changed from ${c ? "controlled" : "uncontrolled"} to ${o ? "controlled" : "uncontrolled"}.`), r.current = o;
  }, [
    o
  ]);
  let u = o ? t : l, s = z((c, ...f) => {
    let d = (p, ...h) => {
      n && (Object.is(u, p) || n(p, ...h)), o || (u = p);
    };
    typeof c == "function" ? (process.env.NODE_ENV !== "production" && console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), i((h, ...b) => {
      let x = c(o ? u : h, ...b);
      return d(x, ...f), o ? h : x;
    })) : (o || i(c), d(c, ...f));
  }, [
    o,
    u,
    n
  ]);
  return [
    u,
    s
  ];
}
function Ge(t, e = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(t, e), n);
}
const Oo = Symbol("default");
function vn({ values: t, children: e }) {
  for (let [n, l] of t)
    e = /* @__PURE__ */ C.createElement(n.Provider, {
      value: l
    }, e);
  return e;
}
function xe(t) {
  let { className: e, style: n, children: l, defaultClassName: i, defaultChildren: r, defaultStyle: o, values: u } = t;
  return V(() => {
    let s, c, f;
    return typeof e == "function" ? s = e({
      ...u,
      defaultClassName: i
    }) : s = e, typeof n == "function" ? c = n({
      ...u,
      defaultStyle: o || {}
    }) : c = n, typeof l == "function" ? f = l({
      ...u,
      defaultChildren: r
    }) : l == null ? f = r : f = l, {
      className: s ?? i,
      style: c || o ? {
        ...o,
        ...c
      } : void 0,
      children: f ?? r,
      "data-rac": ""
    };
  }, [
    e,
    n,
    l,
    i,
    r,
    o,
    u
  ]);
}
function zo(t, e) {
  let n = H(t);
  if (e === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let l = e || Oo;
    if (!n.slots[l]) {
      let i = new Intl.ListFormat().format(Object.keys(n.slots).map((o) => `"${o}"`)), r = e ? `Invalid slot "${e}".` : "A slot prop is required.";
      throw new Error(`${r} Valid slot names are ${i}.`);
    }
    return n.slots[l];
  }
  return n;
}
function Be(t, e, n) {
  let l = zo(n, t.slot) || {}, { ref: i, ...r } = l, o = Pt(V(() => Pl(e, i), [
    e,
    i
  ])), u = L(r, t);
  return "style" in r && r.style && "style" in t && t.style && (typeof r.style == "function" || typeof t.style == "function" ? u.style = (s) => {
    let c = typeof r.style == "function" ? r.style(s) : r.style, f = {
      ...s.defaultStyle,
      ...c
    }, d = typeof t.style == "function" ? t.style({
      ...s,
      defaultStyle: f
    }) : t.style;
    return {
      ...f,
      ...d
    };
  } : u.style = {
    ...r.style,
    ...t.style
  }), [
    u,
    o
  ];
}
function Nl(t = !0) {
  let [e, n] = W(t), l = k(!1), i = z((r) => {
    l.current = !0, n(!!r);
  }, []);
  return Z(() => {
    l.current || n(!1);
  }, []), [
    i,
    e
  ];
}
class hn {
  get childNodes() {
    throw new Error("childNodes is not supported");
  }
  clone() {
    let e = new hn(this.type, this.key);
    return e.value = this.value, e.level = this.level, e.hasChildNodes = this.hasChildNodes, e.rendered = this.rendered, e.textValue = this.textValue, e["aria-label"] = this["aria-label"], e.index = this.index, e.parentKey = this.parentKey, e.prevKey = this.prevKey, e.nextKey = this.nextKey, e.firstChildKey = this.firstChildKey, e.lastChildKey = this.lastChildKey, e.props = this.props, e.render = this.render, e.colSpan = this.colSpan, e.colIndex = this.colIndex, e;
  }
  constructor(e, n) {
    this.value = null, this.level = 0, this.hasChildNodes = !1, this.rendered = null, this.textValue = "", this["aria-label"] = void 0, this.index = 0, this.parentKey = null, this.prevKey = null, this.nextKey = null, this.firstChildKey = null, this.lastChildKey = null, this.props = {}, this.colSpan = null, this.colIndex = null, this.type = e, this.key = n;
  }
}
class bn {
  get size() {
    return this.itemCount;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  *[Symbol.iterator]() {
    let e = this.firstKey != null ? this.keyMap.get(this.firstKey) : void 0;
    for (; e; )
      yield e, e = e.nextKey != null ? this.keyMap.get(e.nextKey) : void 0;
  }
  getChildren(e) {
    let n = this.keyMap;
    return {
      *[Symbol.iterator]() {
        let l = n.get(e), i = l?.firstChildKey != null ? n.get(l.firstChildKey) : null;
        for (; i; )
          yield i, i = i.nextKey != null ? n.get(i.nextKey) : void 0;
      }
    };
  }
  getKeyBefore(e) {
    let n = this.keyMap.get(e);
    if (!n) return null;
    if (n.prevKey != null) {
      for (n = this.keyMap.get(n.prevKey); n && n.type !== "item" && n.lastChildKey != null; ) n = this.keyMap.get(n.lastChildKey);
      var l;
      return (l = n?.key) !== null && l !== void 0 ? l : null;
    }
    return n.parentKey;
  }
  getKeyAfter(e) {
    let n = this.keyMap.get(e);
    if (!n) return null;
    if (n.type !== "item" && n.firstChildKey != null) return n.firstChildKey;
    for (; n; ) {
      if (n.nextKey != null) return n.nextKey;
      if (n.parentKey != null) n = this.keyMap.get(n.parentKey);
      else return null;
    }
    return null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    let e = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
    for (; e?.lastChildKey != null; ) e = this.keyMap.get(e.lastChildKey);
    var n;
    return (n = e?.key) !== null && n !== void 0 ? n : null;
  }
  getItem(e) {
    var n;
    return (n = this.keyMap.get(e)) !== null && n !== void 0 ? n : null;
  }
  at() {
    throw new Error("Not implemented");
  }
  clone() {
    let e = this.constructor, n = new e();
    return n.keyMap = new Map(this.keyMap), n.firstKey = this.firstKey, n.lastKey = this.lastKey, n.itemCount = this.itemCount, n;
  }
  addNode(e) {
    if (this.frozen) throw new Error("Cannot add a node to a frozen collection");
    e.type === "item" && this.keyMap.get(e.key) == null && this.itemCount++, this.keyMap.set(e.key, e);
  }
  removeNode(e) {
    if (this.frozen) throw new Error("Cannot remove a node to a frozen collection");
    let n = this.keyMap.get(e);
    n != null && n.type === "item" && this.itemCount--, this.keyMap.delete(e);
  }
  commit(e, n, l = !1) {
    if (this.frozen) throw new Error("Cannot commit a frozen collection");
    this.firstKey = e, this.lastKey = n, this.frozen = !l;
  }
  // TODO: this is pretty specific to menu, will need to check if it is generic enough
  // Will need to handle varying levels I assume but will revisit after I get searchable menu working for base menu
  // TODO: an alternative is to simply walk the collection and add all item nodes that match the filter and any sections/separators we encounter
  // to an array, then walk that new array and fix all the next/Prev keys while adding them to the new collection
  UNSTABLE_filter(e) {
    let n = new bn(), l = null;
    for (let i of this)
      if (i.type === "section" && i.hasChildNodes) {
        let r = i.clone(), o = null;
        for (let u of this.getChildren(i.key)) if (In(u, e, this, n)) {
          let s = u.clone();
          o == null && (r.firstChildKey = s.key), n.firstKey == null && (n.firstKey = r.key), o && o.parentKey === s.parentKey ? (o.nextKey = s.key, s.prevKey = o.key) : s.prevKey = null, s.nextKey = null, n.addNode(s), o = s;
        }
        o && (o.type !== "header" ? (r.lastChildKey = o.key, l == null ? r.prevKey = null : (l.type === "section" || l.type === "separator") && (l.nextKey = r.key, r.prevKey = l.key), r.nextKey = null, l = r, n.addNode(r)) : (n.firstKey === r.key && (n.firstKey = null), n.removeNode(o.key)));
      } else if (i.type === "separator") {
        let r = i.clone();
        r.nextKey = null, l?.type === "section" && (l.nextKey = r.key, r.prevKey = l.key, l = r, n.addNode(r));
      } else {
        let r = i.clone();
        In(r, e, this, n) && (n.firstKey == null && (n.firstKey = r.key), l != null && l.type !== "section" && l.type !== "separator" && l.parentKey === r.parentKey ? (l.nextKey = r.key, r.prevKey = l.key) : r.prevKey = null, r.nextKey = null, n.addNode(r), l = r);
      }
    if (l?.type === "separator" && l.nextKey === null) {
      let i;
      l.prevKey != null && (i = n.getItem(l.prevKey), i.nextKey = null), n.removeNode(l.key), l = i;
    }
    return n.lastKey = l?.key || null, n;
  }
  constructor() {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.frozen = !1, this.itemCount = 0;
  }
}
function In(t, e, n, l) {
  if (t.type === "subdialogtrigger" || t.type === "submenutrigger") {
    let i = [
      ...n.getChildren(t.key)
    ][0];
    if (i && e(i.textValue)) {
      let r = i.clone();
      return l.addNode(r), !0;
    } else return !1;
  } else return t.type === "header" ? !0 : e(t.textValue);
}
class Rl {
  *[Symbol.iterator]() {
    let e = this.firstChild;
    for (; e; )
      yield e, e = e.nextSibling;
  }
  get firstChild() {
    return this._firstChild;
  }
  set firstChild(e) {
    this._firstChild = e, this.ownerDocument.markDirty(this);
  }
  get lastChild() {
    return this._lastChild;
  }
  set lastChild(e) {
    this._lastChild = e, this.ownerDocument.markDirty(this);
  }
  get previousSibling() {
    return this._previousSibling;
  }
  set previousSibling(e) {
    this._previousSibling = e, this.ownerDocument.markDirty(this);
  }
  get nextSibling() {
    return this._nextSibling;
  }
  set nextSibling(e) {
    this._nextSibling = e, this.ownerDocument.markDirty(this);
  }
  get parentNode() {
    return this._parentNode;
  }
  set parentNode(e) {
    this._parentNode = e, this.ownerDocument.markDirty(this);
  }
  get isConnected() {
    var e;
    return ((e = this.parentNode) === null || e === void 0 ? void 0 : e.isConnected) || !1;
  }
  invalidateChildIndices(e) {
    (this._minInvalidChildIndex == null || !this._minInvalidChildIndex.isConnected || e.index < this._minInvalidChildIndex.index) && (this._minInvalidChildIndex = e, this.ownerDocument.markDirty(this));
  }
  updateChildIndices() {
    let e = this._minInvalidChildIndex;
    for (; e; )
      e.index = e.previousSibling ? e.previousSibling.index + 1 : 0, e = e.nextSibling;
    this._minInvalidChildIndex = null;
  }
  appendChild(e) {
    e.parentNode && e.parentNode.removeChild(e), this.firstChild == null && (this.firstChild = e), this.lastChild ? (this.lastChild.nextSibling = e, e.index = this.lastChild.index + 1, e.previousSibling = this.lastChild) : (e.previousSibling = null, e.index = 0), e.parentNode = this, e.nextSibling = null, this.lastChild = e, this.ownerDocument.markDirty(this), this.isConnected && this.ownerDocument.queueUpdate();
  }
  insertBefore(e, n) {
    if (n == null) return this.appendChild(e);
    e.parentNode && e.parentNode.removeChild(e), e.nextSibling = n, e.previousSibling = n.previousSibling, e.index = n.index - 1, this.firstChild === n ? this.firstChild = e : n.previousSibling && (n.previousSibling.nextSibling = e), n.previousSibling = e, e.parentNode = n.parentNode, this.invalidateChildIndices(e), this.isConnected && this.ownerDocument.queueUpdate();
  }
  removeChild(e) {
    e.parentNode !== this || !this.ownerDocument.isMounted || (this._minInvalidChildIndex === e && (this._minInvalidChildIndex = null), e.nextSibling && (this.invalidateChildIndices(e.nextSibling), e.nextSibling.previousSibling = e.previousSibling), e.previousSibling && (e.previousSibling.nextSibling = e.nextSibling), this.firstChild === e && (this.firstChild = e.nextSibling), this.lastChild === e && (this.lastChild = e.previousSibling), e.parentNode = null, e.nextSibling = null, e.previousSibling = null, e.index = 0, this.ownerDocument.markDirty(e), this.isConnected && this.ownerDocument.queueUpdate());
  }
  addEventListener() {
  }
  removeEventListener() {
  }
  get previousVisibleSibling() {
    let e = this.previousSibling;
    for (; e && e.isHidden; ) e = e.previousSibling;
    return e;
  }
  get nextVisibleSibling() {
    let e = this.nextSibling;
    for (; e && e.isHidden; ) e = e.nextSibling;
    return e;
  }
  get firstVisibleChild() {
    let e = this.firstChild;
    for (; e && e.isHidden; ) e = e.nextSibling;
    return e;
  }
  get lastVisibleChild() {
    let e = this.lastChild;
    for (; e && e.isHidden; ) e = e.previousSibling;
    return e;
  }
  constructor(e) {
    this._firstChild = null, this._lastChild = null, this._previousSibling = null, this._nextSibling = null, this._parentNode = null, this._minInvalidChildIndex = null, this.ownerDocument = e;
  }
}
class Ne extends Rl {
  get index() {
    return this._index;
  }
  set index(e) {
    this._index = e, this.ownerDocument.markDirty(this);
  }
  get level() {
    return this.parentNode instanceof Ne ? this.parentNode.level + (this.node.type === "item" ? 1 : 0) : 0;
  }
  /**
  * Lazily gets a mutable instance of a Node. If the node has already
  * been cloned during this update cycle, it just returns the existing one.
  */
  getMutableNode() {
    return this.isMutated || (this.node = this.node.clone(), this.isMutated = !0), this.ownerDocument.markDirty(this), this.node;
  }
  updateNode() {
    var e, n, l;
    let i = this.nextVisibleSibling, r = this.getMutableNode();
    r.index = this.index, r.level = this.level, r.parentKey = this.parentNode instanceof Ne ? this.parentNode.node.key : null;
    var o;
    r.prevKey = (o = (e = this.previousVisibleSibling) === null || e === void 0 ? void 0 : e.node.key) !== null && o !== void 0 ? o : null;
    var u;
    r.nextKey = (u = i?.node.key) !== null && u !== void 0 ? u : null, r.hasChildNodes = !!this.firstChild;
    var s;
    r.firstChildKey = (s = (n = this.firstVisibleChild) === null || n === void 0 ? void 0 : n.node.key) !== null && s !== void 0 ? s : null;
    var c;
    if (r.lastChildKey = (c = (l = this.lastVisibleChild) === null || l === void 0 ? void 0 : l.node.key) !== null && c !== void 0 ? c : null, (r.colSpan != null || r.colIndex != null) && i) {
      var f, d;
      let p = ((f = r.colIndex) !== null && f !== void 0 ? f : r.index) + ((d = r.colSpan) !== null && d !== void 0 ? d : 1);
      if (p !== i.node.colIndex) {
        let h = i.getMutableNode();
        h.colIndex = p;
      }
    }
  }
  setProps(e, n, l, i) {
    let r = this.getMutableNode(), { value: o, textValue: u, id: s, ...c } = e;
    if (c.ref = n, r.props = c, r.rendered = l, r.render = i, r.value = o, r.textValue = u || (typeof c.children == "string" ? c.children : "") || e["aria-label"] || "", s != null && s !== r.key) {
      if (this.hasSetProps) throw new Error("Cannot change the id of an item");
      r.key = s;
    }
    c.colSpan != null && (r.colSpan = c.colSpan), this.hasSetProps = !0, this.isConnected && this.ownerDocument.queueUpdate();
  }
  get style() {
    let e = this;
    return {
      get display() {
        return e.isHidden ? "none" : "";
      },
      set display(n) {
        let l = n === "none";
        if (e.isHidden !== l) {
          var i, r;
          (((i = e.parentNode) === null || i === void 0 ? void 0 : i.firstVisibleChild) === e || ((r = e.parentNode) === null || r === void 0 ? void 0 : r.lastVisibleChild) === e) && e.ownerDocument.markDirty(e.parentNode);
          let o = e.previousVisibleSibling, u = e.nextVisibleSibling;
          o && e.ownerDocument.markDirty(o), u && e.ownerDocument.markDirty(u), e.isHidden = l, e.ownerDocument.markDirty(e);
        }
      }
    };
  }
  hasAttribute() {
  }
  setAttribute() {
  }
  setAttributeNS() {
  }
  removeAttribute() {
  }
  constructor(e, n) {
    super(n), this.nodeType = 8, this.isMutated = !0, this._index = 0, this.hasSetProps = !1, this.isHidden = !1, this.node = new hn(e, `react-aria-${++n.nodeId}`);
  }
}
class Ho extends Rl {
  get isConnected() {
    return this.isMounted;
  }
  createElement(e) {
    return new Ne(e, this);
  }
  getMutableCollection() {
    return this.nextCollection || (this.nextCollection = this.collection.clone()), this.nextCollection;
  }
  markDirty(e) {
    this.dirtyNodes.add(e);
  }
  addNode(e) {
    if (e.isHidden) return;
    let n = this.getMutableCollection();
    if (!n.getItem(e.node.key)) for (let l of e) this.addNode(l);
    n.addNode(e.node);
  }
  removeNode(e) {
    for (let l of e) this.removeNode(l);
    this.getMutableCollection().removeNode(e.node.key);
  }
  /** Finalizes the collection update, updating all nodes and freezing the collection. */
  getCollection() {
    return this.inSubscription ? this.collection.clone() : (this.queuedRender = !1, this.updateCollection(), this.collection);
  }
  updateCollection() {
    for (let r of this.dirtyNodes) r instanceof Ne && (!r.isConnected || r.isHidden) ? this.removeNode(r) : r.updateChildIndices();
    for (let r of this.dirtyNodes) r instanceof Ne && (r.isConnected && !r.isHidden && (r.updateNode(), this.addNode(r)), r.isMutated = !1);
    if (this.dirtyNodes.clear(), this.nextCollection) {
      var e, n, l, i;
      this.nextCollection.commit((l = (e = this.firstVisibleChild) === null || e === void 0 ? void 0 : e.node.key) !== null && l !== void 0 ? l : null, (i = (n = this.lastVisibleChild) === null || n === void 0 ? void 0 : n.node.key) !== null && i !== void 0 ? i : null, this.isSSR), this.isSSR || (this.collection = this.nextCollection, this.nextCollection = null);
    }
  }
  queueUpdate() {
    if (!(this.dirtyNodes.size === 0 || this.queuedRender)) {
      this.queuedRender = !0, this.inSubscription = !0;
      for (let e of this.subscriptions) e();
      this.inSubscription = !1;
    }
  }
  subscribe(e) {
    return this.subscriptions.add(e), () => this.subscriptions.delete(e);
  }
  resetAfterSSR() {
    this.isSSR && (this.isSSR = !1, this.firstChild = null, this.lastChild = null, this.nodeId = 0);
  }
  constructor(e) {
    super(null), this.nodeType = 11, this.ownerDocument = this, this.dirtyNodes = /* @__PURE__ */ new Set(), this.isSSR = !1, this.nodeId = 0, this.nodesByProps = /* @__PURE__ */ new WeakMap(), this.isMounted = !0, this.nextCollection = null, this.subscriptions = /* @__PURE__ */ new Set(), this.queuedRender = !1, this.inSubscription = !1, this.collection = e, this.nextCollection = e;
  }
}
function Ol(t) {
  let { children: e, items: n, idScope: l, addIdAndValue: i, dependencies: r = [] } = t, o = V(() => /* @__PURE__ */ new WeakMap(), r);
  return V(() => {
    if (n && typeof e == "function") {
      let c = [];
      for (let f of n) {
        let d = o.get(f);
        if (!d) {
          d = e(f);
          var u, s;
          let p = (s = (u = d.props.id) !== null && u !== void 0 ? u : f.key) !== null && s !== void 0 ? s : f.id;
          if (p == null) throw new Error("Could not determine key for item");
          l && (p = l + ":" + p), d = xl(d, i ? {
            key: p,
            id: p,
            value: f
          } : {
            key: p
          }), o.set(f, d);
        }
        c.push(d);
      }
      return c;
    } else if (typeof e != "function") return e;
  }, [
    e,
    n,
    o,
    l,
    i
  ]);
}
if (typeof HTMLTemplateElement < "u") {
  const t = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : t.call(this);
    }
  });
}
const qt = /* @__PURE__ */ Y(!1);
function Vo(t) {
  if (H(qt))
    return /* @__PURE__ */ C.createElement(C.Fragment, null, t.children);
  let n = /* @__PURE__ */ C.createElement(qt.Provider, {
    value: !0
  }, t.children);
  return /* @__PURE__ */ C.createElement("template", {
    "data-react-aria-hidden": !0
  }, n);
}
function jo(t) {
  let e = (n, l) => H(qt) ? null : t(n, l);
  return e.displayName = t.displayName || t.name, ve(e);
}
function $n(t) {
  let e = t;
  return e.nativeEvent = t, e.isDefaultPrevented = () => e.defaultPrevented, e.isPropagationStopped = () => e.cancelBubble, e.persist = () => {
  }, e;
}
function zl(t, e) {
  Object.defineProperty(t, "target", {
    value: e
  }), Object.defineProperty(t, "currentTarget", {
    value: e
  });
}
function Hl(t) {
  let e = k({
    isFocused: !1,
    observer: null
  });
  Z(() => {
    const l = e.current;
    return () => {
      l.observer && (l.observer.disconnect(), l.observer = null);
    };
  }, []);
  let n = ne((l) => {
    t?.(l);
  });
  return z((l) => {
    if (l.target instanceof HTMLButtonElement || l.target instanceof HTMLInputElement || l.target instanceof HTMLTextAreaElement || l.target instanceof HTMLSelectElement) {
      e.current.isFocused = !0;
      let i = l.target, r = (o) => {
        if (e.current.isFocused = !1, i.disabled) {
          let u = $n(o);
          n(u);
        }
        e.current.observer && (e.current.observer.disconnect(), e.current.observer = null);
      };
      i.addEventListener("focusout", r, {
        once: !0
      }), e.current.observer = new MutationObserver(() => {
        if (e.current.isFocused && i.disabled) {
          var o;
          (o = e.current.observer) === null || o === void 0 || o.disconnect();
          let u = i === document.activeElement ? null : document.activeElement;
          i.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: u
          })), i.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: u
          }));
        }
      }), e.current.observer.observe(i, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
let ft = !1;
function Ln(t) {
  for (; t && !fn(t); ) t = t.parentElement;
  let e = le(t), n = e.document.activeElement;
  if (!n || n === t) return;
  ft = !0;
  let l = !1, i = (f) => {
    (f.target === n || l) && f.stopImmediatePropagation();
  }, r = (f) => {
    (f.target === n || l) && (f.stopImmediatePropagation(), !t && !l && (l = !0, pe(n), s()));
  }, o = (f) => {
    (f.target === t || l) && f.stopImmediatePropagation();
  }, u = (f) => {
    (f.target === t || l) && (f.stopImmediatePropagation(), l || (l = !0, pe(n), s()));
  };
  e.addEventListener("blur", i, !0), e.addEventListener("focusout", r, !0), e.addEventListener("focusin", u, !0), e.addEventListener("focus", o, !0);
  let s = () => {
    cancelAnimationFrame(c), e.removeEventListener("blur", i, !0), e.removeEventListener("focusout", r, !0), e.removeEventListener("focusin", u, !0), e.removeEventListener("focus", o, !0), ft = !1, l = !1;
  }, c = requestAnimationFrame(s);
  return s;
}
let Le = "default", Yt = "", at = /* @__PURE__ */ new WeakMap();
function Mn(t) {
  if (sn()) {
    if (Le === "default") {
      const e = X(t);
      Yt = e.documentElement.style.webkitUserSelect, e.documentElement.style.webkitUserSelect = "none";
    }
    Le = "disabled";
  } else if (t instanceof HTMLElement || t instanceof SVGElement) {
    let e = "userSelect" in t.style ? "userSelect" : "webkitUserSelect";
    at.set(t, t.style[e]), t.style[e] = "none";
  }
}
function Mt(t) {
  if (sn()) {
    if (Le !== "disabled") return;
    Le = "restoring", setTimeout(() => {
      Al(() => {
        if (Le === "restoring") {
          const e = X(t);
          e.documentElement.style.webkitUserSelect === "none" && (e.documentElement.style.webkitUserSelect = Yt || ""), Yt = "", Le = "default";
        }
      });
    }, 300);
  } else if ((t instanceof HTMLElement || t instanceof SVGElement) && t && at.has(t)) {
    let e = at.get(t), n = "userSelect" in t.style ? "userSelect" : "webkitUserSelect";
    t.style[n] === "none" && (t.style[n] = e), t.getAttribute("style") === "" && t.removeAttribute("style"), at.delete(t);
  }
}
const Vl = C.createContext({
  register: () => {
  }
});
Vl.displayName = "PressResponderContext";
function Uo(t, e) {
  return e.get ? e.get.call(t) : e.value;
}
function jl(t, e, n) {
  if (!e.has(t)) throw new TypeError("attempted to " + n + " private field on non-instance");
  return e.get(t);
}
function Wo(t, e) {
  var n = jl(t, e, "get");
  return Uo(t, n);
}
function _o(t, e) {
  if (e.has(t))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Go(t, e, n) {
  _o(t, e), e.set(t, n);
}
function qo(t, e, n) {
  if (e.set) e.set.call(t, n);
  else {
    if (!e.writable)
      throw new TypeError("attempted to set read only private field");
    e.value = n;
  }
}
function Nn(t, e, n) {
  var l = jl(t, e, "set");
  return qo(t, l, n), n;
}
function Yo(t) {
  let e = H(Vl);
  if (e) {
    let { register: n, ...l } = e;
    t = L(l, t), n();
  }
  return Fl(e, t.ref), t;
}
var it = /* @__PURE__ */ new WeakMap();
class rt {
  continuePropagation() {
    Nn(this, it, !1);
  }
  get shouldStopPropagation() {
    return Wo(this, it);
  }
  constructor(e, n, l, i) {
    Go(this, it, {
      writable: !0,
      value: void 0
    }), Nn(this, it, !0);
    var r;
    let o = (r = i?.target) !== null && r !== void 0 ? r : l.currentTarget;
    const u = o?.getBoundingClientRect();
    let s, c = 0, f, d = null;
    l.clientX != null && l.clientY != null && (f = l.clientX, d = l.clientY), u && (f != null && d != null ? (s = f - u.left, c = d - u.top) : (s = u.width / 2, c = u.height / 2)), this.type = e, this.pointerType = n, this.target = l.currentTarget, this.shiftKey = l.shiftKey, this.metaKey = l.metaKey, this.ctrlKey = l.ctrlKey, this.altKey = l.altKey, this.x = s, this.y = c;
  }
}
const Rn = Symbol("linkClicked"), On = "react-aria-pressable-style", zn = "data-react-aria-pressable";
function Ct(t) {
  let { onPress: e, onPressChange: n, onPressStart: l, onPressEnd: i, onPressUp: r, onClick: o, isDisabled: u, isPressed: s, preventFocusOnPress: c, shouldCancelOnPointerExit: f, allowTextSelectionOnPress: d, ref: p, ...h } = Yo(t), [b, x] = W(!1), m = k({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null,
    disposables: []
  }), { addGlobalListener: g, removeAllGlobalListeners: E } = St(), T = ne((a, w) => {
    let I = m.current;
    if (u || I.didFirePressStart) return !1;
    let P = !0;
    if (I.isTriggeringEvent = !0, l) {
      let D = new rt("pressstart", w, a);
      l(D), P = D.shouldStopPropagation;
    }
    return n && n(!0), I.isTriggeringEvent = !1, I.didFirePressStart = !0, x(!0), P;
  }), K = ne((a, w, I = !0) => {
    let P = m.current;
    if (!P.didFirePressStart) return !1;
    P.didFirePressStart = !1, P.isTriggeringEvent = !0;
    let D = !0;
    if (i) {
      let v = new rt("pressend", w, a);
      i(v), D = v.shouldStopPropagation;
    }
    if (n && n(!1), x(!1), e && I && !u) {
      let v = new rt("press", w, a);
      e(v), D && (D = v.shouldStopPropagation);
    }
    return P.isTriggeringEvent = !1, D;
  }), F = ne((a, w) => {
    let I = m.current;
    if (u) return !1;
    if (r) {
      I.isTriggeringEvent = !0;
      let P = new rt("pressup", w, a);
      return r(P), I.isTriggeringEvent = !1, P.shouldStopPropagation;
    }
    return !0;
  }), B = ne((a) => {
    let w = m.current;
    if (w.isPressed && w.target) {
      w.didFirePressStart && w.pointerType != null && K(Pe(w.target, a), w.pointerType, !1), w.isPressed = !1, w.isOverTarget = !1, w.activePointerId = null, w.pointerType = null, E(), d || Mt(w.target);
      for (let I of w.disposables) I();
      w.disposables = [];
    }
  }), N = ne((a) => {
    f && B(a);
  }), R = ne((a) => {
    o?.(a);
  }), G = ne((a, w) => {
    if (o) {
      let I = new MouseEvent("click", a);
      zl(I, w), o($n(I));
    }
  }), M = V(() => {
    let a = m.current, w = {
      onKeyDown(P) {
        if (Nt(P.nativeEvent, P.currentTarget) && _(P.currentTarget, U(P.nativeEvent))) {
          var D;
          jn(U(P.nativeEvent), P.key) && P.preventDefault();
          let v = !0;
          if (!a.isPressed && !P.repeat) {
            a.target = P.currentTarget, a.isPressed = !0, a.pointerType = "keyboard", v = T(P, "keyboard");
            let $ = P.currentTarget, S = (y) => {
              Nt(y, $) && !y.repeat && _($, U(y)) && a.target && F(Pe(a.target, y), "keyboard");
            };
            g(X(P.currentTarget), "keyup", Xe(S, I), !0);
          }
          v && P.stopPropagation(), P.metaKey && ke() && ((D = a.metaKeyEvents) === null || D === void 0 || D.set(P.key, P.nativeEvent));
        } else P.key === "Meta" && (a.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(P) {
        if (!(P && !_(P.currentTarget, U(P.nativeEvent))) && P && P.button === 0 && !a.isTriggeringEvent && !ye.isOpening) {
          let D = !0;
          if (u && P.preventDefault(), !a.ignoreEmulatedMouseEvents && !a.isPressed && (a.pointerType === "virtual" || Gt(P.nativeEvent))) {
            let v = T(P, "virtual"), $ = F(P, "virtual"), S = K(P, "virtual");
            R(P), D = v && $ && S;
          } else if (a.isPressed && a.pointerType !== "keyboard") {
            let v = a.pointerType || P.nativeEvent.pointerType || "virtual", $ = F(Pe(P.currentTarget, P), v), S = K(Pe(P.currentTarget, P), v, !0);
            D = $ && S, a.isOverTarget = !1, R(P), B(P);
          }
          a.ignoreEmulatedMouseEvents = !1, D && P.stopPropagation();
        }
      }
    }, I = (P) => {
      var D;
      if (a.isPressed && a.target && Nt(P, a.target)) {
        var v;
        jn(U(P), P.key) && P.preventDefault();
        let S = U(P), y = _(a.target, U(P));
        K(Pe(a.target, P), "keyboard", y), y && G(P, a.target), E(), P.key !== "Enter" && mn(a.target) && _(a.target, S) && !P[Rn] && (P[Rn] = !0, ye(a.target, P, !1)), a.isPressed = !1, (v = a.metaKeyEvents) === null || v === void 0 || v.delete(P.key);
      } else if (P.key === "Meta" && (!((D = a.metaKeyEvents) === null || D === void 0) && D.size)) {
        var $;
        let S = a.metaKeyEvents;
        a.metaKeyEvents = void 0;
        for (let y of S.values()) ($ = a.target) === null || $ === void 0 || $.dispatchEvent(new KeyboardEvent("keyup", y));
      }
    };
    if (typeof PointerEvent < "u") {
      w.onPointerDown = (v) => {
        if (v.button !== 0 || !_(v.currentTarget, U(v.nativeEvent))) return;
        if (wo(v.nativeEvent)) {
          a.pointerType = "virtual";
          return;
        }
        a.pointerType = v.pointerType;
        let $ = !0;
        if (!a.isPressed) {
          a.isPressed = !0, a.isOverTarget = !0, a.activePointerId = v.pointerId, a.target = v.currentTarget, d || Mn(a.target), $ = T(v, a.pointerType);
          let S = U(v.nativeEvent);
          "releasePointerCapture" in S && S.releasePointerCapture(v.pointerId), g(X(v.currentTarget), "pointerup", P, !1), g(X(v.currentTarget), "pointercancel", D, !1);
        }
        $ && v.stopPropagation();
      }, w.onMouseDown = (v) => {
        if (_(v.currentTarget, U(v.nativeEvent)) && v.button === 0) {
          if (c) {
            let $ = Ln(v.target);
            $ && a.disposables.push($);
          }
          v.stopPropagation();
        }
      }, w.onPointerUp = (v) => {
        !_(v.currentTarget, U(v.nativeEvent)) || a.pointerType === "virtual" || v.button === 0 && !a.isPressed && F(v, a.pointerType || v.pointerType);
      }, w.onPointerEnter = (v) => {
        v.pointerId === a.activePointerId && a.target && !a.isOverTarget && a.pointerType != null && (a.isOverTarget = !0, T(Pe(a.target, v), a.pointerType));
      }, w.onPointerLeave = (v) => {
        v.pointerId === a.activePointerId && a.target && a.isOverTarget && a.pointerType != null && (a.isOverTarget = !1, K(Pe(a.target, v), a.pointerType, !1), N(v));
      };
      let P = (v) => {
        if (v.pointerId === a.activePointerId && a.isPressed && v.button === 0 && a.target) {
          if (_(a.target, U(v)) && a.pointerType != null) {
            let $ = !1, S = setTimeout(() => {
              a.isPressed && a.target instanceof HTMLElement && ($ ? B(v) : (pe(a.target), a.target.click()));
            }, 80);
            g(v.currentTarget, "click", () => $ = !0, !0), a.disposables.push(() => clearTimeout(S));
          } else B(v);
          a.isOverTarget = !1;
        }
      }, D = (v) => {
        B(v);
      };
      w.onDragStart = (v) => {
        _(v.currentTarget, U(v.nativeEvent)) && B(v);
      };
    } else if (process.env.NODE_ENV === "test") {
      w.onMouseDown = (v) => {
        if (v.button !== 0 || !_(v.currentTarget, U(v.nativeEvent))) return;
        if (a.ignoreEmulatedMouseEvents) {
          v.stopPropagation();
          return;
        }
        if (a.isPressed = !0, a.isOverTarget = !0, a.target = v.currentTarget, a.pointerType = Gt(v.nativeEvent) ? "virtual" : "mouse", on(() => T(v, a.pointerType)) && v.stopPropagation(), c) {
          let S = Ln(v.target);
          S && a.disposables.push(S);
        }
        g(X(v.currentTarget), "mouseup", P, !1);
      }, w.onMouseEnter = (v) => {
        if (!_(v.currentTarget, U(v.nativeEvent))) return;
        let $ = !0;
        a.isPressed && !a.ignoreEmulatedMouseEvents && a.pointerType != null && (a.isOverTarget = !0, $ = T(v, a.pointerType)), $ && v.stopPropagation();
      }, w.onMouseLeave = (v) => {
        if (!_(v.currentTarget, U(v.nativeEvent))) return;
        let $ = !0;
        a.isPressed && !a.ignoreEmulatedMouseEvents && a.pointerType != null && (a.isOverTarget = !1, $ = K(v, a.pointerType, !1), N(v)), $ && v.stopPropagation();
      }, w.onMouseUp = (v) => {
        _(v.currentTarget, U(v.nativeEvent)) && !a.ignoreEmulatedMouseEvents && v.button === 0 && !a.isPressed && F(v, a.pointerType || "mouse");
      };
      let P = (v) => {
        if (v.button === 0) {
          if (a.ignoreEmulatedMouseEvents) {
            a.ignoreEmulatedMouseEvents = !1;
            return;
          }
          a.target && a.target.contains(v.target) && a.pointerType != null || B(v), a.isOverTarget = !1;
        }
      };
      w.onTouchStart = (v) => {
        if (!_(v.currentTarget, U(v.nativeEvent))) return;
        let $ = Xo(v.nativeEvent);
        if (!$) return;
        a.activePointerId = $.identifier, a.ignoreEmulatedMouseEvents = !0, a.isOverTarget = !0, a.isPressed = !0, a.target = v.currentTarget, a.pointerType = "touch", d || Mn(a.target), T(be(a.target, v), a.pointerType) && v.stopPropagation(), g(le(v.currentTarget), "scroll", D, !0);
      }, w.onTouchMove = (v) => {
        if (!_(v.currentTarget, U(v.nativeEvent))) return;
        if (!a.isPressed) {
          v.stopPropagation();
          return;
        }
        let $ = Hn(v.nativeEvent, a.activePointerId), S = !0;
        $ && Vn($, v.currentTarget) ? !a.isOverTarget && a.pointerType != null && (a.isOverTarget = !0, S = T(be(a.target, v), a.pointerType)) : a.isOverTarget && a.pointerType != null && (a.isOverTarget = !1, S = K(be(a.target, v), a.pointerType, !1), N(be(a.target, v))), S && v.stopPropagation();
      }, w.onTouchEnd = (v) => {
        if (!_(v.currentTarget, U(v.nativeEvent))) return;
        if (!a.isPressed) {
          v.stopPropagation();
          return;
        }
        let $ = Hn(v.nativeEvent, a.activePointerId), S = !0;
        $ && Vn($, v.currentTarget) && a.pointerType != null ? (F(be(a.target, v), a.pointerType), S = K(be(a.target, v), a.pointerType), G(v.nativeEvent, a.target)) : a.isOverTarget && a.pointerType != null && (S = K(be(a.target, v), a.pointerType, !1)), S && v.stopPropagation(), a.isPressed = !1, a.activePointerId = null, a.isOverTarget = !1, a.ignoreEmulatedMouseEvents = !0, a.target && !d && Mt(a.target), E();
      }, w.onTouchCancel = (v) => {
        _(v.currentTarget, U(v.nativeEvent)) && (v.stopPropagation(), a.isPressed && B(be(a.target, v)));
      };
      let D = (v) => {
        a.isPressed && _(U(v), a.target) && B({
          currentTarget: a.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      w.onDragStart = (v) => {
        _(v.currentTarget, U(v.nativeEvent)) && B(v);
      };
    }
    return w;
  }, [
    g,
    u,
    c,
    E,
    d,
    B,
    N,
    K,
    T,
    F,
    R,
    G
  ]);
  return O(() => {
    if (!p || process.env.NODE_ENV === "test") return;
    const a = X(p.current);
    if (!a || !a.head || a.getElementById(On)) return;
    const w = a.createElement("style");
    w.id = On, w.textContent = `
@layer {
  [${zn}] {
    touch-action: pan-x pan-y pinch-zoom;
  }
}
    `.trim(), a.head.prepend(w);
  }, [
    p
  ]), O(() => {
    let a = m.current;
    return () => {
      var w;
      d || Mt((w = a.target) !== null && w !== void 0 ? w : void 0);
      for (let I of a.disposables) I();
      a.disposables = [];
    };
  }, [
    d
  ]), {
    isPressed: s || b,
    pressProps: L(h, M, {
      [zn]: !0
    })
  };
}
function mn(t) {
  return t.tagName === "A" && t.hasAttribute("href");
}
function Nt(t, e) {
  const { key: n, code: l } = t, i = e, r = i.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || l === "Space") && !(i instanceof le(i).HTMLInputElement && !Ul(i, n) || i instanceof le(i).HTMLTextAreaElement || i.isContentEditable) && // Links should only trigger with Enter key
  !((r === "link" || !r && mn(i)) && n !== "Enter");
}
function Xo(t) {
  const { targetTouches: e } = t;
  return e.length > 0 ? e[0] : null;
}
function Hn(t, e) {
  const n = t.changedTouches;
  for (let l = 0; l < n.length; l++) {
    const i = n[l];
    if (i.identifier === e) return i;
  }
  return null;
}
function be(t, e) {
  let n = 0, l = 0;
  return e.targetTouches && e.targetTouches.length === 1 && (n = e.targetTouches[0].clientX, l = e.targetTouches[0].clientY), {
    currentTarget: t,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey,
    clientX: n,
    clientY: l
  };
}
function Pe(t, e) {
  let n = e.clientX, l = e.clientY;
  return {
    currentTarget: t,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey,
    clientX: n,
    clientY: l
  };
}
function Zo(t) {
  let e = 0, n = 0;
  return t.width !== void 0 ? e = t.width / 2 : t.radiusX !== void 0 && (e = t.radiusX), t.height !== void 0 ? n = t.height / 2 : t.radiusY !== void 0 && (n = t.radiusY), {
    top: t.clientY - n,
    right: t.clientX + e,
    bottom: t.clientY + n,
    left: t.clientX - e
  };
}
function Jo(t, e) {
  return !(t.left > e.right || e.left > t.right || t.top > e.bottom || e.top > t.bottom);
}
function Vn(t, e) {
  let n = e.getBoundingClientRect(), l = Zo(t);
  return Jo(n, l);
}
function Qo(t) {
  return t instanceof HTMLInputElement ? !1 : t instanceof HTMLButtonElement ? t.type !== "submit" && t.type !== "reset" : !mn(t);
}
function jn(t, e) {
  return t instanceof HTMLInputElement ? !Ul(t, e) : Qo(t);
}
const eu = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Ul(t, e) {
  return t.type === "checkbox" || t.type === "radio" ? e === " " : eu.has(t.type);
}
let ge = null, qe = /* @__PURE__ */ new Set(), We = /* @__PURE__ */ new Map(), Ke = !1, Xt = !1;
const tu = {
  Tab: !0,
  Escape: !0
};
function yn(t, e) {
  for (let n of qe) n(t, e);
}
function nu(t) {
  return !(t.metaKey || !ke() && t.altKey || t.ctrlKey || t.key === "Control" || t.key === "Shift" || t.key === "Meta");
}
function pt(t) {
  Ke = !0, nu(t) && (ge = "keyboard", yn("keyboard", t));
}
function oe(t) {
  ge = "pointer", (t.type === "mousedown" || t.type === "pointerdown") && (Ke = !0, yn("pointer", t));
}
function Wl(t) {
  Gt(t) && (Ke = !0, ge = "virtual");
}
function _l(t) {
  t.target === window || t.target === document || ft || !t.isTrusted || (!Ke && !Xt && (ge = "virtual", yn("virtual", t)), Ke = !1, Xt = !1);
}
function Gl() {
  ft || (Ke = !1, Xt = !0);
}
function vt(t) {
  if (typeof window > "u" || typeof document > "u" || We.get(le(t))) return;
  const e = le(t), n = X(t);
  let l = e.HTMLElement.prototype.focus;
  e.HTMLElement.prototype.focus = function() {
    Ke = !0, l.apply(this, arguments);
  }, n.addEventListener("keydown", pt, !0), n.addEventListener("keyup", pt, !0), n.addEventListener("click", Wl, !0), e.addEventListener("focus", _l, !0), e.addEventListener("blur", Gl, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", oe, !0), n.addEventListener("pointermove", oe, !0), n.addEventListener("pointerup", oe, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", oe, !0), n.addEventListener("mousemove", oe, !0), n.addEventListener("mouseup", oe, !0)), e.addEventListener("beforeunload", () => {
    ql(t);
  }, {
    once: !0
  }), We.set(e, {
    focus: l
  });
}
const ql = (t, e) => {
  const n = le(t), l = X(t);
  e && l.removeEventListener("DOMContentLoaded", e), We.has(n) && (n.HTMLElement.prototype.focus = We.get(n).focus, l.removeEventListener("keydown", pt, !0), l.removeEventListener("keyup", pt, !0), l.removeEventListener("click", Wl, !0), n.removeEventListener("focus", _l, !0), n.removeEventListener("blur", Gl, !1), typeof PointerEvent < "u" ? (l.removeEventListener("pointerdown", oe, !0), l.removeEventListener("pointermove", oe, !0), l.removeEventListener("pointerup", oe, !0)) : process.env.NODE_ENV === "test" && (l.removeEventListener("mousedown", oe, !0), l.removeEventListener("mousemove", oe, !0), l.removeEventListener("mouseup", oe, !0)), We.delete(n));
};
function lu(t) {
  const e = X(t);
  let n;
  return e.readyState !== "loading" ? vt(t) : (n = () => {
    vt(t);
  }, e.addEventListener("DOMContentLoaded", n)), () => ql(t, n);
}
typeof document < "u" && lu();
function wt() {
  return ge !== "pointer";
}
function ht() {
  return ge;
}
function Yl() {
  vt();
  let [t, e] = W(ge);
  return O(() => {
    let n = () => {
      e(ge);
    };
    return qe.add(n), () => {
      qe.delete(n);
    };
  }, []), Oe() ? null : t;
}
const iu = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function ru(t, e, n) {
  let l = X(n?.target);
  const i = typeof window < "u" ? le(n?.target).HTMLInputElement : HTMLInputElement, r = typeof window < "u" ? le(n?.target).HTMLTextAreaElement : HTMLTextAreaElement, o = typeof window < "u" ? le(n?.target).HTMLElement : HTMLElement, u = typeof window < "u" ? le(n?.target).KeyboardEvent : KeyboardEvent;
  return t = t || l.activeElement instanceof i && !iu.has(l.activeElement.type) || l.activeElement instanceof r || l.activeElement instanceof o && l.activeElement.isContentEditable, !(t && e === "keyboard" && n instanceof u && !tu[n.key]);
}
function ou(t, e, n) {
  vt(), O(() => {
    let l = (i, r) => {
      ru(!!n?.isTextInput, i, r) && t(wt());
    };
    return qe.add(l), () => {
      qe.delete(l);
    };
  }, e);
}
function ue(t) {
  const e = X(t), n = Te(e);
  if (ht() === "virtual") {
    let l = n;
    Al(() => {
      Te(e) === l && t.isConnected && pe(t);
    });
  } else pe(t);
}
function Xl(t) {
  let { isDisabled: e, onFocus: n, onBlur: l, onFocusChange: i } = t;
  const r = z((s) => {
    if (s.target === s.currentTarget)
      return l && l(s), i && i(!1), !0;
  }, [
    l,
    i
  ]), o = Hl(r), u = z((s) => {
    const c = X(s.target), f = c ? Te(c) : Te();
    s.target === s.currentTarget && f === U(s.nativeEvent) && (n && n(s), i && i(!0), o(s));
  }, [
    i,
    n,
    o
  ]);
  return {
    focusProps: {
      onFocus: !e && (n || i || l) ? u : void 0,
      onBlur: !e && (l || i) ? r : void 0
    }
  };
}
function Un(t) {
  if (!t) return;
  let e = !0;
  return (n) => {
    let l = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        e && process.env.NODE_ENV !== "production" ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : e = !0;
      },
      continuePropagation() {
        e = !1;
      },
      isPropagationStopped() {
        return e;
      }
    };
    t(l), e && n.stopPropagation();
  };
}
function uu(t) {
  return {
    keyboardProps: t.isDisabled ? {} : {
      onKeyDown: Un(t.onKeyDown),
      onKeyUp: Un(t.onKeyUp)
    }
  };
}
let bt = /* @__PURE__ */ C.createContext(null);
function su(t) {
  let e = H(bt) || {};
  Fl(e, t);
  let { ref: n, ...l } = e;
  return l;
}
const au = /* @__PURE__ */ C.forwardRef(function(e, n) {
  let { children: l, ...i } = e, r = Pt(n), o = {
    ...i,
    ref: r
  };
  return /* @__PURE__ */ C.createElement(bt.Provider, {
    value: o
  }, l);
});
function Je(t, e) {
  let { focusProps: n } = Xl(t), { keyboardProps: l } = uu(t), i = L(n, l), r = su(e), o = t.isDisabled ? {} : r, u = k(t.autoFocus);
  O(() => {
    u.current && e.current && ue(e.current), u.current = !1;
  }, [
    e
  ]);
  let s = t.excludeFromTabOrder ? -1 : 0;
  return t.isDisabled && (s = void 0), {
    focusableProps: L({
      ...i,
      tabIndex: s
    }, o)
  };
}
const pa = /* @__PURE__ */ ve(({ children: t, ...e }, n) => {
  n = Pt(n);
  let { focusableProps: l } = Je(e, n), i = C.Children.only(t);
  O(() => {
    if (process.env.NODE_ENV === "production") return;
    let o = n.current;
    if (!o || !(o instanceof le(o).Element)) {
      console.error("<Focusable> child must forward its ref to a DOM element.");
      return;
    }
    if (!e.isDisabled && !fn(o)) {
      console.warn("<Focusable> child must be focusable. Please ensure the tabIndex prop is passed through.");
      return;
    }
    if (o.localName !== "button" && o.localName !== "input" && o.localName !== "select" && o.localName !== "textarea" && o.localName !== "a" && o.localName !== "area" && o.localName !== "summary" && o.localName !== "img" && o.localName !== "svg") {
      let u = o.getAttribute("role");
      u ? (
        // https://w3c.github.io/aria/#widget_roles
        u !== "application" && u !== "button" && u !== "checkbox" && u !== "combobox" && u !== "gridcell" && u !== "link" && u !== "menuitem" && u !== "menuitemcheckbox" && u !== "menuitemradio" && u !== "option" && u !== "radio" && u !== "searchbox" && u !== "separator" && u !== "slider" && u !== "spinbutton" && u !== "switch" && u !== "tab" && u !== "tabpanel" && u !== "textbox" && u !== "treeitem" && // aria-describedby is also announced on these roles
        u !== "img" && u !== "meter" && u !== "progressbar" && console.warn(`<Focusable> child must have an interactive ARIA role. Got "${u}".`)
      ) : console.warn("<Focusable> child must have an interactive ARIA role.");
    }
  }, [
    n,
    e.isDisabled
  ]);
  let r = parseInt(C.version, 10) < 19 ? i.ref : i.props.ref;
  return /* @__PURE__ */ C.cloneElement(i, {
    ...L(l, i.props),
    // @ts-ignore
    ref: Pl(r, n)
  });
});
function gn(t) {
  let { isDisabled: e, onBlurWithin: n, onFocusWithin: l, onFocusWithinChange: i } = t, r = k({
    isFocusWithin: !1
  }), { addGlobalListener: o, removeAllGlobalListeners: u } = St(), s = z((d) => {
    d.currentTarget.contains(d.target) && r.current.isFocusWithin && !d.currentTarget.contains(d.relatedTarget) && (r.current.isFocusWithin = !1, u(), n && n(d), i && i(!1));
  }, [
    n,
    i,
    r,
    u
  ]), c = Hl(s), f = z((d) => {
    if (!d.currentTarget.contains(d.target)) return;
    const p = X(d.target), h = Te(p);
    if (!r.current.isFocusWithin && h === U(d.nativeEvent)) {
      l && l(d), i && i(!0), r.current.isFocusWithin = !0, c(d);
      let b = d.currentTarget;
      o(p, "focus", (x) => {
        if (r.current.isFocusWithin && !_(b, x.target)) {
          let m = new p.defaultView.FocusEvent("blur", {
            relatedTarget: x.target
          });
          zl(m, b);
          let g = $n(m);
          s(g);
        }
      }, {
        capture: !0
      });
    }
  }, [
    l,
    i,
    c,
    o,
    s
  ]);
  return e ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: f,
      onBlur: s
    }
  };
}
let $t = !1, ot = 0;
function Zt() {
  $t = !0, setTimeout(() => {
    $t = !1;
  }, 50);
}
function Wn(t) {
  t.pointerType === "touch" && Zt();
}
function cu() {
  if (!(typeof document > "u"))
    return ot === 0 && (typeof PointerEvent < "u" ? document.addEventListener("pointerup", Wn) : process.env.NODE_ENV === "test" && document.addEventListener("touchend", Zt)), ot++, () => {
      ot--, !(ot > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", Wn) : process.env.NODE_ENV === "test" && document.removeEventListener("touchend", Zt));
    };
}
function ze(t) {
  let { onHoverStart: e, onHoverChange: n, onHoverEnd: l, isDisabled: i } = t, [r, o] = W(!1), u = k({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  O(cu, []);
  let { addGlobalListener: s, removeAllGlobalListeners: c } = St(), { hoverProps: f, triggerHoverEnd: d } = V(() => {
    let p = (x, m) => {
      if (u.pointerType = m, i || m === "touch" || u.isHovered || !x.currentTarget.contains(x.target)) return;
      u.isHovered = !0;
      let g = x.currentTarget;
      u.target = g, s(X(x.target), "pointerover", (E) => {
        u.isHovered && u.target && !_(u.target, E.target) && h(E, E.pointerType);
      }, {
        capture: !0
      }), e && e({
        type: "hoverstart",
        target: g,
        pointerType: m
      }), n && n(!0), o(!0);
    }, h = (x, m) => {
      let g = u.target;
      u.pointerType = "", u.target = null, !(m === "touch" || !u.isHovered || !g) && (u.isHovered = !1, c(), l && l({
        type: "hoverend",
        target: g,
        pointerType: m
      }), n && n(!1), o(!1));
    }, b = {};
    return typeof PointerEvent < "u" ? (b.onPointerEnter = (x) => {
      $t && x.pointerType === "mouse" || p(x, x.pointerType);
    }, b.onPointerLeave = (x) => {
      !i && x.currentTarget.contains(x.target) && h(x, x.pointerType);
    }) : process.env.NODE_ENV === "test" && (b.onTouchStart = () => {
      u.ignoreEmulatedMouseEvents = !0;
    }, b.onMouseEnter = (x) => {
      !u.ignoreEmulatedMouseEvents && !$t && p(x, "mouse"), u.ignoreEmulatedMouseEvents = !1;
    }, b.onMouseLeave = (x) => {
      !i && x.currentTarget.contains(x.target) && h(x, "mouse");
    }), {
      hoverProps: b,
      triggerHoverEnd: h
    };
  }, [
    e,
    n,
    l,
    i,
    u,
    s,
    c
  ]);
  return O(() => {
    i && d({
      currentTarget: u.target
    }, u.pointerType);
  }, [
    i
  ]), {
    hoverProps: f,
    isHovered: r
  };
}
const du = 500;
function fu(t) {
  let { isDisabled: e, onLongPressStart: n, onLongPressEnd: l, onLongPress: i, threshold: r = du, accessibilityDescription: o } = t;
  const u = k(void 0);
  let { addGlobalListener: s, removeGlobalListener: c } = St(), { pressProps: f } = Ct({
    isDisabled: e,
    onPressStart(p) {
      if (p.continuePropagation(), (p.pointerType === "mouse" || p.pointerType === "touch") && (n && n({
        ...p,
        type: "longpressstart"
      }), u.current = setTimeout(() => {
        p.target.dispatchEvent(new PointerEvent("pointercancel", {
          bubbles: !0
        })), X(p.target).activeElement !== p.target && pe(p.target), i && i({
          ...p,
          type: "longpress"
        }), u.current = void 0;
      }, r), p.pointerType === "touch")) {
        let h = (b) => {
          b.preventDefault();
        };
        s(p.target, "contextmenu", h, {
          once: !0
        }), s(window, "pointerup", () => {
          setTimeout(() => {
            c(p.target, "contextmenu", h);
          }, 30);
        }, {
          once: !0
        });
      }
    },
    onPressEnd(p) {
      u.current && clearTimeout(u.current), l && (p.pointerType === "mouse" || p.pointerType === "touch") && l({
        ...p,
        type: "longpressend"
      });
    }
  }), d = an(i && !e ? o : void 0);
  return {
    longPressProps: L(f, d)
  };
}
var ut = { exports: {} }, Rt = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _n;
function pu() {
  if (_n) return Rt;
  _n = 1;
  var t = C;
  function e(d, p) {
    return d === p && (d !== 0 || 1 / d === 1 / p) || d !== d && p !== p;
  }
  var n = typeof Object.is == "function" ? Object.is : e, l = t.useState, i = t.useEffect, r = t.useLayoutEffect, o = t.useDebugValue;
  function u(d, p) {
    var h = p(), b = l({ inst: { value: h, getSnapshot: p } }), x = b[0].inst, m = b[1];
    return r(
      function() {
        x.value = h, x.getSnapshot = p, s(x) && m({ inst: x });
      },
      [d, h, p]
    ), i(
      function() {
        return s(x) && m({ inst: x }), d(function() {
          s(x) && m({ inst: x });
        });
      },
      [d]
    ), o(h), h;
  }
  function s(d) {
    var p = d.getSnapshot;
    d = d.value;
    try {
      var h = p();
      return !n(d, h);
    } catch {
      return !0;
    }
  }
  function c(d, p) {
    return p();
  }
  var f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : u;
  return Rt.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : f, Rt;
}
var Ot = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gn;
function vu() {
  return Gn || (Gn = 1, process.env.NODE_ENV !== "production" && function() {
    function t(h, b) {
      return h === b && (h !== 0 || 1 / h === 1 / b) || h !== h && b !== b;
    }
    function e(h, b) {
      f || i.startTransition === void 0 || (f = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var x = b();
      if (!d) {
        var m = b();
        r(x, m) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      m = o({
        inst: { value: x, getSnapshot: b }
      });
      var g = m[0].inst, E = m[1];
      return s(
        function() {
          g.value = x, g.getSnapshot = b, n(g) && E({ inst: g });
        },
        [h, x, b]
      ), u(
        function() {
          return n(g) && E({ inst: g }), h(function() {
            n(g) && E({ inst: g });
          });
        },
        [h]
      ), c(x), x;
    }
    function n(h) {
      var b = h.getSnapshot;
      h = h.value;
      try {
        var x = b();
        return !r(h, x);
      } catch {
        return !0;
      }
    }
    function l(h, b) {
      return b();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = C, r = typeof Object.is == "function" ? Object.is : t, o = i.useState, u = i.useEffect, s = i.useLayoutEffect, c = i.useDebugValue, f = !1, d = !1, p = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? l : e;
    Ot.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : p, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Ot;
}
var qn;
function hu() {
  return qn || (qn = 1, process.env.NODE_ENV === "production" ? ut.exports = pu() : ut.exports = vu()), ut.exports;
}
var bu = hu();
const Zl = /* @__PURE__ */ Y(!1), Ye = /* @__PURE__ */ Y(null);
function $u(t) {
  if (H(Ye))
    return t.content;
  let { collection: n, document: l } = xu(t.createCollection);
  return /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement(Vo, null, /* @__PURE__ */ C.createElement(Ye.Provider, {
    value: l
  }, t.content)), /* @__PURE__ */ C.createElement(mu, {
    render: t.children,
    collection: n
  }));
}
function mu({ collection: t, render: e }) {
  return e(t);
}
function yu(t, e, n) {
  let l = Oe(), i = k(l);
  i.current = l;
  let r = z(() => i.current ? n() : e(), [
    e,
    n
  ]);
  return bu.useSyncExternalStore(t, r);
}
const gu = typeof C.useSyncExternalStore == "function" ? C.useSyncExternalStore : yu;
function xu(t) {
  let [e] = W(() => new Ho(t?.() || new bn())), n = z((o) => e.subscribe(o), [
    e
  ]), l = z(() => {
    let o = e.getCollection();
    return e.isSSR && e.resetAfterSSR(), o;
  }, [
    e
  ]), i = z(() => (e.isSSR = !0, e.getCollection()), [
    e
  ]), r = gu(n, l, i);
  return Z(() => (e.isMounted = !0, () => {
    e.isMounted = !1;
  }), [
    e
  ]), {
    collection: r,
    document: e
  };
}
const Jt = /* @__PURE__ */ Y(null);
function Eu(t, e, n, l, i, r) {
  let o = z((s) => {
    s?.setProps(e, n, l, r);
  }, [
    e,
    n,
    l,
    r
  ]), u = H(Jt);
  if (u) {
    let s = u.ownerDocument.nodesByProps.get(e);
    return s || (s = u.ownerDocument.createElement(t), s.setProps(e, n, l, r), u.appendChild(s), u.ownerDocument.updateCollection(), u.ownerDocument.nodesByProps.set(e, s)), i ? /* @__PURE__ */ C.createElement(Jt.Provider, {
      value: s
    }, i) : null;
  }
  return /* @__PURE__ */ C.createElement(t, {
    ref: o
  }, i);
}
function Jl(t, e) {
  let n = ({ node: i }) => e(i.props, i.props.ref, i), l = ve((i, r) => {
    let o = H(bt);
    if (!H(Zl)) {
      if (e.length >= 3) throw new Error(e.name + " cannot be rendered outside a collection.");
      return e(i, r);
    }
    return Eu(t, i, r, "children" in i ? i.children : null, null, (s) => (
      // Forward FocusableContext to real DOM tree so tooltips work.
      /* @__PURE__ */ C.createElement(bt.Provider, {
        value: o
      }, /* @__PURE__ */ C.createElement(n, {
        node: s
      }))
    ));
  });
  return l.displayName = e.name, l;
}
function Su(t) {
  return Ol({
    ...t,
    addIdAndValue: !0
  });
}
const Yn = /* @__PURE__ */ Y(null);
function Pu(t) {
  let e = H(Yn), n = (e?.dependencies || []).concat(t.dependencies), l = t.idScope || e?.idScope, i = Su({
    ...t,
    idScope: l,
    dependencies: n
  });
  return H(Ye) && (i = /* @__PURE__ */ C.createElement(Cu, null, i)), e = V(() => ({
    dependencies: n,
    idScope: l
  }), [
    l,
    ...n
  ]), /* @__PURE__ */ C.createElement(Yn.Provider, {
    value: e
  }, i);
}
function Cu({ children: t }) {
  let e = H(Ye), n = V(() => /* @__PURE__ */ C.createElement(Ye.Provider, {
    value: null
  }, /* @__PURE__ */ C.createElement(Zl.Provider, {
    value: !0
  }, t)), [
    t
  ]);
  return Oe() ? /* @__PURE__ */ C.createElement(Jt.Provider, {
    value: e
  }, n) : /* @__PURE__ */ Rr(n, e);
}
function wu(t, e) {
  let { elementType: n = "a", onPress: l, onPressStart: i, onPressEnd: r, onClick: o, isDisabled: u, ...s } = t, c = {};
  n !== "a" && (c = {
    role: "link",
    tabIndex: u ? void 0 : 0
  });
  let { focusableProps: f } = Je(t, e), { pressProps: d, isPressed: p } = Ct({
    onPress: l,
    onPressStart: i,
    onPressEnd: r,
    onClick: o,
    isDisabled: u,
    ref: e
  }), h = ee(s, {
    labelable: !0
  }), b = L(f, d), x = Ze(), m = mo(t);
  return {
    isPressed: p,
    linkProps: L(h, m, {
      ...b,
      ...c,
      "aria-disabled": u || void 0,
      "aria-current": t["aria-current"],
      onClick: (g) => {
        var E;
        (E = d.onClick) === null || E === void 0 || E.call(d, g), yo(g, x, t.href, t.routerOptions);
      }
    })
  };
}
const Du = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), Tu = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function ku(t) {
  if (Intl.Locale) {
    let n = new Intl.Locale(t).maximize(), l = typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo;
    if (l) return l.direction === "rtl";
    if (n.script) return Du.has(n.script);
  }
  let e = t.split("-")[0];
  return Tu.has(e);
}
const Ku = Symbol.for("react-aria.i18n.locale");
function Ql() {
  let t = typeof window < "u" && window[Ku] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      t
    ]);
  } catch {
    t = "en-US";
  }
  return {
    locale: t,
    direction: ku(t) ? "rtl" : "ltr"
  };
}
let Qt = Ql(), Ue = /* @__PURE__ */ new Set();
function Xn() {
  Qt = Ql();
  for (let t of Ue) t(Qt);
}
function Bu() {
  let t = Oe(), [e, n] = W(Qt);
  return O(() => (Ue.size === 0 && window.addEventListener("languagechange", Xn), Ue.add(n), () => {
    Ue.delete(n), Ue.size === 0 && window.removeEventListener("languagechange", Xn);
  }), []), t ? {
    locale: "en-US",
    direction: "ltr"
  } : e;
}
const Au = /* @__PURE__ */ C.createContext(null);
function Ae() {
  let t = Bu();
  return H(Au) || t;
}
const Fu = Symbol.for("react-aria.i18n.locale"), Iu = Symbol.for("react-aria.i18n.strings");
let Fe;
class Dt {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(e, n) {
    let i = this.getStringsForLocale(n)[e];
    if (!i) throw new Error(`Could not find intl message ${e} in ${n} locale`);
    return i;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(e) {
    let n = this.strings[e];
    return n || (n = Lu(e, this.strings, this.defaultLocale), this.strings[e] = n), n;
  }
  static getGlobalDictionaryForPackage(e) {
    if (typeof window > "u") return null;
    let n = window[Fu];
    if (Fe === void 0) {
      let i = window[Iu];
      if (!i) return null;
      Fe = {};
      for (let r in i) Fe[r] = new Dt({
        [n]: i[r]
      }, n);
    }
    let l = Fe?.[e];
    if (!l) throw new Error(`Strings for package "${e}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return l;
  }
  constructor(e, n = "en-US") {
    this.strings = Object.fromEntries(Object.entries(e).filter(([, l]) => l)), this.defaultLocale = n;
  }
}
function Lu(t, e, n = "en-US") {
  if (e[t]) return e[t];
  let l = Mu(t);
  if (e[l]) return e[l];
  for (let i in e)
    if (i.startsWith(l + "-")) return e[i];
  return e[n];
}
function Mu(t) {
  return Intl.Locale ? new Intl.Locale(t).language : t.split("-")[0];
}
const Zn = /* @__PURE__ */ new Map(), Jn = /* @__PURE__ */ new Map();
class Nu {
  /** Formats a localized string for the given key with the provided variables. */
  format(e, n) {
    let l = this.strings.getStringForLocale(e, this.locale);
    return typeof l == "function" ? l(n, this) : l;
  }
  plural(e, n, l = "cardinal") {
    let i = n["=" + e];
    if (i) return typeof i == "function" ? i() : i;
    let r = this.locale + ":" + l, o = Zn.get(r);
    o || (o = new Intl.PluralRules(this.locale, {
      type: l
    }), Zn.set(r, o));
    let u = o.select(e);
    return i = n[u] || n.other, typeof i == "function" ? i() : i;
  }
  number(e) {
    let n = Jn.get(this.locale);
    return n || (n = new Intl.NumberFormat(this.locale), Jn.set(this.locale, n)), n.format(e);
  }
  select(e, n) {
    let l = e[n] || e.other;
    return typeof l == "function" ? l() : l;
  }
  constructor(e, n) {
    this.locale = e, this.strings = n;
  }
}
const Qn = /* @__PURE__ */ new WeakMap();
function Ru(t) {
  let e = Qn.get(t);
  return e || (e = new Dt(t), Qn.set(t, e)), e;
}
function Ou(t, e) {
  return e && Dt.getGlobalDictionaryForPackage(e) || Ru(t);
}
function xn(t, e) {
  let { locale: n } = Ae(), l = Ou(t, e);
  return V(() => new Nu(n, l), [
    n,
    l
  ]);
}
let zt = /* @__PURE__ */ new Map(), en = !1;
try {
  en = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let mt = !1;
try {
  mt = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const ei = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class zu {
  /** Formats a number value as a string, according to the locale and options provided to the constructor. */
  format(e) {
    let n = "";
    if (!en && this.options.signDisplay != null ? n = Vu(this.numberFormatter, this.options.signDisplay, e) : n = this.numberFormatter.format(e), this.options.style === "unit" && !mt) {
      var l;
      let { unit: i, unitDisplay: r = "short", locale: o } = this.resolvedOptions();
      if (!i) return n;
      let u = (l = ei[i]) === null || l === void 0 ? void 0 : l[r];
      n += u[o] || u.default;
    }
    return n;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(e) {
    return this.numberFormatter.formatToParts(e);
  }
  /** Formats a number range as a string. */
  formatRange(e, n) {
    if (typeof this.numberFormatter.formatRange == "function") return this.numberFormatter.formatRange(e, n);
    if (n < e) throw new RangeError("End date must be >= start date");
    return `${this.format(e)} – ${this.format(n)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(e, n) {
    if (typeof this.numberFormatter.formatRangeToParts == "function") return this.numberFormatter.formatRangeToParts(e, n);
    if (n < e) throw new RangeError("End date must be >= start date");
    let l = this.numberFormatter.formatToParts(e), i = this.numberFormatter.formatToParts(n);
    return [
      ...l.map((r) => ({
        ...r,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...i.map((r) => ({
        ...r,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let e = this.numberFormatter.resolvedOptions();
    return !en && this.options.signDisplay != null && (e = {
      ...e,
      signDisplay: this.options.signDisplay
    }), !mt && this.options.style === "unit" && (e = {
      ...e,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), e;
  }
  constructor(e, n = {}) {
    this.numberFormatter = Hu(e, n), this.options = n;
  }
}
function Hu(t, e = {}) {
  let { numberingSystem: n } = e;
  if (n && t.includes("-nu-") && (t.includes("-u-") || (t += "-u-"), t += `-nu-${n}`), e.style === "unit" && !mt) {
    var l;
    let { unit: o, unitDisplay: u = "short" } = e;
    if (!o) throw new Error('unit option must be provided with style: "unit"');
    if (!(!((l = ei[o]) === null || l === void 0) && l[u])) throw new Error(`Unsupported unit ${o} with unitDisplay = ${u}`);
    e = {
      ...e,
      style: "decimal"
    };
  }
  let i = t + (e ? Object.entries(e).sort((o, u) => o[0] < u[0] ? -1 : 1).join() : "");
  if (zt.has(i)) return zt.get(i);
  let r = new Intl.NumberFormat(t, e);
  return zt.set(i, r), r;
}
function Vu(t, e, n) {
  if (e === "auto") return t.format(n);
  if (e === "never") return t.format(Math.abs(n));
  {
    let l = !1;
    if (e === "always" ? l = n > 0 || Object.is(n, 0) : e === "exceptZero" && (Object.is(n, -0) || Object.is(n, 0) ? n = Math.abs(n) : l = n > 0), l) {
      let i = t.format(-n), r = t.format(n), o = i.replace(r, "").replace(/\u200e|\u061C/, "");
      return [
        ...o
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), i.replace(r, "!!!").replace(o, "+").replace("!!!", r);
    } else return t.format(n);
  }
}
function ju(t = {}) {
  let { locale: e } = Ae();
  return V(() => new zu(e, t), [
    e,
    t
  ]);
}
let Ht = /* @__PURE__ */ new Map();
function Uu(t) {
  let { locale: e } = Ae(), n = e + (t ? Object.entries(t).sort((i, r) => i[0] < r[0] ? -1 : 1).join() : "");
  if (Ht.has(n)) return Ht.get(n);
  let l = new Intl.Collator(e, t);
  return Ht.set(n, l), l;
}
function ti(t, e) {
  let { elementType: n = "button", isDisabled: l, onPress: i, onPressStart: r, onPressEnd: o, onPressUp: u, onPressChange: s, preventFocusOnPress: c, allowFocusWhenDisabled: f, onClick: d, href: p, target: h, rel: b, type: x = "button" } = t, m;
  n === "button" ? m = {
    type: x,
    disabled: l,
    form: t.form,
    formAction: t.formAction,
    formEncType: t.formEncType,
    formMethod: t.formMethod,
    formNoValidate: t.formNoValidate,
    formTarget: t.formTarget,
    name: t.name,
    value: t.value
  } : m = {
    role: "button",
    href: n === "a" && !l ? p : void 0,
    target: n === "a" ? h : void 0,
    type: n === "input" ? x : void 0,
    disabled: n === "input" ? l : void 0,
    "aria-disabled": !l || n === "input" ? void 0 : l,
    rel: n === "a" ? b : void 0
  };
  let { pressProps: g, isPressed: E } = Ct({
    onPressStart: r,
    onPressEnd: o,
    onPressChange: s,
    onPress: i,
    onPressUp: u,
    onClick: d,
    isDisabled: l,
    preventFocusOnPress: c,
    ref: e
  }), { focusableProps: T } = Je(t, e);
  f && (T.tabIndex = l ? -1 : T.tabIndex);
  let K = L(T, g, ee(t, {
    labelable: !0
  }));
  return {
    isPressed: E,
    buttonProps: L(m, K, {
      "aria-haspopup": t["aria-haspopup"],
      "aria-expanded": t["aria-expanded"],
      "aria-controls": t["aria-controls"],
      "aria-pressed": t["aria-pressed"],
      "aria-current": t["aria-current"]
    })
  };
}
function ni(t, e, n) {
  const { isSelected: l } = e, { isPressed: i, buttonProps: r } = ti({
    ...t,
    onPress: Xe(e.toggle, t.onPress)
  }, n);
  return {
    isPressed: i,
    isSelected: l,
    isDisabled: t.isDisabled || !1,
    buttonProps: L(r, {
      "aria-pressed": l
    })
  };
}
function Wu(t) {
  if (t.checked) return !0;
  let e = [];
  if (!t.form) e = [
    ...X(t).querySelectorAll(`input[type="radio"][name="${CSS.escape(t.name)}"]`)
  ].filter((r) => !r.form);
  else {
    var n, l;
    let r = (l = t.form) === null || l === void 0 || (n = l.elements) === null || n === void 0 ? void 0 : n.namedItem(t.name);
    e = [
      ...r ?? []
    ];
  }
  return e ? !e.some((r) => r.checked) : !1;
}
function li(t, e) {
  return !t || !e ? !1 : e.some((n) => n.contains(t));
}
function yt(t, e, n) {
  let l = e?.tabbable ? Ro : fn, i = t?.nodeType === Node.ELEMENT_NODE ? t : null, r = X(i), o = lo(r, t || r, NodeFilter.SHOW_ELEMENT, {
    acceptNode(u) {
      var s;
      return !(e == null || (s = e.from) === null || s === void 0) && s.contains(u) || e?.tabbable && u.tagName === "INPUT" && u.getAttribute("type") === "radio" && (!Wu(u) || o.currentNode.tagName === "INPUT" && o.currentNode.type === "radio" && o.currentNode.name === u.name) ? NodeFilter.FILTER_REJECT : l(u) && (!n || li(u, n)) && (!e?.accept || e.accept(u)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return e?.from && (o.currentNode = e.from), o;
}
class En {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(e) {
    return this.fastMap.get(e);
  }
  addTreeNode(e, n, l) {
    let i = this.fastMap.get(n ?? null);
    if (!i) return;
    let r = new el({
      scopeRef: e
    });
    i.addChild(r), r.parent = i, this.fastMap.set(e, r), l && (r.nodeToRestore = l);
  }
  addNode(e) {
    this.fastMap.set(e.scopeRef, e);
  }
  removeTreeNode(e) {
    if (e === null) return;
    let n = this.fastMap.get(e);
    if (!n) return;
    let l = n.parent;
    for (let r of this.traverse()) r !== n && n.nodeToRestore && r.nodeToRestore && n.scopeRef && n.scopeRef.current && li(r.nodeToRestore, n.scopeRef.current) && (r.nodeToRestore = n.nodeToRestore);
    let i = n.children;
    l && (l.removeChild(n), i.size > 0 && i.forEach((r) => l && l.addChild(r))), this.fastMap.delete(n.scopeRef);
  }
  // Pre Order Depth First
  *traverse(e = this.root) {
    if (e.scopeRef != null && (yield e), e.children.size > 0) for (let n of e.children) yield* this.traverse(n);
  }
  clone() {
    var e;
    let n = new En();
    var l;
    for (let i of this.traverse()) n.addTreeNode(i.scopeRef, (l = (e = i.parent) === null || e === void 0 ? void 0 : e.scopeRef) !== null && l !== void 0 ? l : null, i.nodeToRestore);
    return n;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new el({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
}
class el {
  addChild(e) {
    this.children.add(e), e.parent = this;
  }
  removeChild(e) {
    this.children.delete(e), e.parent = void 0;
  }
  constructor(e) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = e.scopeRef;
  }
}
new En();
function Qe(t = {}) {
  let { autoFocus: e = !1, isTextInput: n, within: l } = t, i = k({
    isFocused: !1,
    isFocusVisible: e || wt()
  }), [r, o] = W(!1), [u, s] = W(() => i.current.isFocused && i.current.isFocusVisible), c = z(() => s(i.current.isFocused && i.current.isFocusVisible), []), f = z((h) => {
    i.current.isFocused = h, o(h), c();
  }, [
    c
  ]);
  ou((h) => {
    i.current.isFocusVisible = h, c();
  }, [], {
    isTextInput: n
  });
  let { focusProps: d } = Xl({
    isDisabled: l,
    onFocusChange: f
  }), { focusWithinProps: p } = gn({
    isDisabled: !l,
    onFocusWithinChange: f
  });
  return {
    isFocused: r,
    isFocusVisible: u,
    focusProps: l ? p : d
  };
}
function _u(t, e) {
  let n = e?.isDisabled, [l, i] = W(!1);
  return Z(() => {
    if (t?.current && !n) {
      let r = () => {
        if (t.current) {
          let u = yt(t.current, {
            tabbable: !0
          });
          i(!!u.nextNode());
        }
      };
      r();
      let o = new MutationObserver(r);
      return o.observe(t.current, {
        subtree: !0,
        childList: !0,
        attributes: !0,
        attributeFilter: [
          "tabIndex",
          "disabled"
        ]
      }), () => {
        o.disconnect();
      };
    }
  }), n ? !1 : l;
}
function ii(t) {
  let e = qu(X(t));
  e !== t && (e && Gu(e, t), t && ri(t, e));
}
function Gu(t, e) {
  t.dispatchEvent(new FocusEvent("blur", {
    relatedTarget: e
  })), t.dispatchEvent(new FocusEvent("focusout", {
    bubbles: !0,
    relatedTarget: e
  }));
}
function ri(t, e) {
  t.dispatchEvent(new FocusEvent("focus", {
    relatedTarget: e
  })), t.dispatchEvent(new FocusEvent("focusin", {
    bubbles: !0,
    relatedTarget: e
  }));
}
function qu(t) {
  let e = Te(t), n = e?.getAttribute("aria-activedescendant");
  return n && t.getElementById(n) || e;
}
function Yu(t, e, n) {
  let l = {
    isSelected: e.selectedKeys.has(t.id),
    defaultSelected: !1,
    setSelected(s) {
      e.setSelected(t.id, s);
    },
    toggle() {
      e.toggleKey(t.id);
    }
  }, { isPressed: i, isSelected: r, isDisabled: o, buttonProps: u } = ni({
    ...t,
    id: void 0,
    isDisabled: t.isDisabled || e.isDisabled
  }, l, n);
  return e.selectionMode === "single" && (u.role = "radio", u["aria-checked"] = l.isSelected, delete u["aria-pressed"]), {
    isPressed: i,
    isSelected: r,
    isDisabled: o,
    buttonProps: u
  };
}
const oi = 7e3;
let ce = null;
function tn(t, e = "assertive", n = oi) {
  ce ? ce.announce(t, e, n) : (ce = new Xu(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? ce.announce(t, e, n) : setTimeout(() => {
    ce?.isAttached() && ce?.announce(t, e, n);
  }, 100));
}
class Xu {
  isAttached() {
    var e;
    return (e = this.node) === null || e === void 0 ? void 0 : e.isConnected;
  }
  createLog(e) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", e), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(e, n = "assertive", l = oi) {
    var i, r;
    if (!this.node) return;
    let o = document.createElement("div");
    typeof e == "object" ? (o.setAttribute("role", "img"), o.setAttribute("aria-labelledby", e["aria-labelledby"])) : o.textContent = e, n === "assertive" ? (i = this.assertiveLog) === null || i === void 0 || i.appendChild(o) : (r = this.politeLog) === null || r === void 0 || r.appendChild(o), e !== "" && setTimeout(() => {
      o.remove();
    }, l);
  }
  clear(e) {
    this.node && ((!e || e === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!e || e === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
}
function ui(t) {
  let { id: e, label: n, "aria-labelledby": l, "aria-label": i, labelElementType: r = "label" } = t;
  e = ae(e);
  let o = ae(), u = {};
  n ? (l = l ? `${o} ${l}` : o, u = {
    id: o,
    htmlFor: r === "label" ? e : void 0
  }) : !l && !i && process.env.NODE_ENV !== "production" && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let s = xo({
    id: e,
    "aria-label": i,
    "aria-labelledby": l
  });
  return {
    labelProps: u,
    fieldProps: s
  };
}
function Zu(t) {
  let { description: e, errorMessage: n, isInvalid: l, validationState: i } = t, { labelProps: r, fieldProps: o } = ui(t), u = Wt([
    !!e,
    !!n,
    l,
    i
  ]), s = Wt([
    !!e,
    !!n,
    l,
    i
  ]);
  return o = L(o, {
    "aria-describedby": [
      u,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      s,
      t["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: r,
    fieldProps: o,
    descriptionProps: {
      id: u
    },
    errorMessageProps: {
      id: s
    }
  };
}
function Ju(t = {}) {
  let { isReadOnly: e } = t, [n, l] = pn(t.isSelected, t.defaultSelected || !1, t.onChange), [i] = W(n);
  function r(s) {
    e || l(s);
  }
  function o() {
    e || l(!n);
  }
  var u;
  return {
    isSelected: n,
    defaultSelected: (u = t.defaultSelected) !== null && u !== void 0 ? u : i,
    setSelected: r,
    toggle: o
  };
}
const tl = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function va(t = {}) {
  let { style: e, isFocusable: n } = t, [l, i] = W(!1), { focusWithinProps: r } = gn({
    isDisabled: !n,
    onFocusWithinChange: (u) => i(u)
  }), o = V(() => l ? e : e ? {
    ...tl,
    ...e
  } : tl, [
    l
  ]);
  return {
    visuallyHiddenProps: {
      ...r,
      style: o
    }
  };
}
const de = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, gt = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, Qu = {
  top: "left",
  left: "top"
}, nn = {
  top: "height",
  left: "width"
}, si = {
  width: "totalWidth",
  height: "totalHeight"
}, st = {};
let J = typeof document < "u" ? window.visualViewport : null;
function nl(t) {
  let e = 0, n = 0, l = 0, i = 0, r = 0, o = 0, u = {};
  var s;
  let c = ((s = J?.scale) !== null && s !== void 0 ? s : 1) > 1;
  if (t.tagName === "BODY") {
    let b = document.documentElement;
    l = b.clientWidth, i = b.clientHeight;
    var f;
    e = (f = J?.width) !== null && f !== void 0 ? f : l;
    var d;
    n = (d = J?.height) !== null && d !== void 0 ? d : i, u.top = b.scrollTop || t.scrollTop, u.left = b.scrollLeft || t.scrollLeft, J && (r = J.offsetTop, o = J.offsetLeft);
  } else
    ({ width: e, height: n, top: r, left: o } = Re(t)), u.top = t.scrollTop, u.left = t.scrollLeft, l = e, i = n;
  if (wl() && (t.tagName === "BODY" || t.tagName === "HTML") && c) {
    u.top = 0, u.left = 0;
    var p;
    r = (p = J?.pageTop) !== null && p !== void 0 ? p : 0;
    var h;
    o = (h = J?.pageLeft) !== null && h !== void 0 ? h : 0;
  }
  return {
    width: e,
    height: n,
    totalWidth: l,
    totalHeight: i,
    scroll: u,
    top: r,
    left: o
  };
}
function es(t) {
  return {
    top: t.scrollTop,
    left: t.scrollLeft,
    width: t.scrollWidth,
    height: t.scrollHeight
  };
}
function ll(t, e, n, l, i, r, o) {
  var u;
  let s = (u = i.scroll[t]) !== null && u !== void 0 ? u : 0, c = l[nn[t]], f = l.scroll[de[t]] + r, d = c + l.scroll[de[t]] - r, p = e - s + o[t] - l[de[t]], h = e - s + n + o[t] - l[de[t]];
  return p < f ? f - p : h > d ? Math.max(d - h, f - p) : 0;
}
function ts(t) {
  let e = window.getComputedStyle(t);
  return {
    top: parseInt(e.marginTop, 10) || 0,
    bottom: parseInt(e.marginBottom, 10) || 0,
    left: parseInt(e.marginLeft, 10) || 0,
    right: parseInt(e.marginRight, 10) || 0
  };
}
function il(t) {
  if (st[t]) return st[t];
  let [e, n] = t.split(" "), l = de[e] || "right", i = Qu[l];
  de[n] || (n = "center");
  let r = nn[l], o = nn[i];
  return st[t] = {
    placement: e,
    crossPlacement: n,
    axis: l,
    crossAxis: i,
    size: r,
    crossSize: o
  }, st[t];
}
function Vt(t, e, n, l, i, r, o, u, s, c) {
  let { placement: f, crossPlacement: d, axis: p, crossAxis: h, size: b, crossSize: x } = l, m = {};
  var g;
  m[h] = (g = t[h]) !== null && g !== void 0 ? g : 0;
  var E, T, K, F;
  d === "center" ? m[h] += (((E = t[x]) !== null && E !== void 0 ? E : 0) - ((T = n[x]) !== null && T !== void 0 ? T : 0)) / 2 : d !== h && (m[h] += ((K = t[x]) !== null && K !== void 0 ? K : 0) - ((F = n[x]) !== null && F !== void 0 ? F : 0)), m[h] += r;
  const B = t[h] - n[x] + s + c, N = t[h] + t[x] - s - c;
  if (m[h] = Ge(m[h], B, N), f === p) {
    const R = u ? o[b] : e[si[b]];
    m[gt[p]] = Math.floor(R - t[p] + i);
  } else m[p] = Math.floor(t[p] + t[b] + i);
  return m;
}
function ns(t, e, n, l, i, r, o, u) {
  const s = l ? n.height : e[si.height];
  var c;
  let f = t.top != null ? n.top + t.top : n.top + (s - ((c = t.bottom) !== null && c !== void 0 ? c : 0) - o);
  var d, p, h, b, x, m;
  let g = u !== "top" ? (
    // We want the distance between the top of the overlay to the bottom of the boundary
    Math.max(0, e.height + e.top + ((d = e.scroll.top) !== null && d !== void 0 ? d : 0) - f - (((p = i.top) !== null && p !== void 0 ? p : 0) + ((h = i.bottom) !== null && h !== void 0 ? h : 0) + r))
  ) : Math.max(0, f + o - (e.top + ((b = e.scroll.top) !== null && b !== void 0 ? b : 0)) - (((x = i.top) !== null && x !== void 0 ? x : 0) + ((m = i.bottom) !== null && m !== void 0 ? m : 0) + r));
  return Math.min(e.height - r * 2, g);
}
function rl(t, e, n, l, i, r) {
  let { placement: o, axis: u, size: s } = r;
  var c, f;
  if (o === u) return Math.max(0, n[u] - t[u] - ((c = t.scroll[u]) !== null && c !== void 0 ? c : 0) + e[u] - ((f = l[u]) !== null && f !== void 0 ? f : 0) - l[gt[u]] - i);
  var d;
  return Math.max(0, t[s] + t[u] + t.scroll[u] - e[u] - n[u] - n[s] - ((d = l[u]) !== null && d !== void 0 ? d : 0) - l[gt[u]] - i);
}
function ls(t, e, n, l, i, r, o, u, s, c, f, d, p, h, b, x) {
  let m = il(t), { size: g, crossAxis: E, crossSize: T, placement: K, crossPlacement: F } = m, B = Vt(e, u, n, m, f, d, c, p, b, x), N = f, R = rl(u, c, e, i, r + f, m);
  if (o && l[g] > R) {
    let re = il(`${gt[K]} ${F}`), He = Vt(e, u, n, re, f, d, c, p, b, x);
    rl(u, c, e, i, r + f, re) > R && (m = re, B = He, N = f);
  }
  let G = "bottom";
  m.axis === "top" ? m.placement === "top" ? G = "top" : m.placement === "bottom" && (G = "bottom") : m.crossAxis === "top" && (m.crossPlacement === "top" ? G = "bottom" : m.crossPlacement === "bottom" && (G = "top"));
  let M = ll(E, B[E], n[T], u, s, r, c);
  B[E] += M;
  let a = ns(B, u, c, p, i, r, n.height, G);
  h && h < a && (a = h), n.height = Math.min(n.height, a), B = Vt(e, u, n, m, N, d, c, p, b, x), M = ll(E, B[E], n[T], u, s, r, c), B[E] += M;
  let w = {}, I = e[E] + 0.5 * e[T] - B[E] - i[de[E]];
  const P = b / 2 + x;
  var D, v, $, S;
  const y = de[E] === "left" ? ((D = i.left) !== null && D !== void 0 ? D : 0) + ((v = i.right) !== null && v !== void 0 ? v : 0) : (($ = i.top) !== null && $ !== void 0 ? $ : 0) + ((S = i.bottom) !== null && S !== void 0 ? S : 0), j = n[T] - y - b / 2 - x, te = e[E] + b / 2 - (B[E] + i[de[E]]), Q = e[E] + e[T] - b / 2 - (B[E] + i[de[E]]), ie = Ge(I, te, Q);
  return w[E] = Ge(ie, P, j), {
    position: B,
    maxHeight: a,
    arrowOffsetLeft: w.left,
    arrowOffsetTop: w.top,
    placement: m.placement
  };
}
function is(t) {
  let { placement: e, targetNode: n, overlayNode: l, scrollNode: i, padding: r, shouldFlip: o, boundaryElement: u, offset: s, crossOffset: c, maxHeight: f, arrowSize: d = 0, arrowBoundaryOffset: p = 0 } = t, h = l instanceof HTMLElement ? rs(l) : document.documentElement, b = h === document.documentElement;
  const x = window.getComputedStyle(h).position;
  let m = !!x && x !== "static", g = b ? Re(n) : ol(n, h);
  if (!b) {
    let { marginTop: w, marginLeft: I } = window.getComputedStyle(n);
    g.top += parseInt(w, 10) || 0, g.left += parseInt(I, 10) || 0;
  }
  let E = Re(l), T = ts(l);
  var K, F;
  E.width += ((K = T.left) !== null && K !== void 0 ? K : 0) + ((F = T.right) !== null && F !== void 0 ? F : 0);
  var B, N;
  E.height += ((B = T.top) !== null && B !== void 0 ? B : 0) + ((N = T.bottom) !== null && N !== void 0 ? N : 0);
  let R = es(i), G = nl(u), M = nl(h), a = u.tagName === "BODY" ? Re(h) : ol(h, u);
  return h.tagName === "HTML" && u.tagName === "BODY" && (M.scroll.top = 0, M.scroll.left = 0), ls(e, g, E, R, T, r, o, G, M, a, s, c, m, f, d, p);
}
function Re(t) {
  let { top: e, left: n, width: l, height: i } = t.getBoundingClientRect(), { scrollTop: r, scrollLeft: o, clientTop: u, clientLeft: s } = document.documentElement;
  return {
    top: e + r - u,
    left: n + o - s,
    width: l,
    height: i
  };
}
function ol(t, e) {
  let n = window.getComputedStyle(t), l;
  if (n.position === "fixed") {
    let { top: i, left: r, width: o, height: u } = t.getBoundingClientRect();
    l = {
      top: i,
      left: r,
      width: o,
      height: u
    };
  } else {
    l = Re(t);
    let i = Re(e), r = window.getComputedStyle(e);
    i.top += (parseInt(r.borderTopWidth, 10) || 0) - e.scrollTop, i.left += (parseInt(r.borderLeftWidth, 10) || 0) - e.scrollLeft, l.top -= i.top, l.left -= i.left;
  }
  return l.top -= parseInt(n.marginTop, 10) || 0, l.left -= parseInt(n.marginLeft, 10) || 0, l;
}
function rs(t) {
  let e = t.offsetParent;
  if (e && e === document.body && window.getComputedStyle(e).position === "static" && !ul(e) && (e = document.documentElement), e == null)
    for (e = t.parentElement; e && !ul(e); ) e = e.parentElement;
  return e || document.documentElement;
}
function ul(t) {
  let e = window.getComputedStyle(t);
  return e.transform !== "none" || /transform|perspective/.test(e.willChange) || e.filter !== "none" || e.contain === "paint" || "backdropFilter" in e && e.backdropFilter !== "none" || "WebkitBackdropFilter" in e && e.WebkitBackdropFilter !== "none";
}
const os = /* @__PURE__ */ new WeakMap();
function us(t) {
  let { triggerRef: e, isOpen: n, onClose: l } = t;
  O(() => {
    if (!n || l === null) return;
    let i = (r) => {
      let o = r.target;
      if (!e.current || o instanceof Node && !o.contains(e.current) || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement) return;
      let u = l || os.get(e.current);
      u && u();
    };
    return window.addEventListener("scroll", i, !0), () => {
      window.removeEventListener("scroll", i, !0);
    };
  }, [
    n,
    l,
    e
  ]);
}
let q = typeof document < "u" ? window.visualViewport : null;
function ss(t) {
  let { direction: e } = Ae(), { arrowSize: n = 0, targetRef: l, overlayRef: i, scrollRef: r = i, placement: o = "bottom", containerPadding: u = 12, shouldFlip: s = !0, boundaryElement: c = typeof document < "u" ? document.body : null, offset: f = 0, crossOffset: d = 0, shouldUpdatePosition: p = !0, isOpen: h = !0, onClose: b, maxHeight: x, arrowBoundaryOffset: m = 0 } = t, [g, E] = W(null), T = [
    p,
    o,
    i.current,
    l.current,
    r.current,
    u,
    s,
    c,
    f,
    d,
    h,
    e,
    x,
    m,
    n
  ], K = k(q?.scale);
  O(() => {
    h && (K.current = q?.scale);
  }, [
    h
  ]);
  let F = z(() => {
    if (p === !1 || !h || !i.current || !l.current || !c || q?.scale !== K.current) return;
    let M = null;
    if (r.current && r.current.contains(document.activeElement)) {
      var a;
      let S = (a = document.activeElement) === null || a === void 0 ? void 0 : a.getBoundingClientRect(), y = r.current.getBoundingClientRect();
      var w;
      if (M = {
        type: "top",
        offset: ((w = S?.top) !== null && w !== void 0 ? w : 0) - y.top
      }, M.offset > y.height / 2) {
        M.type = "bottom";
        var I;
        M.offset = ((I = S?.bottom) !== null && I !== void 0 ? I : 0) - y.bottom;
      }
    }
    let P = i.current;
    if (!x && i.current) {
      var D;
      P.style.top = "0px", P.style.bottom = "";
      var v;
      P.style.maxHeight = ((v = (D = window.visualViewport) === null || D === void 0 ? void 0 : D.height) !== null && v !== void 0 ? v : window.innerHeight) + "px";
    }
    let $ = is({
      placement: cs(o, e),
      overlayNode: i.current,
      targetNode: l.current,
      scrollNode: r.current || i.current,
      padding: u,
      shouldFlip: s,
      boundaryElement: c,
      offset: f,
      crossOffset: d,
      maxHeight: x,
      arrowSize: n,
      arrowBoundaryOffset: m
    });
    if ($.position) {
      if (P.style.top = "", P.style.bottom = "", P.style.left = "", P.style.right = "", Object.keys($.position).forEach((S) => P.style[S] = $.position[S] + "px"), P.style.maxHeight = $.maxHeight != null ? $.maxHeight + "px" : "", M && document.activeElement && r.current) {
        let S = document.activeElement.getBoundingClientRect(), y = r.current.getBoundingClientRect(), j = S[M.type] - y[M.type];
        r.current.scrollTop += j - M.offset;
      }
      E($);
    }
  }, T);
  Z(F, T), as(F), An({
    ref: i,
    onResize: F
  }), An({
    ref: l,
    onResize: F
  });
  let B = k(!1);
  Z(() => {
    let M, a = () => {
      B.current = !0, clearTimeout(M), M = setTimeout(() => {
        B.current = !1;
      }, 500), F();
    }, w = () => {
      B.current && a();
    };
    return q?.addEventListener("resize", a), q?.addEventListener("scroll", w), () => {
      q?.removeEventListener("resize", a), q?.removeEventListener("scroll", w);
    };
  }, [
    F
  ]);
  let N = z(() => {
    B.current || b?.();
  }, [
    b,
    B
  ]);
  us({
    triggerRef: l,
    isOpen: h,
    onClose: b && N
  });
  var R, G;
  return {
    overlayProps: {
      style: {
        position: "absolute",
        zIndex: 1e5,
        ...g?.position,
        maxHeight: (R = g?.maxHeight) !== null && R !== void 0 ? R : "100vh"
      }
    },
    placement: (G = g?.placement) !== null && G !== void 0 ? G : null,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: g?.arrowOffsetLeft,
        top: g?.arrowOffsetTop
      }
    },
    updatePosition: F
  };
}
function as(t) {
  Z(() => (window.addEventListener("resize", t, !1), () => {
    window.removeEventListener("resize", t, !1);
  }), [
    t
  ]);
}
function cs(t, e) {
  return e === "rtl" ? t.replace("start", "right").replace("end", "left") : t.replace("start", "left").replace("end", "right");
}
const ds = /* @__PURE__ */ Y({});
function fs() {
  var t;
  return (t = H(ds)) !== null && t !== void 0 ? t : {};
}
const ln = /* @__PURE__ */ C.createContext(null);
function ps(t) {
  let { children: e } = t, n = H(ln), [l, i] = W(0), r = V(() => ({
    parent: n,
    modalCount: l,
    addModal() {
      i((o) => o + 1), n && n.addModal();
    },
    removeModal() {
      i((o) => o - 1), n && n.removeModal();
    }
  }), [
    n,
    l
  ]);
  return /* @__PURE__ */ C.createElement(ln.Provider, {
    value: r
  }, e);
}
function vs() {
  let t = H(ln);
  return {
    modalProviderProps: {
      "aria-hidden": t && t.modalCount > 0 ? !0 : void 0
    }
  };
}
function hs(t) {
  let { modalProviderProps: e } = vs();
  return /* @__PURE__ */ C.createElement("div", {
    "data-overlay-container": !0,
    ...t,
    ...e
  });
}
function bs(t) {
  return /* @__PURE__ */ C.createElement(ps, null, /* @__PURE__ */ C.createElement(hs, t));
}
function $s(t) {
  let e = Oe(), { portalContainer: n = e ? null : document.body, ...l } = t, { getContainer: i } = fs();
  if (!t.portalContainer && i && (n = i()), C.useEffect(() => {
    if (n?.closest("[data-overlay-container]")) throw new Error("An OverlayContainer must not be inside another container. Please change the portalContainer prop.");
  }, [
    n
  ]), !n) return null;
  let r = /* @__PURE__ */ C.createElement(bs, l);
  return /* @__PURE__ */ Nr.createPortal(r, n);
}
function rn(t) {
  return vo() ? t.altKey : t.ctrlKey;
}
function ct(t, e) {
  var n, l;
  let i = `[data-key="${CSS.escape(String(e))}"]`, r = (n = t.current) === null || n === void 0 ? void 0 : n.dataset.collection;
  return r && (i = `[data-collection="${CSS.escape(r)}"]${i}`), (l = t.current) === null || l === void 0 ? void 0 : l.querySelector(i);
}
const ai = /* @__PURE__ */ new WeakMap();
function ms(t) {
  let e = ae();
  return ai.set(t, e), e;
}
function ys(t) {
  return ai.get(t);
}
const gs = 1e3;
function xs(t) {
  let { keyboardDelegate: e, selectionManager: n, onTypeSelect: l } = t, i = k({
    search: "",
    timeout: void 0
  }).current, r = (o) => {
    let u = Es(o.key);
    if (!(!u || o.ctrlKey || o.metaKey || !o.currentTarget.contains(o.target) || i.search.length === 0 && u === " ")) {
      if (u === " " && i.search.trim().length > 0 && (o.preventDefault(), "continuePropagation" in o || o.stopPropagation()), i.search += u, e.getKeyForSearch != null) {
        let s = e.getKeyForSearch(i.search, n.focusedKey);
        s == null && (s = e.getKeyForSearch(i.search)), s != null && (n.setFocusedKey(s), l && l(s));
      }
      clearTimeout(i.timeout), i.timeout = setTimeout(() => {
        i.search = "";
      }, gs);
    }
  };
  return {
    typeSelectProps: {
      // Using a capturing listener to catch the keydown event before
      // other hooks in order to handle the Spacebar event.
      onKeyDownCapture: e.getKeyForSearch ? r : void 0
    }
  };
}
function Es(t) {
  return t.length === 1 || !/^[A-Z]/i.test(t) ? t : "";
}
function Ss(t) {
  let { selectionManager: e, keyboardDelegate: n, ref: l, autoFocus: i = !1, shouldFocusWrap: r = !1, disallowEmptySelection: o = !1, disallowSelectAll: u = !1, escapeKeyBehavior: s = "clearSelection", selectOnFocus: c = e.selectionBehavior === "replace", disallowTypeAhead: f = !1, shouldUseVirtualFocus: d, allowsTabNavigation: p = !1, isVirtualized: h, scrollRef: b = l, linkBehavior: x = "action" } = t, { direction: m } = Ae(), g = Ze(), E = ($) => {
    var S;
    if ($.altKey && $.key === "Tab" && $.preventDefault(), !(!((S = l.current) === null || S === void 0) && S.contains($.target))) return;
    const y = (A, Ee) => {
      if (A != null) {
        if (e.isLink(A) && x === "selection" && c && !rn($)) {
          on(() => {
            e.setFocusedKey(A, Ee);
          });
          let Se = ct(l, A), Dn = e.getItemProps(A);
          Se && g.open(Se, $, Dn.href, Dn.routerOptions);
          return;
        }
        if (e.setFocusedKey(A, Ee), e.isLink(A) && x === "override") return;
        $.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(A) : c && !rn($) && e.replaceSelection(A);
      }
    };
    switch ($.key) {
      case "ArrowDown":
        if (n.getKeyBelow) {
          var j, te, Q;
          let A = e.focusedKey != null ? (j = n.getKeyBelow) === null || j === void 0 ? void 0 : j.call(n, e.focusedKey) : (te = n.getFirstKey) === null || te === void 0 ? void 0 : te.call(n);
          A == null && r && (A = (Q = n.getFirstKey) === null || Q === void 0 ? void 0 : Q.call(n, e.focusedKey)), A != null && ($.preventDefault(), y(A));
        }
        break;
      case "ArrowUp":
        if (n.getKeyAbove) {
          var ie, re, He;
          let A = e.focusedKey != null ? (ie = n.getKeyAbove) === null || ie === void 0 ? void 0 : ie.call(n, e.focusedKey) : (re = n.getLastKey) === null || re === void 0 ? void 0 : re.call(n);
          A == null && r && (A = (He = n.getLastKey) === null || He === void 0 ? void 0 : He.call(n, e.focusedKey)), A != null && ($.preventDefault(), y(A));
        }
        break;
      case "ArrowLeft":
        if (n.getKeyLeftOf) {
          var tt, Tt, kt;
          let A = e.focusedKey != null ? (tt = n.getKeyLeftOf) === null || tt === void 0 ? void 0 : tt.call(n, e.focusedKey) : null;
          A == null && r && (A = m === "rtl" ? (Tt = n.getFirstKey) === null || Tt === void 0 ? void 0 : Tt.call(n, e.focusedKey) : (kt = n.getLastKey) === null || kt === void 0 ? void 0 : kt.call(n, e.focusedKey)), A != null && ($.preventDefault(), y(A, m === "rtl" ? "first" : "last"));
        }
        break;
      case "ArrowRight":
        if (n.getKeyRightOf) {
          var Kt, Bt, At;
          let A = e.focusedKey != null ? (Kt = n.getKeyRightOf) === null || Kt === void 0 ? void 0 : Kt.call(n, e.focusedKey) : null;
          A == null && r && (A = m === "rtl" ? (Bt = n.getLastKey) === null || Bt === void 0 ? void 0 : Bt.call(n, e.focusedKey) : (At = n.getFirstKey) === null || At === void 0 ? void 0 : At.call(n, e.focusedKey)), A != null && ($.preventDefault(), y(A, m === "rtl" ? "last" : "first"));
        }
        break;
      case "Home":
        if (n.getFirstKey) {
          if (e.focusedKey === null && $.shiftKey) return;
          $.preventDefault();
          let A = n.getFirstKey(e.focusedKey, Ie($));
          e.setFocusedKey(A), A != null && (Ie($) && $.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(A) : c && e.replaceSelection(A));
        }
        break;
      case "End":
        if (n.getLastKey) {
          if (e.focusedKey === null && $.shiftKey) return;
          $.preventDefault();
          let A = n.getLastKey(e.focusedKey, Ie($));
          e.setFocusedKey(A), A != null && (Ie($) && $.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(A) : c && e.replaceSelection(A));
        }
        break;
      case "PageDown":
        if (n.getKeyPageBelow && e.focusedKey != null) {
          let A = n.getKeyPageBelow(e.focusedKey);
          A != null && ($.preventDefault(), y(A));
        }
        break;
      case "PageUp":
        if (n.getKeyPageAbove && e.focusedKey != null) {
          let A = n.getKeyPageAbove(e.focusedKey);
          A != null && ($.preventDefault(), y(A));
        }
        break;
      case "a":
        Ie($) && e.selectionMode === "multiple" && u !== !0 && ($.preventDefault(), e.selectAll());
        break;
      case "Escape":
        s === "clearSelection" && !o && e.selectedKeys.size !== 0 && ($.stopPropagation(), $.preventDefault(), e.clearSelection());
        break;
      case "Tab":
        if (!p) {
          if ($.shiftKey) l.current.focus();
          else {
            let A = yt(l.current, {
              tabbable: !0
            }), Ee, Se;
            do
              Se = A.lastChild(), Se && (Ee = Se);
            while (Se);
            Ee && !Ee.contains(document.activeElement) && pe(Ee);
          }
          break;
        }
    }
  }, T = k({
    top: 0,
    left: 0
  });
  lt(b, "scroll", h ? void 0 : () => {
    var $, S, y, j;
    T.current = {
      top: (y = ($ = b.current) === null || $ === void 0 ? void 0 : $.scrollTop) !== null && y !== void 0 ? y : 0,
      left: (j = (S = b.current) === null || S === void 0 ? void 0 : S.scrollLeft) !== null && j !== void 0 ? j : 0
    };
  });
  let K = ($) => {
    if (e.isFocused) {
      $.currentTarget.contains($.target) || e.setFocused(!1);
      return;
    }
    if ($.currentTarget.contains($.target)) {
      if (e.setFocused(!0), e.focusedKey == null) {
        var S, y;
        let Q = (re) => {
          re != null && (e.setFocusedKey(re), c && !e.isSelected(re) && e.replaceSelection(re));
        }, ie = $.relatedTarget;
        var j, te;
        ie && $.currentTarget.compareDocumentPosition(ie) & Node.DOCUMENT_POSITION_FOLLOWING ? Q((j = e.lastSelectedKey) !== null && j !== void 0 ? j : (S = n.getLastKey) === null || S === void 0 ? void 0 : S.call(n)) : Q((te = e.firstSelectedKey) !== null && te !== void 0 ? te : (y = n.getFirstKey) === null || y === void 0 ? void 0 : y.call(n));
      } else !h && b.current && (b.current.scrollTop = T.current.top, b.current.scrollLeft = T.current.left);
      if (e.focusedKey != null && b.current) {
        let Q = ct(l, e.focusedKey);
        Q instanceof HTMLElement && (!Q.contains(document.activeElement) && !d && pe(Q), ht() === "keyboard" && $e(Q, {
          containingElement: l.current
        }));
      }
    }
  }, F = ($) => {
    $.currentTarget.contains($.relatedTarget) || e.setFocused(!1);
  }, B = k(!1);
  lt(l, Ko, d ? ($) => {
    let { detail: S } = $;
    $.stopPropagation(), e.setFocused(!0), S?.focusStrategy === "first" && (B.current = !0);
  } : void 0);
  let N = ne(() => {
    var $, S;
    let y = (S = ($ = n.getFirstKey) === null || $ === void 0 ? void 0 : $.call(n)) !== null && S !== void 0 ? S : null;
    if (y == null) {
      let j = Te();
      ii(l.current), ri(j, null), e.collection.size > 0 && (B.current = !1);
    } else
      e.setFocusedKey(y), B.current = !1;
  });
  Bn(() => {
    B.current && N();
  }, [
    e.collection,
    N
  ]);
  let R = ne(() => {
    e.collection.size > 0 && (B.current = !1);
  });
  Bn(() => {
    R();
  }, [
    e.focusedKey,
    R
  ]), lt(l, ko, d ? ($) => {
    var S;
    $.stopPropagation(), e.setFocused(!1), !((S = $.detail) === null || S === void 0) && S.clearFocusKey && e.setFocusedKey(null);
  } : void 0);
  const G = k(i), M = k(!1);
  O(() => {
    if (G.current) {
      var $, S;
      let te = null;
      var y;
      i === "first" && (te = (y = ($ = n.getFirstKey) === null || $ === void 0 ? void 0 : $.call(n)) !== null && y !== void 0 ? y : null);
      var j;
      i === "last" && (te = (j = (S = n.getLastKey) === null || S === void 0 ? void 0 : S.call(n)) !== null && j !== void 0 ? j : null);
      let Q = e.selectedKeys;
      if (Q.size) {
        for (let ie of Q) if (e.canSelectItem(ie)) {
          te = ie;
          break;
        }
      }
      e.setFocused(!0), e.setFocusedKey(te), te == null && !d && l.current && ue(l.current), e.collection.size > 0 && (G.current = !1, M.current = !0);
    }
  });
  let a = k(e.focusedKey), w = k(null);
  O(() => {
    if (e.isFocused && e.focusedKey != null && (e.focusedKey !== a.current || M.current) && b.current && l.current) {
      let $ = ht(), S = ct(l, e.focusedKey);
      if (!(S instanceof HTMLElement))
        return;
      ($ === "keyboard" || M.current) && (w.current && cancelAnimationFrame(w.current), w.current = requestAnimationFrame(() => {
        b.current && (Il(b.current, S), $ !== "virtual" && $e(S, {
          containingElement: l.current
        }));
      }));
    }
    !d && e.isFocused && e.focusedKey == null && a.current != null && l.current && ue(l.current), a.current = e.focusedKey, M.current = !1;
  }), O(() => () => {
    w.current && cancelAnimationFrame(w.current);
  }, []), lt(l, "react-aria-focus-scope-restore", ($) => {
    $.preventDefault(), e.setFocused(!0);
  });
  let I = {
    onKeyDown: E,
    onFocus: K,
    onBlur: F,
    onMouseDown($) {
      b.current === $.target && $.preventDefault();
    }
  }, { typeSelectProps: P } = xs({
    keyboardDelegate: n,
    selectionManager: e
  });
  f || (I = L(P, I));
  let D;
  d || (D = e.focusedKey == null ? 0 : -1);
  let v = ms(e.collection);
  return {
    collectionProps: L(I, {
      tabIndex: D,
      "data-collection": v
    })
  };
}
function Ps(t) {
  let { id: e, selectionManager: n, key: l, ref: i, shouldSelectOnPressUp: r, shouldUseVirtualFocus: o, focus: u, isDisabled: s, onAction: c, allowsDifferentPressOrigin: f, linkBehavior: d = "action" } = t, p = Ze();
  e = ae(e);
  let h = (y) => {
    if (y.pointerType === "keyboard" && rn(y)) n.toggleSelection(l);
    else {
      if (n.selectionMode === "none") return;
      if (n.isLink(l)) {
        if (d === "selection" && i.current) {
          let j = n.getItemProps(l);
          p.open(i.current, y, j.href, j.routerOptions), n.setSelectedKeys(n.selectedKeys);
          return;
        } else if (d === "override" || d === "none") return;
      }
      n.selectionMode === "single" ? n.isSelected(l) && !n.disallowEmptySelection ? n.toggleSelection(l) : n.replaceSelection(l) : y && y.shiftKey ? n.extendSelection(l) : n.selectionBehavior === "toggle" || y && (Ie(y) || y.pointerType === "touch" || y.pointerType === "virtual") ? n.toggleSelection(l) : n.replaceSelection(l);
    }
  };
  O(() => {
    l === n.focusedKey && n.isFocused && (o ? ii(i.current) : u ? u() : document.activeElement !== i.current && i.current && ue(i.current));
  }, [
    i,
    l,
    n.focusedKey,
    n.childFocusStrategy,
    n.isFocused,
    o
  ]), s = s || n.isDisabled(l);
  let b = {};
  !o && !s ? b = {
    tabIndex: l === n.focusedKey ? 0 : -1,
    onFocus(y) {
      y.target === i.current && n.setFocusedKey(l);
    }
  } : s && (b.onMouseDown = (y) => {
    y.preventDefault();
  });
  let x = n.isLink(l) && d === "override", m = n.isLink(l) && d !== "selection" && d !== "none", g = !s && n.canSelectItem(l) && !x, E = (c || m) && !s, T = E && (n.selectionBehavior === "replace" ? !g : !g || n.isEmpty), K = E && g && n.selectionBehavior === "replace", F = T || K, B = k(null), N = F && g, R = k(!1), G = k(!1), M = n.getItemProps(l), a = (y) => {
    c && c(), m && i.current && p.open(i.current, y, M.href, M.routerOptions);
  }, w = {
    ref: i
  };
  if (r ? (w.onPressStart = (y) => {
    B.current = y.pointerType, R.current = N, y.pointerType === "keyboard" && (!F || al()) && h(y);
  }, f ? (w.onPressUp = T ? void 0 : (y) => {
    y.pointerType === "mouse" && g && h(y);
  }, w.onPress = T ? a : (y) => {
    y.pointerType !== "keyboard" && y.pointerType !== "mouse" && g && h(y);
  }) : w.onPress = (y) => {
    if (T || K && y.pointerType !== "mouse") {
      if (y.pointerType === "keyboard" && !sl()) return;
      a(y);
    } else y.pointerType !== "keyboard" && g && h(y);
  }) : (w.onPressStart = (y) => {
    B.current = y.pointerType, R.current = N, G.current = T, g && (y.pointerType === "mouse" && !T || y.pointerType === "keyboard" && (!E || al())) && h(y);
  }, w.onPress = (y) => {
    (y.pointerType === "touch" || y.pointerType === "pen" || y.pointerType === "virtual" || y.pointerType === "keyboard" && F && sl() || y.pointerType === "mouse" && G.current) && (F ? a(y) : g && h(y));
  }), b["data-collection"] = ys(n.collection), b["data-key"] = l, w.preventFocusOnPress = o, o && (w = L(w, {
    onPressStart(y) {
      y.pointerType !== "touch" && (n.setFocused(!0), n.setFocusedKey(l));
    },
    onPress(y) {
      y.pointerType === "touch" && (n.setFocused(!0), n.setFocusedKey(l));
    }
  })), M)
    for (let y of [
      "onPressStart",
      "onPressEnd",
      "onPressChange",
      "onPress",
      "onPressUp",
      "onClick"
    ]) M[y] && (w[y] = Xe(w[y], M[y]));
  let { pressProps: I, isPressed: P } = Ct(w), D = K ? (y) => {
    B.current === "mouse" && (y.stopPropagation(), y.preventDefault(), a(y));
  } : void 0, { longPressProps: v } = fu({
    isDisabled: !N,
    onLongPress(y) {
      y.pointerType === "touch" && (h(y), n.setSelectionBehavior("toggle"));
    }
  }), $ = (y) => {
    B.current === "touch" && R.current && y.preventDefault();
  }, S = d !== "none" && n.isLink(l) ? (y) => {
    ye.isOpening || y.preventDefault();
  } : void 0;
  return {
    itemProps: L(
      b,
      g || T || o && !s ? I : {},
      N ? v : {},
      {
        onDoubleClick: D,
        onDragStartCapture: $,
        onClick: S,
        id: e
      },
      // Prevent DOM focus from moving on mouse down when using virtual focus
      o ? {
        onMouseDown: (y) => y.preventDefault()
      } : void 0
    ),
    isPressed: P,
    isSelected: n.isSelected(l),
    isFocused: n.isFocused && n.focusedKey === l,
    isDisabled: s,
    allowsSelection: g,
    hasAction: F
  };
}
function sl() {
  let t = window.event;
  return t?.key === "Enter";
}
function al() {
  let t = window.event;
  return t?.key === " " || t?.code === "Space";
}
class cl {
  getItemRect(e) {
    let n = this.ref.current;
    if (!n) return null;
    let l = e != null ? ct(this.ref, e) : null;
    if (!l) return null;
    let i = n.getBoundingClientRect(), r = l.getBoundingClientRect();
    return {
      x: r.left - i.left + n.scrollLeft,
      y: r.top - i.top + n.scrollTop,
      width: r.width,
      height: r.height
    };
  }
  getContentSize() {
    let e = this.ref.current;
    var n, l;
    return {
      width: (n = e?.scrollWidth) !== null && n !== void 0 ? n : 0,
      height: (l = e?.scrollHeight) !== null && l !== void 0 ? l : 0
    };
  }
  getVisibleRect() {
    let e = this.ref.current;
    var n, l, i, r;
    return {
      x: (n = e?.scrollLeft) !== null && n !== void 0 ? n : 0,
      y: (l = e?.scrollTop) !== null && l !== void 0 ? l : 0,
      width: (i = e?.offsetWidth) !== null && i !== void 0 ? i : 0,
      height: (r = e?.offsetHeight) !== null && r !== void 0 ? r : 0
    };
  }
  constructor(e) {
    this.ref = e;
  }
}
class ci {
  isDisabled(e) {
    var n;
    return this.disabledBehavior === "all" && (((n = e.props) === null || n === void 0 ? void 0 : n.isDisabled) || this.disabledKeys.has(e.key));
  }
  findNextNonDisabled(e, n) {
    let l = e;
    for (; l != null; ) {
      let i = this.collection.getItem(l);
      if (i?.type === "item" && !this.isDisabled(i)) return l;
      l = n(l);
    }
    return null;
  }
  getNextKey(e) {
    let n = e;
    return n = this.collection.getKeyAfter(n), this.findNextNonDisabled(n, (l) => this.collection.getKeyAfter(l));
  }
  getPreviousKey(e) {
    let n = e;
    return n = this.collection.getKeyBefore(n), this.findNextNonDisabled(n, (l) => this.collection.getKeyBefore(l));
  }
  findKey(e, n, l) {
    let i = e, r = this.layoutDelegate.getItemRect(i);
    if (!r || i == null) return null;
    let o = r;
    do {
      if (i = n(i), i == null) break;
      r = this.layoutDelegate.getItemRect(i);
    } while (r && l(o, r) && i != null);
    return i;
  }
  isSameRow(e, n) {
    return e.y === n.y || e.x !== n.x;
  }
  isSameColumn(e, n) {
    return e.x === n.x || e.y !== n.y;
  }
  getKeyBelow(e) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(e, (n) => this.getNextKey(n), this.isSameRow) : this.getNextKey(e);
  }
  getKeyAbove(e) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(e, (n) => this.getPreviousKey(n), this.isSameRow) : this.getPreviousKey(e);
  }
  getNextColumn(e, n) {
    return n ? this.getPreviousKey(e) : this.getNextKey(e);
  }
  getKeyRightOf(e) {
    let n = this.direction === "ltr" ? "getKeyRightOf" : "getKeyLeftOf";
    return this.layoutDelegate[n] ? (e = this.layoutDelegate[n](e), this.findNextNonDisabled(e, (l) => this.layoutDelegate[n](l))) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(e, this.direction === "rtl") : this.findKey(e, (l) => this.getNextColumn(l, this.direction === "rtl"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(e, this.direction === "rtl") : null;
  }
  getKeyLeftOf(e) {
    let n = this.direction === "ltr" ? "getKeyLeftOf" : "getKeyRightOf";
    return this.layoutDelegate[n] ? (e = this.layoutDelegate[n](e), this.findNextNonDisabled(e, (l) => this.layoutDelegate[n](l))) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(e, this.direction === "ltr") : this.findKey(e, (l) => this.getNextColumn(l, this.direction === "ltr"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(e, this.direction === "ltr") : null;
  }
  getFirstKey() {
    let e = this.collection.getFirstKey();
    return this.findNextNonDisabled(e, (n) => this.collection.getKeyAfter(n));
  }
  getLastKey() {
    let e = this.collection.getLastKey();
    return this.findNextNonDisabled(e, (n) => this.collection.getKeyBefore(n));
  }
  getKeyPageAbove(e) {
    let n = this.ref.current, l = this.layoutDelegate.getItemRect(e);
    if (!l) return null;
    if (n && !_e(n)) return this.getFirstKey();
    let i = e;
    if (this.orientation === "horizontal") {
      let r = Math.max(0, l.x + l.width - this.layoutDelegate.getVisibleRect().width);
      for (; l && l.x > r && i != null; )
        i = this.getKeyAbove(i), l = i == null ? null : this.layoutDelegate.getItemRect(i);
    } else {
      let r = Math.max(0, l.y + l.height - this.layoutDelegate.getVisibleRect().height);
      for (; l && l.y > r && i != null; )
        i = this.getKeyAbove(i), l = i == null ? null : this.layoutDelegate.getItemRect(i);
    }
    return i ?? this.getFirstKey();
  }
  getKeyPageBelow(e) {
    let n = this.ref.current, l = this.layoutDelegate.getItemRect(e);
    if (!l) return null;
    if (n && !_e(n)) return this.getLastKey();
    let i = e;
    if (this.orientation === "horizontal") {
      let r = Math.min(this.layoutDelegate.getContentSize().width, l.y - l.width + this.layoutDelegate.getVisibleRect().width);
      for (; l && l.x < r && i != null; )
        i = this.getKeyBelow(i), l = i == null ? null : this.layoutDelegate.getItemRect(i);
    } else {
      let r = Math.min(this.layoutDelegate.getContentSize().height, l.y - l.height + this.layoutDelegate.getVisibleRect().height);
      for (; l && l.y < r && i != null; )
        i = this.getKeyBelow(i), l = i == null ? null : this.layoutDelegate.getItemRect(i);
    }
    return i ?? this.getLastKey();
  }
  getKeyForSearch(e, n) {
    if (!this.collator) return null;
    let l = this.collection, i = n || this.getFirstKey();
    for (; i != null; ) {
      let r = l.getItem(i);
      if (!r) return null;
      let o = r.textValue.slice(0, e.length);
      if (r.textValue && this.collator.compare(o, e) === 0) return i;
      i = this.getNextKey(i);
    }
    return null;
  }
  constructor(...e) {
    if (e.length === 1) {
      let n = e[0];
      this.collection = n.collection, this.ref = n.ref, this.collator = n.collator, this.disabledKeys = n.disabledKeys || /* @__PURE__ */ new Set(), this.disabledBehavior = n.disabledBehavior || "all", this.orientation = n.orientation || "vertical", this.direction = n.direction, this.layout = n.layout || "stack", this.layoutDelegate = n.layoutDelegate || new cl(n.ref);
    } else
      this.collection = e[0], this.disabledKeys = e[1], this.ref = e[2], this.collator = e[3], this.layout = "stack", this.orientation = "vertical", this.disabledBehavior = "all", this.layoutDelegate = new cl(this.ref);
    this.layout === "stack" && this.orientation === "vertical" && (this.getKeyLeftOf = void 0, this.getKeyRightOf = void 0);
  }
}
function Cs(t) {
  let { selectionManager: e, collection: n, disabledKeys: l, ref: i, keyboardDelegate: r, layoutDelegate: o } = t, u = Uu({
    usage: "search",
    sensitivity: "base"
  }), s = e.disabledBehavior, c = V(() => r || new ci({
    collection: n,
    disabledKeys: l,
    disabledBehavior: s,
    ref: i,
    collator: u,
    layoutDelegate: o
  }), [
    r,
    o,
    n,
    l,
    i,
    u,
    s
  ]), { collectionProps: f } = Ss({
    ...t,
    ref: i,
    selectionManager: e,
    keyboardDelegate: c
  });
  return {
    listProps: f
  };
}
class ws {
  build(e, n) {
    return this.context = n, dl(() => this.iterateCollection(e));
  }
  *iterateCollection(e) {
    let { children: n, items: l } = e;
    if (C.isValidElement(n) && n.type === C.Fragment) yield* this.iterateCollection({
      children: n.props.children,
      items: l
    });
    else if (typeof n == "function") {
      if (!l) throw new Error("props.children was a function but props.items is missing");
      let i = 0;
      for (let r of l)
        yield* this.getFullNode({
          value: r,
          index: i
        }, {
          renderer: n
        }), i++;
    } else {
      let i = [];
      C.Children.forEach(n, (o) => {
        o && i.push(o);
      });
      let r = 0;
      for (let o of i) {
        let u = this.getFullNode({
          element: o,
          index: r
        }, {});
        for (let s of u)
          r++, yield s;
      }
    }
  }
  getKey(e, n, l, i) {
    if (e.key != null) return e.key;
    if (n.type === "cell" && n.key != null) return `${i}${n.key}`;
    let r = n.value;
    if (r != null) {
      var o;
      let u = (o = r.key) !== null && o !== void 0 ? o : r.id;
      if (u == null) throw new Error("No key found for item");
      return u;
    }
    return i ? `${i}.${n.index}` : `$.${n.index}`;
  }
  getChildState(e, n) {
    return {
      renderer: n.renderer || e.renderer
    };
  }
  *getFullNode(e, n, l, i) {
    if (C.isValidElement(e.element) && e.element.type === C.Fragment) {
      let m = [];
      C.Children.forEach(e.element.props.children, (E) => {
        m.push(E);
      });
      var r;
      let g = (r = e.index) !== null && r !== void 0 ? r : 0;
      for (const E of m) yield* this.getFullNode({
        element: E,
        index: g++
      }, n, l, i);
      return;
    }
    let o = e.element;
    if (!o && e.value && n && n.renderer) {
      let m = this.cache.get(e.value);
      if (m && (!m.shouldInvalidate || !m.shouldInvalidate(this.context))) {
        m.index = e.index, m.parentKey = i ? i.key : null, yield m;
        return;
      }
      o = n.renderer(e.value);
    }
    if (C.isValidElement(o)) {
      let m = o.type;
      if (typeof m != "function" && typeof m.getCollectionNode != "function") {
        let K = o.type;
        throw new Error(`Unknown element <${K}> in collection.`);
      }
      let g = m.getCollectionNode(o.props, this.context);
      var u;
      let E = (u = e.index) !== null && u !== void 0 ? u : 0, T = g.next();
      for (; !T.done && T.value; ) {
        let K = T.value;
        e.index = E;
        var s;
        let F = (s = K.key) !== null && s !== void 0 ? s : null;
        F == null && (F = K.element ? null : this.getKey(o, e, n, l));
        let N = [
          ...this.getFullNode({
            ...K,
            key: F,
            index: E,
            wrapper: Ds(e.wrapper, K.wrapper)
          }, this.getChildState(n, K), l ? `${l}${o.key}` : o.key, i)
        ];
        for (let R of N) {
          var c, f;
          R.value = (f = (c = K.value) !== null && c !== void 0 ? c : e.value) !== null && f !== void 0 ? f : null, R.value && this.cache.set(R.value, R);
          var d;
          if (e.type && R.type !== e.type) throw new Error(`Unsupported type <${jt(R.type)}> in <${jt((d = i?.type) !== null && d !== void 0 ? d : "unknown parent type")}>. Only <${jt(e.type)}> is supported.`);
          E++, yield R;
        }
        T = g.next(N);
      }
      return;
    }
    if (e.key == null || e.type == null) return;
    let p = this;
    var h, b;
    let x = {
      type: e.type,
      props: e.props,
      key: e.key,
      parentKey: i ? i.key : null,
      value: (h = e.value) !== null && h !== void 0 ? h : null,
      level: i ? i.level + 1 : 0,
      index: e.index,
      rendered: e.rendered,
      textValue: (b = e.textValue) !== null && b !== void 0 ? b : "",
      "aria-label": e["aria-label"],
      wrapper: e.wrapper,
      shouldInvalidate: e.shouldInvalidate,
      hasChildNodes: e.hasChildNodes || !1,
      childNodes: dl(function* () {
        if (!e.hasChildNodes || !e.childNodes) return;
        let m = 0;
        for (let g of e.childNodes()) {
          g.key != null && (g.key = `${x.key}${g.key}`);
          let E = p.getFullNode({
            ...g,
            index: m
          }, p.getChildState(n, g), x.key, x);
          for (let T of E)
            m++, yield T;
        }
      })
    };
    yield x;
  }
  constructor() {
    this.cache = /* @__PURE__ */ new WeakMap();
  }
}
function dl(t) {
  let e = [], n = null;
  return {
    *[Symbol.iterator]() {
      for (let l of e) yield l;
      n || (n = t());
      for (let l of n)
        e.push(l), yield l;
    }
  };
}
function Ds(t, e) {
  if (t && e) return (n) => t(e(n));
  if (t) return t;
  if (e) return e;
}
function jt(t) {
  return t[0].toUpperCase() + t.slice(1);
}
function Ts(t, e, n) {
  let l = V(() => new ws(), []), { children: i, items: r, collection: o } = t;
  return V(() => {
    if (o) return o;
    let s = l.build({
      children: i,
      items: r
    }, n);
    return e(s);
  }, [
    l,
    i,
    r,
    o,
    n,
    e
  ]);
}
function ks(t, e) {
  return typeof e.getChildren == "function" ? e.getChildren(t.key) : t.childNodes;
}
function Ks(t) {
  return Bs(t);
}
function Bs(t, e) {
  for (let n of t)
    return n;
}
function Ut(t, e, n) {
  if (e.parentKey === n.parentKey) return e.index - n.index;
  let l = [
    ...fl(t, e),
    e
  ], i = [
    ...fl(t, n),
    n
  ], r = l.slice(0, i.length).findIndex((o, u) => o !== i[u]);
  return r !== -1 ? (e = l[r], n = i[r], e.index - n.index) : l.findIndex((o) => o === n) >= 0 ? 1 : (i.findIndex((o) => o === e) >= 0, -1);
}
function fl(t, e) {
  let n = [], l = e;
  for (; l?.parentKey != null; )
    l = t.getItem(l.parentKey), l && n.unshift(l);
  return n;
}
const Sn = /* @__PURE__ */ new WeakMap();
function pl(t, e) {
  var n;
  let { id: l } = (n = Sn.get(t)) !== null && n !== void 0 ? n : {};
  if (!l) throw new Error("Unknown list");
  return `${l}-${As(e)}`;
}
function As(t) {
  return typeof t == "string" ? t.replace(/\s*/g, "") : "" + t;
}
var di = {};
di = {
  deselectedItem: (t) => `${t.item} غير المحدد`,
  longPressToSelect: "اضغط مطولًا للدخول إلى وضع التحديد.",
  select: "تحديد",
  selectedAll: "جميع العناصر المحددة.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "لم يتم تحديد عناصر",
    one: () => `${e.number(t.count)} عنصر محدد`,
    other: () => `${e.number(t.count)} عنصر محدد`
  })}.`,
  selectedItem: (t) => `${t.item} المحدد`
};
var fi = {};
fi = {
  deselectedItem: (t) => `${t.item} не е избран.`,
  longPressToSelect: "Натиснете и задръжте за да влезете в избирателен режим.",
  select: "Изберете",
  selectedAll: "Всички елементи са избрани.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Няма избрани елементи",
    one: () => `${e.number(t.count)} избран елемент`,
    other: () => `${e.number(t.count)} избрани елементи`
  })}.`,
  selectedItem: (t) => `${t.item} избран.`
};
var pi = {};
pi = {
  deselectedItem: (t) => `Položka ${t.item} není vybrána.`,
  longPressToSelect: "Dlouhým stisknutím přejdete do režimu výběru.",
  select: "Vybrat",
  selectedAll: "Vybrány všechny položky.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nevybrány žádné položky",
    one: () => `Vybrána ${e.number(t.count)} položka`,
    other: () => `Vybráno ${e.number(t.count)} položek`
  })}.`,
  selectedItem: (t) => `Vybrána položka ${t.item}.`
};
var vi = {};
vi = {
  deselectedItem: (t) => `${t.item} ikke valgt.`,
  longPressToSelect: "Lav et langt tryk for at aktivere valgtilstand.",
  select: "Vælg",
  selectedAll: "Alle elementer valgt.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Ingen elementer valgt",
    one: () => `${e.number(t.count)} element valgt`,
    other: () => `${e.number(t.count)} elementer valgt`
  })}.`,
  selectedItem: (t) => `${t.item} valgt.`
};
var hi = {};
hi = {
  deselectedItem: (t) => `${t.item} nicht ausgewählt.`,
  longPressToSelect: "Gedrückt halten, um Auswahlmodus zu öffnen.",
  select: "Auswählen",
  selectedAll: "Alle Elemente ausgewählt.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Keine Elemente ausgewählt",
    one: () => `${e.number(t.count)} Element ausgewählt`,
    other: () => `${e.number(t.count)} Elemente ausgewählt`
  })}.`,
  selectedItem: (t) => `${t.item} ausgewählt.`
};
var bi = {};
bi = {
  deselectedItem: (t) => `Δεν επιλέχθηκε το στοιχείο ${t.item}.`,
  longPressToSelect: "Πατήστε παρατεταμένα για να μπείτε σε λειτουργία επιλογής.",
  select: "Επιλογή",
  selectedAll: "Επιλέχθηκαν όλα τα στοιχεία.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Δεν επιλέχθηκαν στοιχεία",
    one: () => `Επιλέχθηκε ${e.number(t.count)} στοιχείο`,
    other: () => `Επιλέχθηκαν ${e.number(t.count)} στοιχεία`
  })}.`,
  selectedItem: (t) => `Επιλέχθηκε το στοιχείο ${t.item}.`
};
var $i = {};
$i = {
  deselectedItem: (t) => `${t.item} not selected.`,
  select: "Select",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "No items selected",
    one: () => `${e.number(t.count)} item selected`,
    other: () => `${e.number(t.count)} items selected`
  })}.`,
  selectedAll: "All items selected.",
  selectedItem: (t) => `${t.item} selected.`,
  longPressToSelect: "Long press to enter selection mode."
};
var mi = {};
mi = {
  deselectedItem: (t) => `${t.item} no seleccionado.`,
  longPressToSelect: "Mantenga pulsado para abrir el modo de selección.",
  select: "Seleccionar",
  selectedAll: "Todos los elementos seleccionados.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Ningún elemento seleccionado",
    one: () => `${e.number(t.count)} elemento seleccionado`,
    other: () => `${e.number(t.count)} elementos seleccionados`
  })}.`,
  selectedItem: (t) => `${t.item} seleccionado.`
};
var yi = {};
yi = {
  deselectedItem: (t) => `${t.item} pole valitud.`,
  longPressToSelect: "Valikurežiimi sisenemiseks vajutage pikalt.",
  select: "Vali",
  selectedAll: "Kõik üksused valitud.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Üksusi pole valitud",
    one: () => `${e.number(t.count)} üksus valitud`,
    other: () => `${e.number(t.count)} üksust valitud`
  })}.`,
  selectedItem: (t) => `${t.item} valitud.`
};
var gi = {};
gi = {
  deselectedItem: (t) => `Kohdetta ${t.item} ei valittu.`,
  longPressToSelect: "Siirry valintatilaan painamalla pitkään.",
  select: "Valitse",
  selectedAll: "Kaikki kohteet valittu.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Ei yhtään kohdetta valittu",
    one: () => `${e.number(t.count)} kohde valittu`,
    other: () => `${e.number(t.count)} kohdetta valittu`
  })}.`,
  selectedItem: (t) => `${t.item} valittu.`
};
var xi = {};
xi = {
  deselectedItem: (t) => `${t.item} non sélectionné.`,
  longPressToSelect: "Appuyez de manière prolongée pour passer en mode de sélection.",
  select: "Sélectionner",
  selectedAll: "Tous les éléments sélectionnés.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Aucun élément sélectionné",
    one: () => `${e.number(t.count)} élément sélectionné`,
    other: () => `${e.number(t.count)} éléments sélectionnés`
  })}.`,
  selectedItem: (t) => `${t.item} sélectionné.`
};
var Ei = {};
Ei = {
  deselectedItem: (t) => `${t.item} לא נבחר.`,
  longPressToSelect: "הקשה ארוכה לכניסה למצב בחירה.",
  select: "בחר",
  selectedAll: "כל הפריטים נבחרו.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "לא נבחרו פריטים",
    one: () => `פריט ${e.number(t.count)} נבחר`,
    other: () => `${e.number(t.count)} פריטים נבחרו`
  })}.`,
  selectedItem: (t) => `${t.item} נבחר.`
};
var Si = {};
Si = {
  deselectedItem: (t) => `Stavka ${t.item} nije odabrana.`,
  longPressToSelect: "Dugo pritisnite za ulazak u način odabira.",
  select: "Odaberite",
  selectedAll: "Odabrane su sve stavke.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nije odabrana nijedna stavka",
    one: () => `Odabrana je ${e.number(t.count)} stavka`,
    other: () => `Odabrano je ${e.number(t.count)} stavki`
  })}.`,
  selectedItem: (t) => `Stavka ${t.item} je odabrana.`
};
var Pi = {};
Pi = {
  deselectedItem: (t) => `${t.item} nincs kijelölve.`,
  longPressToSelect: "Nyomja hosszan a kijelöléshez.",
  select: "Kijelölés",
  selectedAll: "Az összes elem kijelölve.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Egy elem sincs kijelölve",
    one: () => `${e.number(t.count)} elem kijelölve`,
    other: () => `${e.number(t.count)} elem kijelölve`
  })}.`,
  selectedItem: (t) => `${t.item} kijelölve.`
};
var Ci = {};
Ci = {
  deselectedItem: (t) => `${t.item} non selezionato.`,
  longPressToSelect: "Premi a lungo per passare alla modalità di selezione.",
  select: "Seleziona",
  selectedAll: "Tutti gli elementi selezionati.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nessun elemento selezionato",
    one: () => `${e.number(t.count)} elemento selezionato`,
    other: () => `${e.number(t.count)} elementi selezionati`
  })}.`,
  selectedItem: (t) => `${t.item} selezionato.`
};
var wi = {};
wi = {
  deselectedItem: (t) => `${t.item} が選択されていません。`,
  longPressToSelect: "長押しして選択モードを開きます。",
  select: "選択",
  selectedAll: "すべての項目を選択しました。",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "項目が選択されていません",
    one: () => `${e.number(t.count)} 項目を選択しました`,
    other: () => `${e.number(t.count)} 項目を選択しました`
  })}。`,
  selectedItem: (t) => `${t.item} を選択しました。`
};
var Di = {};
Di = {
  deselectedItem: (t) => `${t.item}이(가) 선택되지 않았습니다.`,
  longPressToSelect: "선택 모드로 들어가려면 길게 누르십시오.",
  select: "선택",
  selectedAll: "모든 항목이 선택되었습니다.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "선택된 항목이 없습니다",
    one: () => `${e.number(t.count)}개 항목이 선택되었습니다`,
    other: () => `${e.number(t.count)}개 항목이 선택되었습니다`
  })}.`,
  selectedItem: (t) => `${t.item}이(가) 선택되었습니다.`
};
var Ti = {};
Ti = {
  deselectedItem: (t) => `${t.item} nepasirinkta.`,
  longPressToSelect: "Norėdami įjungti pasirinkimo režimą, paspauskite ir palaikykite.",
  select: "Pasirinkti",
  selectedAll: "Pasirinkti visi elementai.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nepasirinktas nė vienas elementas",
    one: () => `Pasirinktas ${e.number(t.count)} elementas`,
    other: () => `Pasirinkta elementų: ${e.number(t.count)}`
  })}.`,
  selectedItem: (t) => `Pasirinkta: ${t.item}.`
};
var ki = {};
ki = {
  deselectedItem: (t) => `Vienums ${t.item} nav atlasīts.`,
  longPressToSelect: "Ilgi turiet nospiestu. lai ieslēgtu atlases režīmu.",
  select: "Atlasīt",
  selectedAll: "Atlasīti visi vienumi.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nav atlasīts neviens vienums",
    one: () => `Atlasīto vienumu skaits: ${e.number(t.count)}`,
    other: () => `Atlasīto vienumu skaits: ${e.number(t.count)}`
  })}.`,
  selectedItem: (t) => `Atlasīts vienums ${t.item}.`
};
var Ki = {};
Ki = {
  deselectedItem: (t) => `${t.item} er ikke valgt.`,
  longPressToSelect: "Bruk et langt trykk for å gå inn i valgmodus.",
  select: "Velg",
  selectedAll: "Alle elementer er valgt.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Ingen elementer er valgt",
    one: () => `${e.number(t.count)} element er valgt`,
    other: () => `${e.number(t.count)} elementer er valgt`
  })}.`,
  selectedItem: (t) => `${t.item} er valgt.`
};
var Bi = {};
Bi = {
  deselectedItem: (t) => `${t.item} niet geselecteerd.`,
  longPressToSelect: "Druk lang om de selectiemodus te openen.",
  select: "Selecteren",
  selectedAll: "Alle items geselecteerd.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Geen items geselecteerd",
    one: () => `${e.number(t.count)} item geselecteerd`,
    other: () => `${e.number(t.count)} items geselecteerd`
  })}.`,
  selectedItem: (t) => `${t.item} geselecteerd.`
};
var Ai = {};
Ai = {
  deselectedItem: (t) => `Nie zaznaczono ${t.item}.`,
  longPressToSelect: "Naciśnij i przytrzymaj, aby wejść do trybu wyboru.",
  select: "Zaznacz",
  selectedAll: "Wszystkie zaznaczone elementy.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nie zaznaczono żadnych elementów",
    one: () => `${e.number(t.count)} zaznaczony element`,
    other: () => `${e.number(t.count)} zaznaczonych elementów`
  })}.`,
  selectedItem: (t) => `Zaznaczono ${t.item}.`
};
var Fi = {};
Fi = {
  deselectedItem: (t) => `${t.item} não selecionado.`,
  longPressToSelect: "Mantenha pressionado para entrar no modo de seleção.",
  select: "Selecionar",
  selectedAll: "Todos os itens selecionados.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nenhum item selecionado",
    one: () => `${e.number(t.count)} item selecionado`,
    other: () => `${e.number(t.count)} itens selecionados`
  })}.`,
  selectedItem: (t) => `${t.item} selecionado.`
};
var Ii = {};
Ii = {
  deselectedItem: (t) => `${t.item} não selecionado.`,
  longPressToSelect: "Prima continuamente para entrar no modo de seleção.",
  select: "Selecionar",
  selectedAll: "Todos os itens selecionados.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nenhum item selecionado",
    one: () => `${e.number(t.count)} item selecionado`,
    other: () => `${e.number(t.count)} itens selecionados`
  })}.`,
  selectedItem: (t) => `${t.item} selecionado.`
};
var Li = {};
Li = {
  deselectedItem: (t) => `${t.item} neselectat.`,
  longPressToSelect: "Apăsați lung pentru a intra în modul de selectare.",
  select: "Selectare",
  selectedAll: "Toate elementele selectate.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Niciun element selectat",
    one: () => `${e.number(t.count)} element selectat`,
    other: () => `${e.number(t.count)} elemente selectate`
  })}.`,
  selectedItem: (t) => `${t.item} selectat.`
};
var Mi = {};
Mi = {
  deselectedItem: (t) => `${t.item} не выбрано.`,
  longPressToSelect: "Нажмите и удерживайте для входа в режим выбора.",
  select: "Выбрать",
  selectedAll: "Выбраны все элементы.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Нет выбранных элементов",
    one: () => `${e.number(t.count)} элемент выбран`,
    other: () => `${e.number(t.count)} элементов выбрано`
  })}.`,
  selectedItem: (t) => `${t.item} выбрано.`
};
var Ni = {};
Ni = {
  deselectedItem: (t) => `Nevybraté položky: ${t.item}.`,
  longPressToSelect: "Dlhším stlačením prejdite do režimu výberu.",
  select: "Vybrať",
  selectedAll: "Všetky vybraté položky.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Žiadne vybraté položky",
    one: () => `${e.number(t.count)} vybratá položka`,
    other: () => `Počet vybratých položiek:${e.number(t.count)}`
  })}.`,
  selectedItem: (t) => `Vybraté položky: ${t.item}.`
};
var Ri = {};
Ri = {
  deselectedItem: (t) => `Element ${t.item} ni izbran.`,
  longPressToSelect: "Za izbirni način pritisnite in dlje časa držite.",
  select: "Izberite",
  selectedAll: "Vsi elementi so izbrani.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Noben element ni izbran",
    one: () => `${e.number(t.count)} element je izbran`,
    other: () => `${e.number(t.count)} elementov je izbranih`
  })}.`,
  selectedItem: (t) => `Element ${t.item} je izbran.`
};
var Oi = {};
Oi = {
  deselectedItem: (t) => `${t.item} nije izabrano.`,
  longPressToSelect: "Dugo pritisnite za ulazak u režim biranja.",
  select: "Izaberite",
  selectedAll: "Izabrane su sve stavke.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nije izabrana nijedna stavka",
    one: () => `Izabrana je ${e.number(t.count)} stavka`,
    other: () => `Izabrano je ${e.number(t.count)} stavki`
  })}.`,
  selectedItem: (t) => `${t.item} je izabrano.`
};
var zi = {};
zi = {
  deselectedItem: (t) => `${t.item} ej markerat.`,
  longPressToSelect: "Tryck länge när du vill öppna väljarläge.",
  select: "Markera",
  selectedAll: "Alla markerade objekt.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Inga markerade objekt",
    one: () => `${e.number(t.count)} markerat objekt`,
    other: () => `${e.number(t.count)} markerade objekt`
  })}.`,
  selectedItem: (t) => `${t.item} markerat.`
};
var Hi = {};
Hi = {
  deselectedItem: (t) => `${t.item} seçilmedi.`,
  longPressToSelect: "Seçim moduna girmek için uzun basın.",
  select: "Seç",
  selectedAll: "Tüm ögeler seçildi.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Hiçbir öge seçilmedi",
    one: () => `${e.number(t.count)} öge seçildi`,
    other: () => `${e.number(t.count)} öge seçildi`
  })}.`,
  selectedItem: (t) => `${t.item} seçildi.`
};
var Vi = {};
Vi = {
  deselectedItem: (t) => `${t.item} не вибрано.`,
  longPressToSelect: "Виконайте довге натиснення, щоб перейти в режим вибору.",
  select: "Вибрати",
  selectedAll: "Усі елементи вибрано.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Жодних елементів не вибрано",
    one: () => `${e.number(t.count)} елемент вибрано`,
    other: () => `Вибрано елементів: ${e.number(t.count)}`
  })}.`,
  selectedItem: (t) => `${t.item} вибрано.`
};
var ji = {};
ji = {
  deselectedItem: (t) => `未选择 ${t.item}。`,
  longPressToSelect: "长按以进入选择模式。",
  select: "选择",
  selectedAll: "已选择所有项目。",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "未选择项目",
    one: () => `已选择 ${e.number(t.count)} 个项目`,
    other: () => `已选择 ${e.number(t.count)} 个项目`
  })}。`,
  selectedItem: (t) => `已选择 ${t.item}。`
};
var Ui = {};
Ui = {
  deselectedItem: (t) => `未選取「${t.item}」。`,
  longPressToSelect: "長按以進入選擇模式。",
  select: "選取",
  selectedAll: "已選取所有項目。",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "未選取任何項目",
    one: () => `已選取 ${e.number(t.count)} 個項目`,
    other: () => `已選取 ${e.number(t.count)} 個項目`
  })}。`,
  selectedItem: (t) => `已選取「${t.item}」。`
};
var Pn = {};
Pn = {
  "ar-AE": di,
  "bg-BG": fi,
  "cs-CZ": pi,
  "da-DK": vi,
  "de-DE": hi,
  "el-GR": bi,
  "en-US": $i,
  "es-ES": mi,
  "et-EE": yi,
  "fi-FI": gi,
  "fr-FR": xi,
  "he-IL": Ei,
  "hr-HR": Si,
  "hu-HU": Pi,
  "it-IT": Ci,
  "ja-JP": wi,
  "ko-KR": Di,
  "lt-LT": Ti,
  "lv-LV": ki,
  "nb-NO": Ki,
  "nl-NL": Bi,
  "pl-PL": Ai,
  "pt-BR": Fi,
  "pt-PT": Ii,
  "ro-RO": Li,
  "ru-RU": Mi,
  "sk-SK": Ni,
  "sl-SI": Ri,
  "sr-SP": Oi,
  "sv-SE": zi,
  "tr-TR": Hi,
  "uk-UA": Vi,
  "zh-CN": ji,
  "zh-TW": Ui
};
function Fs(t) {
  return t && t.__esModule ? t.default : t;
}
function Is(t, e) {
  let { getRowText: n = (u) => {
    var s, c, f, d;
    return (d = (s = (c = e.collection).getTextValue) === null || s === void 0 ? void 0 : s.call(c, u)) !== null && d !== void 0 ? d : (f = e.collection.getItem(u)) === null || f === void 0 ? void 0 : f.textValue;
  } } = t, l = xn(Fs(Pn), "@react-aria/grid"), i = e.selectionManager.rawSelection, r = k(i), o = ne(() => {
    var u;
    if (!e.selectionManager.isFocused || i === r.current) {
      r.current = i;
      return;
    }
    let s = vl(i, r.current), c = vl(r.current, i), f = e.selectionManager.selectionBehavior === "replace", d = [];
    if (e.selectionManager.selectedKeys.size === 1 && f) {
      let p = e.selectionManager.selectedKeys.keys().next().value;
      if (p != null && e.collection.getItem(p)) {
        let h = n(p);
        h && d.push(l.format("selectedItem", {
          item: h
        }));
      }
    } else if (s.size === 1 && c.size === 0) {
      let p = s.keys().next().value;
      if (p != null) {
        let h = n(p);
        h && d.push(l.format("selectedItem", {
          item: h
        }));
      }
    } else if (c.size === 1 && s.size === 0) {
      let p = c.keys().next().value;
      if (p != null && e.collection.getItem(p)) {
        let h = n(p);
        h && d.push(l.format("deselectedItem", {
          item: h
        }));
      }
    }
    e.selectionManager.selectionMode === "multiple" && (d.length === 0 || i === "all" || i.size > 1 || r.current === "all" || ((u = r.current) === null || u === void 0 ? void 0 : u.size) > 1) && d.push(i === "all" ? l.format("selectedAll") : l.format("selectedCount", {
      count: i.size
    })), d.length > 0 && tn(d.join(" ")), r.current = i;
  });
  Eo(() => {
    if (e.selectionManager.isFocused) o();
    else {
      let u = requestAnimationFrame(o);
      return () => cancelAnimationFrame(u);
    }
  }, [
    i,
    e.selectionManager.isFocused
  ]);
}
function vl(t, e) {
  let n = /* @__PURE__ */ new Set();
  if (t === "all" || e === "all") return n;
  for (let l of t.keys()) e.has(l) || n.add(l);
  return n;
}
function Ls(t) {
  return t && t.__esModule ? t.default : t;
}
function Ms(t) {
  let e = xn(Ls(Pn), "@react-aria/grid"), n = Yl(), l = (n === "pointer" || n === "virtual" || n == null) && typeof window < "u" && "ontouchstart" in window, i = V(() => {
    let o = t.selectionManager.selectionMode, u = t.selectionManager.selectionBehavior, s;
    return l && (s = e.format("longPressToSelect")), u === "replace" && o !== "none" && t.hasItemActions ? s : void 0;
  }, [
    t.selectionManager.selectionMode,
    t.selectionManager.selectionBehavior,
    t.hasItemActions,
    e,
    l
  ]);
  return an(i);
}
function Ns(t, e, n) {
  let { isVirtualized: l, keyboardDelegate: i, layoutDelegate: r, onAction: o, disallowTypeAhead: u, linkBehavior: s = "action", keyboardNavigationBehavior: c = "arrow", escapeKeyBehavior: f = "clearSelection", shouldSelectOnPressUp: d } = t;
  !t["aria-label"] && !t["aria-labelledby"] && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let { listProps: p } = Cs({
    selectionManager: e.selectionManager,
    collection: e.collection,
    disabledKeys: e.disabledKeys,
    ref: n,
    keyboardDelegate: i,
    layoutDelegate: r,
    isVirtualized: l,
    selectOnFocus: e.selectionManager.selectionBehavior === "replace",
    shouldFocusWrap: t.shouldFocusWrap,
    linkBehavior: s,
    disallowTypeAhead: u,
    autoFocus: t.autoFocus,
    escapeKeyBehavior: f
  }), h = ae(t.id);
  Sn.set(e, {
    id: h,
    onAction: o,
    linkBehavior: s,
    keyboardNavigationBehavior: c,
    shouldSelectOnPressUp: d
  });
  let b = Ms({
    selectionManager: e.selectionManager,
    hasItemActions: !!o
  }), x = _u(n, {
    isDisabled: e.collection.size !== 0
  }), m = ee(t, {
    labelable: !0
  }), g = L(
    m,
    {
      role: "grid",
      id: h,
      "aria-multiselectable": e.selectionManager.selectionMode === "multiple" ? "true" : void 0
    },
    // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    e.collection.size === 0 ? {
      tabIndex: x ? -1 : 0
    } : p,
    b
  );
  return l && (g["aria-rowcount"] = e.collection.size, g["aria-colcount"] = 1), Is({}, e), {
    gridProps: g
  };
}
const hl = {
  expand: {
    ltr: "ArrowRight",
    rtl: "ArrowLeft"
  },
  collapse: {
    ltr: "ArrowLeft",
    rtl: "ArrowRight"
  }
};
function Rs(t, e, n) {
  var l, i;
  let { node: r, isVirtualized: o } = t, { direction: u } = Ae(), { onAction: s, linkBehavior: c, keyboardNavigationBehavior: f, shouldSelectOnPressUp: d } = Sn.get(e), p = Wt(), h = k(null), b = () => {
    var D;
    n.current !== null && (h.current != null && r.key !== h.current || !(!((D = n.current) === null || D === void 0) && D.contains(document.activeElement))) && ue(n.current);
  }, x = {}, m = t.hasChildItems, g = e.selectionManager.isLink(r.key);
  if (r != null && "expandedKeys" in e) {
    var E, T;
    let D = (E = (T = e.collection).getChildren) === null || E === void 0 ? void 0 : E.call(T, r.key);
    m = m || [
      ...D ?? []
    ].length > 1, s == null && !g && e.selectionManager.selectionMode === "none" && m && (s = () => e.toggleKey(r.key));
    let v = m ? e.expandedKeys.has(r.key) : void 0, $ = 1;
    if (r.level > 0 && r?.parentKey != null) {
      let S = e.collection.getItem(r.parentKey);
      if (S) {
        var K, F;
        $ = [
          ...(K = (F = e.collection).getChildren) === null || K === void 0 ? void 0 : K.call(F, S.key)
        ].filter((j) => j.type === "item").length;
      }
    } else $ = [
      ...e.collection
    ].filter((S) => S.level === 0 && S.type === "item").length;
    x = {
      "aria-expanded": v,
      "aria-level": r.level + 1,
      "aria-posinset": r?.index + 1,
      "aria-setsize": $
    };
  }
  let { itemProps: B, ...N } = Ps({
    selectionManager: e.selectionManager,
    key: r.key,
    ref: n,
    isVirtualized: o,
    shouldSelectOnPressUp: t.shouldSelectOnPressUp || d,
    onAction: s || !((l = r.props) === null || l === void 0) && l.onAction ? Xe((i = r.props) === null || i === void 0 ? void 0 : i.onAction, s ? () => s(r.key) : void 0) : void 0,
    focus: b,
    linkBehavior: c
  }), R = (D) => {
    if (!D.currentTarget.contains(D.target) || !n.current || !document.activeElement) return;
    let v = yt(n.current);
    if (v.currentNode = document.activeElement, "expandedKeys" in e && document.activeElement === n.current) {
      if (D.key === hl.expand[u] && e.selectionManager.focusedKey === r.key && m && !e.expandedKeys.has(r.key)) {
        e.toggleKey(r.key), D.stopPropagation();
        return;
      } else if (D.key === hl.collapse[u] && e.selectionManager.focusedKey === r.key && m && e.expandedKeys.has(r.key)) {
        e.toggleKey(r.key), D.stopPropagation();
        return;
      }
    }
    switch (D.key) {
      case "ArrowLeft":
        if (f === "arrow") {
          let S = u === "rtl" ? v.nextNode() : v.previousNode();
          if (S)
            D.preventDefault(), D.stopPropagation(), ue(S), $e(S, {
              containingElement: De(n.current)
            });
          else if (D.preventDefault(), D.stopPropagation(), u === "rtl")
            ue(n.current), $e(n.current, {
              containingElement: De(n.current)
            });
          else {
            v.currentNode = n.current;
            let y = bl(v);
            y && (ue(y), $e(y, {
              containingElement: De(n.current)
            }));
          }
        }
        break;
      case "ArrowRight":
        if (f === "arrow") {
          let S = u === "rtl" ? v.previousNode() : v.nextNode();
          if (S)
            D.preventDefault(), D.stopPropagation(), ue(S), $e(S, {
              containingElement: De(n.current)
            });
          else if (D.preventDefault(), D.stopPropagation(), u === "ltr")
            ue(n.current), $e(n.current, {
              containingElement: De(n.current)
            });
          else {
            v.currentNode = n.current;
            let y = bl(v);
            y && (ue(y), $e(y, {
              containingElement: De(n.current)
            }));
          }
        }
        break;
      case "ArrowUp":
      case "ArrowDown":
        if (!D.altKey && n.current.contains(D.target)) {
          var $;
          D.stopPropagation(), D.preventDefault(), ($ = n.current.parentElement) === null || $ === void 0 || $.dispatchEvent(new KeyboardEvent(D.nativeEvent.type, D.nativeEvent));
        }
        break;
    }
  }, G = (D) => {
    if (h.current = r.key, D.target !== n.current) {
      wt() || e.selectionManager.setFocusedKey(r.key);
      return;
    }
  }, M = (D) => {
    if (!(!D.currentTarget.contains(D.target) || !n.current || !document.activeElement))
      switch (D.key) {
        case "Tab":
          if (f === "tab") {
            let v = yt(n.current, {
              tabbable: !0
            });
            v.currentNode = document.activeElement, (D.shiftKey ? v.previousNode() : v.nextNode()) && D.stopPropagation();
          }
      }
  }, a = Bl(r.props), w = N.hasAction ? a : {}, I = L(B, w, {
    role: "row",
    onKeyDownCapture: R,
    onKeyDown: M,
    onFocus: G,
    // 'aria-label': [(node.textValue || undefined), rowAnnouncement].filter(Boolean).join(', '),
    "aria-label": r.textValue || void 0,
    "aria-selected": e.selectionManager.canSelectItem(r.key) ? e.selectionManager.isSelected(r.key) : void 0,
    "aria-disabled": e.selectionManager.isDisabled(r.key) || void 0,
    "aria-labelledby": p && r.textValue ? `${pl(e, r.key)} ${p}` : void 0,
    id: pl(e, r.key)
  });
  o && (I["aria-rowindex"] = r.index + 1);
  let P = {
    role: "gridcell",
    "aria-colindex": 1
  };
  return {
    rowProps: {
      ...L(I, x)
    },
    gridCellProps: P,
    descriptionProps: {
      id: p
    },
    ...N
  };
}
function bl(t) {
  let e = null, n = null;
  do
    n = t.lastChild(), n && (e = n);
  while (n);
  return e;
}
function Os(t) {
  let { value: e = 0, minValue: n = 0, maxValue: l = 100, valueLabel: i, isIndeterminate: r, formatOptions: o = {
    style: "percent"
  } } = t, u = ee(t, {
    labelable: !0
  }), { labelProps: s, fieldProps: c } = ui({
    ...t,
    // Progress bar is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  e = Ge(e, n, l);
  let f = (e - n) / (l - n), d = ju(o);
  if (!r && !i) {
    let p = o.style === "percent" ? f : e;
    i = d.format(p);
  }
  return {
    progressBarProps: L(u, {
      ...c,
      "aria-valuenow": r ? void 0 : e,
      "aria-valuemin": n,
      "aria-valuemax": l,
      "aria-valuetext": r ? void 0 : i,
      role: "progressbar"
    }),
    labelProps: s
  };
}
const Wi = /* @__PURE__ */ new WeakMap();
function zs(t, e, n) {
  let { direction: l } = Ae(), i = t.keyboardDelegate || new ci({
    collection: e.collection,
    ref: n,
    orientation: "horizontal",
    direction: l,
    disabledKeys: e.disabledKeys,
    disabledBehavior: e.selectionManager.disabledBehavior
  }), { labelProps: r, fieldProps: o, descriptionProps: u, errorMessageProps: s } = Zu({
    ...t,
    labelElementType: "span"
  }), { gridProps: c } = Ns({
    ...t,
    ...o,
    keyboardDelegate: i,
    shouldFocusWrap: !0,
    linkBehavior: "override",
    keyboardNavigationBehavior: "tab"
  }, e, n), [f, d] = W(!1), { focusWithinProps: p } = gn({
    onFocusWithinChange: d
  }), h = ee(t), b = k(e.collection.size);
  return O(() => {
    n.current && b.current > 0 && e.collection.size === 0 && f && n.current.focus(), b.current = e.collection.size;
  }, [
    e.collection.size,
    f,
    n
  ]), Wi.set(e, {
    onRemove: t.onRemove
  }), {
    gridProps: L(c, h, {
      role: e.collection.size ? "grid" : null,
      "aria-atomic": !1,
      "aria-relevant": "additions",
      "aria-live": f ? "polite" : "off",
      ...p,
      ...o
    }),
    labelProps: r,
    descriptionProps: u,
    errorMessageProps: s
  };
}
var _i = {};
_i = {
  removeButtonLabel: "إزالة",
  removeDescription: "اضغط على مفتاح DELETE لإزالة علامة."
};
var Gi = {};
Gi = {
  removeButtonLabel: "Премахване",
  removeDescription: "Натиснете Delete, за да премахнете маркера."
};
var qi = {};
qi = {
  removeButtonLabel: "Odebrat",
  removeDescription: "Stisknutím klávesy Delete odeberete značku."
};
var Yi = {};
Yi = {
  removeButtonLabel: "Fjern",
  removeDescription: "Tryk på Slet for at fjerne tag."
};
var Xi = {};
Xi = {
  removeButtonLabel: "Entfernen",
  removeDescription: "Auf „Löschen“ drücken, um das Tag zu entfernen."
};
var Zi = {};
Zi = {
  removeButtonLabel: "Κατάργηση",
  removeDescription: "Πατήστε Διαγραφή για να καταργήσετε την ετικέτα."
};
var Ji = {};
Ji = {
  removeDescription: "Press Delete to remove tag.",
  removeButtonLabel: "Remove"
};
var Qi = {};
Qi = {
  removeButtonLabel: "Quitar",
  removeDescription: "Pulse Eliminar para quitar la etiqueta."
};
var er = {};
er = {
  removeButtonLabel: "Eemalda",
  removeDescription: "Sildi eemaldamiseks vajutage kustutusklahvi Delete."
};
var tr = {};
tr = {
  removeButtonLabel: "Poista",
  removeDescription: "Poista tunniste painamalla Poista-painiketta."
};
var nr = {};
nr = {
  removeButtonLabel: "Supprimer",
  removeDescription: "Appuyez sur Supprimer pour supprimer l’étiquette."
};
var lr = {};
lr = {
  removeButtonLabel: "הסר",
  removeDescription: "לחץ על מחק כדי להסיר תג."
};
var ir = {};
ir = {
  removeButtonLabel: "Ukloni",
  removeDescription: "Pritisnite Delete za uklanjanje oznake."
};
var rr = {};
rr = {
  removeButtonLabel: "Eltávolítás",
  removeDescription: "Nyomja meg a Delete billentyűt a címke eltávolításához."
};
var or = {};
or = {
  removeButtonLabel: "Rimuovi",
  removeDescription: "Premi Elimina per rimuovere il tag."
};
var ur = {};
ur = {
  removeButtonLabel: "削除",
  removeDescription: "タグを削除するには、Delete キーを押します。"
};
var sr = {};
sr = {
  removeButtonLabel: "제거",
  removeDescription: "태그를 제거하려면 Delete 키를 누르십시오."
};
var ar = {};
ar = {
  removeButtonLabel: "Pašalinti",
  removeDescription: "Norėdami pašalinti žymą, paspauskite „Delete“ klavišą."
};
var cr = {};
cr = {
  removeButtonLabel: "Noņemt",
  removeDescription: "Nospiediet Delete [Dzēst], lai noņemtu tagu."
};
var dr = {};
dr = {
  removeButtonLabel: "Fjern",
  removeDescription: "Trykk på Slett for å fjerne taggen."
};
var fr = {};
fr = {
  removeButtonLabel: "Verwijderen",
  removeDescription: "Druk op Verwijderen om de tag te verwijderen."
};
var pr = {};
pr = {
  removeButtonLabel: "Usuń",
  removeDescription: "Naciśnij Usuń, aby usunąć znacznik."
};
var vr = {};
vr = {
  removeButtonLabel: "Remover",
  removeDescription: "Pressione Delete para remover a tag."
};
var hr = {};
hr = {
  removeButtonLabel: "Eliminar",
  removeDescription: "Prima Delete para eliminar a tag."
};
var br = {};
br = {
  removeButtonLabel: "Îndepărtaţi",
  removeDescription: "Apăsați pe Delete (Ștergere) pentru a elimina eticheta."
};
var $r = {};
$r = {
  removeButtonLabel: "Удалить",
  removeDescription: "Нажмите DELETE, чтобы удалить тег."
};
var mr = {};
mr = {
  removeButtonLabel: "Odstrániť",
  removeDescription: "Ak chcete odstrániť značku, stlačte kláves Delete."
};
var yr = {};
yr = {
  removeButtonLabel: "Odstrani",
  removeDescription: "Pritisnite Delete, da odstranite oznako."
};
var gr = {};
gr = {
  removeButtonLabel: "Ukloni",
  removeDescription: "Pritisnite Obriši da biste uklonili oznaku."
};
var xr = {};
xr = {
  removeButtonLabel: "Ta bort",
  removeDescription: "Tryck på Radera för att ta bort taggen."
};
var Er = {};
Er = {
  removeButtonLabel: "Kaldır",
  removeDescription: "Etiketi kaldırmak için Sil tuşuna basın."
};
var Sr = {};
Sr = {
  removeButtonLabel: "Вилучити",
  removeDescription: "Натисніть Delete, щоб вилучити тег."
};
var Pr = {};
Pr = {
  removeButtonLabel: "删除",
  removeDescription: "按下“删除”以删除标记。"
};
var Cr = {};
Cr = {
  removeButtonLabel: "移除",
  removeDescription: "按 Delete 鍵以移除標記。"
};
var wr = {};
wr = {
  "ar-AE": _i,
  "bg-BG": Gi,
  "cs-CZ": qi,
  "da-DK": Yi,
  "de-DE": Xi,
  "el-GR": Zi,
  "en-US": Ji,
  "es-ES": Qi,
  "et-EE": er,
  "fi-FI": tr,
  "fr-FR": nr,
  "he-IL": lr,
  "hr-HR": ir,
  "hu-HU": rr,
  "it-IT": or,
  "ja-JP": ur,
  "ko-KR": sr,
  "lt-LT": ar,
  "lv-LV": cr,
  "nb-NO": dr,
  "nl-NL": fr,
  "pl-PL": pr,
  "pt-BR": vr,
  "pt-PT": hr,
  "ro-RO": br,
  "ru-RU": $r,
  "sk-SK": mr,
  "sl-SI": yr,
  "sr-SP": gr,
  "sv-SE": xr,
  "tr-TR": Er,
  "uk-UA": Sr,
  "zh-CN": Pr,
  "zh-TW": Cr
};
function Hs(t) {
  return t && t.__esModule ? t.default : t;
}
function Vs(t, e, n) {
  let { item: l } = t, i = xn(Hs(wr), "@react-aria/tag"), r = ae(), { onRemove: o } = Wi.get(e) || {}, { rowProps: u, gridCellProps: s, ...c } = Rs({
    node: l
  }, e, n), { descriptionProps: f, ...d } = c, p = e.disabledKeys.has(l.key) || l.props.isDisabled, h = (N) => {
    if (N.key === "Delete" || N.key === "Backspace") {
      if (p) return;
      N.preventDefault(), e.selectionManager.isSelected(l.key) ? o?.(new Set(e.selectionManager.selectedKeys)) : o?.(/* @__PURE__ */ new Set([
        l.key
      ]));
    }
  }, b = Yl();
  b === "virtual" && typeof window < "u" && "ontouchstart" in window && (b = "pointer");
  let x = o && (b === "keyboard" || b === "virtual") ? i.format("removeDescription") : "", m = an(x), g = l.key === e.selectionManager.focusedKey, E = e.selectionManager.focusedKey != null, T = -1;
  !p && (g || !E) && (T = 0);
  let K = ee(l.props), F = Bl(l.props), { focusableProps: B } = Je({
    isDisabled: p
  }, n);
  return {
    removeButtonProps: {
      "aria-label": i.format("removeButtonLabel"),
      "aria-labelledby": `${r} ${u.id}`,
      isDisabled: p,
      id: r,
      onPress: () => o ? o(/* @__PURE__ */ new Set([
        l.key
      ])) : null
    },
    rowProps: L(B, u, K, F, {
      tabIndex: T,
      onKeyDown: o ? h : void 0,
      "aria-describedby": m["aria-describedby"]
    }),
    gridCellProps: L(s, {
      "aria-errormessage": t["aria-errormessage"],
      "aria-label": t["aria-label"]
    }),
    ...d,
    allowsRemoving: !!o
  };
}
function js(t, e) {
  let n = ee(t, {
    labelable: !0
  }), { hoverProps: l } = ze({
    onHoverStart: () => e?.open(!0),
    onHoverEnd: () => e?.close()
  });
  return {
    tooltipProps: L(n, l, {
      role: "tooltip"
    })
  };
}
function Us(t, e, n) {
  let { isDisabled: l, trigger: i } = t, r = ae(), o = k(!1), u = k(!1), s = () => {
    (o.current || u.current) && e.open(u.current);
  }, c = (g) => {
    !o.current && !u.current && e.close(g);
  };
  O(() => {
    let g = (E) => {
      n && n.current && E.key === "Escape" && (E.stopPropagation(), e.close(!0));
    };
    if (e.isOpen)
      return document.addEventListener("keydown", g, !0), () => {
        document.removeEventListener("keydown", g, !0);
      };
  }, [
    n,
    e
  ]);
  let f = () => {
    i !== "focus" && (ht() === "pointer" ? o.current = !0 : o.current = !1, s());
  }, d = () => {
    i !== "focus" && (u.current = !1, o.current = !1, c());
  }, p = () => {
    u.current = !1, o.current = !1, c(!0);
  }, h = () => {
    wt() && (u.current = !0, s());
  }, b = () => {
    u.current = !1, o.current = !1, c(!0);
  }, { hoverProps: x } = ze({
    isDisabled: l,
    onHoverStart: f,
    onHoverEnd: d
  }), { focusableProps: m } = Je({
    isDisabled: l,
    onFocus: h,
    onBlur: b
  }, n);
  return {
    triggerProps: {
      "aria-describedby": e.isOpen ? r : void 0,
      ...L(m, x, {
        onPointerDown: p,
        onKeyDown: p,
        tabIndex: void 0
      })
    },
    tooltipProps: {
      id: r
    }
  };
}
const Dr = /* @__PURE__ */ Y({}), Tr = /* @__PURE__ */ Y(null), ha = /* @__PURE__ */ ve(function(e, n) {
  [e, n] = Be(e, n, Tr);
  let { value: l = 0, minValue: i = 0, maxValue: r = 100, isIndeterminate: o = !1 } = e;
  l = Ge(l, i, r);
  let [u, s] = Nl(!e["aria-label"] && !e["aria-labelledby"]), { progressBarProps: c, labelProps: f } = Os({
    ...e,
    label: s
  }), d = o ? void 0 : (l - i) / (r - i) * 100, p = xe({
    ...e,
    defaultClassName: "react-aria-ProgressBar",
    values: {
      percentage: d,
      valueText: c["aria-valuetext"],
      isIndeterminate: o
    }
  }), h = ee(e, {
    global: !0
  });
  return /* @__PURE__ */ C.createElement("div", {
    ...L(h, p, c),
    ref: n,
    slot: e.slot || void 0
  }, /* @__PURE__ */ C.createElement(Dr.Provider, {
    value: {
      ...f,
      ref: u,
      elementType: "span"
    }
  }, p.children));
}), kr = /* @__PURE__ */ Y({}), ba = /* @__PURE__ */ jo(function(e, n) {
  [e, n] = Be(e, n, kr), e = Ws(e);
  let l = e, { isPending: i } = l, { buttonProps: r, isPressed: o } = ti(e, n), { focusProps: u, isFocused: s, isFocusVisible: c } = Qe(e), { hoverProps: f, isHovered: d } = ze({
    ...e,
    isDisabled: e.isDisabled || i
  }), p = {
    isHovered: d,
    isPressed: (l.isPressed || o) && !i,
    isFocused: s,
    isFocusVisible: c,
    isDisabled: e.isDisabled || !1,
    isPending: i ?? !1
  }, h = xe({
    ...e,
    values: p,
    defaultClassName: "react-aria-Button"
  }), b = ae(r.id), x = ae(), m = r["aria-labelledby"];
  i && (m ? m = `${m} ${x}` : r["aria-label"] && (m = `${b} ${x}`));
  let g = k(i);
  O(() => {
    let T = {
      "aria-labelledby": m || b
    };
    (!g.current && s && i || g.current && s && !i) && tn(T, "assertive"), g.current = i;
  }, [
    i,
    s,
    m,
    b
  ]);
  let E = ee(e, {
    global: !0
  });
  return delete E.onClick, /* @__PURE__ */ C.createElement("button", {
    ...L(E, h, r, u, f),
    // When the button is in a pending state, we want to stop implicit form submission (ie. when the user presses enter on a text input).
    // We do this by changing the button's type to button.
    type: r.type === "submit" && i ? "button" : r.type,
    id: b,
    ref: n,
    "aria-labelledby": m,
    slot: e.slot || void 0,
    "aria-disabled": i ? "true" : r["aria-disabled"],
    "data-disabled": e.isDisabled || void 0,
    "data-pressed": p.isPressed || void 0,
    "data-hovered": d || void 0,
    "data-focused": s || void 0,
    "data-pending": i || void 0,
    "data-focus-visible": c || void 0
  }, /* @__PURE__ */ C.createElement(Tr.Provider, {
    value: {
      id: x
    }
  }, h.children));
});
function Ws(t) {
  return t.isPending && (t.onPress = void 0, t.onPressStart = void 0, t.onPressEnd = void 0, t.onPressChange = void 0, t.onPressUp = void 0, t.onKeyDown = void 0, t.onKeyUp = void 0, t.onClick = void 0, t.href = void 0), t;
}
const _s = /* @__PURE__ */ Y({});
class $l {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(e) {
    let n = this.keyMap.get(e);
    var l;
    return n && (l = n.prevKey) !== null && l !== void 0 ? l : null;
  }
  getKeyAfter(e) {
    let n = this.keyMap.get(e);
    var l;
    return n && (l = n.nextKey) !== null && l !== void 0 ? l : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(e) {
    var n;
    return (n = this.keyMap.get(e)) !== null && n !== void 0 ? n : null;
  }
  at(e) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[e]);
  }
  getChildren(e) {
    let n = this.keyMap.get(e);
    return n?.childNodes || [];
  }
  constructor(e) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = e;
    let n = (o) => {
      if (this.keyMap.set(o.key, o), o.childNodes && o.type === "section") for (let u of o.childNodes) n(u);
    };
    for (let o of e) n(o);
    let l = null, i = 0;
    for (let [o, u] of this.keyMap)
      l ? (l.nextKey = o, u.prevKey = l.key) : (this.firstKey = o, u.prevKey = void 0), u.type === "item" && (u.index = i++), l = u, l.nextKey = void 0;
    var r;
    this.lastKey = (r = l?.key) !== null && r !== void 0 ? r : null;
  }
}
class se extends Set {
  constructor(e, n, l) {
    super(e), e instanceof se ? (this.anchorKey = n ?? e.anchorKey, this.currentKey = l ?? e.currentKey) : (this.anchorKey = n ?? null, this.currentKey = l ?? null);
  }
}
function Gs(t, e) {
  if (t.size !== e.size) return !1;
  for (let n of t)
    if (!e.has(n)) return !1;
  return !0;
}
function qs(t) {
  let { selectionMode: e = "none", disallowEmptySelection: n = !1, allowDuplicateSelectionEvents: l, selectionBehavior: i = "toggle", disabledBehavior: r = "all" } = t, o = k(!1), [, u] = W(!1), s = k(null), c = k(null), [, f] = W(null), d = V(() => ml(t.selectedKeys), [
    t.selectedKeys
  ]), p = V(() => ml(t.defaultSelectedKeys, new se()), [
    t.defaultSelectedKeys
  ]), [h, b] = pn(d, p, t.onSelectionChange), x = V(() => t.disabledKeys ? new Set(t.disabledKeys) : /* @__PURE__ */ new Set(), [
    t.disabledKeys
  ]), [m, g] = W(i);
  i === "replace" && m === "toggle" && typeof h == "object" && h.size === 0 && g("replace");
  let E = k(i);
  return O(() => {
    i !== E.current && (g(i), E.current = i);
  }, [
    i
  ]), {
    selectionMode: e,
    disallowEmptySelection: n,
    selectionBehavior: m,
    setSelectionBehavior: g,
    get isFocused() {
      return o.current;
    },
    setFocused(T) {
      o.current = T, u(T);
    },
    get focusedKey() {
      return s.current;
    },
    get childFocusStrategy() {
      return c.current;
    },
    setFocusedKey(T, K = "first") {
      s.current = T, c.current = K, f(T);
    },
    selectedKeys: h,
    setSelectedKeys(T) {
      (l || !Gs(T, h)) && b(T);
    },
    disabledKeys: x,
    disabledBehavior: r
  };
}
function ml(t, e) {
  return t ? t === "all" ? "all" : new se(t) : e;
}
class Cn {
  /**
  * The type of selection that is allowed in the collection.
  */
  get selectionMode() {
    return this.state.selectionMode;
  }
  /**
  * Whether the collection allows empty selection.
  */
  get disallowEmptySelection() {
    return this.state.disallowEmptySelection;
  }
  /**
  * The selection behavior for the collection.
  */
  get selectionBehavior() {
    return this.state.selectionBehavior;
  }
  /**
  * Sets the selection behavior for the collection.
  */
  setSelectionBehavior(e) {
    this.state.setSelectionBehavior(e);
  }
  /**
  * Whether the collection is currently focused.
  */
  get isFocused() {
    return this.state.isFocused;
  }
  /**
  * Sets whether the collection is focused.
  */
  setFocused(e) {
    this.state.setFocused(e);
  }
  /**
  * The current focused key in the collection.
  */
  get focusedKey() {
    return this.state.focusedKey;
  }
  /** Whether the first or last child of the focused key should receive focus. */
  get childFocusStrategy() {
    return this.state.childFocusStrategy;
  }
  /**
  * Sets the focused key.
  */
  setFocusedKey(e, n) {
    (e == null || this.collection.getItem(e)) && this.state.setFocusedKey(e, n);
  }
  /**
  * The currently selected keys in the collection.
  */
  get selectedKeys() {
    return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
  }
  /**
  * The raw selection value for the collection.
  * Either 'all' for select all, or a set of keys.
  */
  get rawSelection() {
    return this.state.selectedKeys;
  }
  /**
  * Returns whether a key is selected.
  */
  isSelected(e) {
    if (this.state.selectionMode === "none") return !1;
    let n = this.getKey(e);
    return n == null ? !1 : this.state.selectedKeys === "all" ? this.canSelectItem(n) : this.state.selectedKeys.has(n);
  }
  /**
  * Whether the selection is empty.
  */
  get isEmpty() {
    return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
  }
  /**
  * Whether all items in the collection are selected.
  */
  get isSelectAll() {
    if (this.isEmpty) return !1;
    if (this.state.selectedKeys === "all") return !0;
    if (this._isSelectAll != null) return this._isSelectAll;
    let e = this.getSelectAllKeys(), n = this.state.selectedKeys;
    return this._isSelectAll = e.every((l) => n.has(l)), this._isSelectAll;
  }
  get firstSelectedKey() {
    let e = null;
    for (let l of this.state.selectedKeys) {
      let i = this.collection.getItem(l);
      (!e || i && Ut(this.collection, i, e) < 0) && (e = i);
    }
    var n;
    return (n = e?.key) !== null && n !== void 0 ? n : null;
  }
  get lastSelectedKey() {
    let e = null;
    for (let l of this.state.selectedKeys) {
      let i = this.collection.getItem(l);
      (!e || i && Ut(this.collection, i, e) > 0) && (e = i);
    }
    var n;
    return (n = e?.key) !== null && n !== void 0 ? n : null;
  }
  get disabledKeys() {
    return this.state.disabledKeys;
  }
  get disabledBehavior() {
    return this.state.disabledBehavior;
  }
  /**
  * Extends the selection to the given key.
  */
  extendSelection(e) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single") {
      this.replaceSelection(e);
      return;
    }
    let n = this.getKey(e);
    if (n == null) return;
    let l;
    if (this.state.selectedKeys === "all") l = new se([
      n
    ], n, n);
    else {
      let o = this.state.selectedKeys;
      var i;
      let u = (i = o.anchorKey) !== null && i !== void 0 ? i : n;
      l = new se(o, u, n);
      var r;
      for (let s of this.getKeyRange(u, (r = o.currentKey) !== null && r !== void 0 ? r : n)) l.delete(s);
      for (let s of this.getKeyRange(n, u)) this.canSelectItem(s) && l.add(s);
    }
    this.state.setSelectedKeys(l);
  }
  getKeyRange(e, n) {
    let l = this.collection.getItem(e), i = this.collection.getItem(n);
    return l && i ? Ut(this.collection, l, i) <= 0 ? this.getKeyRangeInternal(e, n) : this.getKeyRangeInternal(n, e) : [];
  }
  getKeyRangeInternal(e, n) {
    var l;
    if (!((l = this.layoutDelegate) === null || l === void 0) && l.getKeyRange) return this.layoutDelegate.getKeyRange(e, n);
    let i = [], r = e;
    for (; r != null; ) {
      let o = this.collection.getItem(r);
      if (o && (o.type === "item" || o.type === "cell" && this.allowsCellSelection) && i.push(r), r === n) return i;
      r = this.collection.getKeyAfter(r);
    }
    return [];
  }
  getKey(e) {
    let n = this.collection.getItem(e);
    if (!n || n.type === "cell" && this.allowsCellSelection) return e;
    for (; n && n.type !== "item" && n.parentKey != null; ) n = this.collection.getItem(n.parentKey);
    return !n || n.type !== "item" ? null : n.key;
  }
  /**
  * Toggles whether the given key is selected.
  */
  toggleSelection(e) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single" && !this.isSelected(e)) {
      this.replaceSelection(e);
      return;
    }
    let n = this.getKey(e);
    if (n == null) return;
    let l = new se(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
    l.has(n) ? l.delete(n) : this.canSelectItem(n) && (l.add(n), l.anchorKey = n, l.currentKey = n), !(this.disallowEmptySelection && l.size === 0) && this.state.setSelectedKeys(l);
  }
  /**
  * Replaces the selection with only the given key.
  */
  replaceSelection(e) {
    if (this.selectionMode === "none") return;
    let n = this.getKey(e);
    if (n == null) return;
    let l = this.canSelectItem(n) ? new se([
      n
    ], n, n) : new se();
    this.state.setSelectedKeys(l);
  }
  /**
  * Replaces the selection with the given keys.
  */
  setSelectedKeys(e) {
    if (this.selectionMode === "none") return;
    let n = new se();
    for (let l of e) {
      let i = this.getKey(l);
      if (i != null && (n.add(i), this.selectionMode === "single"))
        break;
    }
    this.state.setSelectedKeys(n);
  }
  getSelectAllKeys() {
    let e = [], n = (l) => {
      for (; l != null; ) {
        if (this.canSelectItem(l)) {
          var i;
          let o = this.collection.getItem(l);
          o?.type === "item" && e.push(l);
          var r;
          o?.hasChildNodes && (this.allowsCellSelection || o.type !== "item") && n((r = (i = Ks(ks(o, this.collection))) === null || i === void 0 ? void 0 : i.key) !== null && r !== void 0 ? r : null);
        }
        l = this.collection.getKeyAfter(l);
      }
    };
    return n(this.collection.getFirstKey()), e;
  }
  /**
  * Selects all items in the collection.
  */
  selectAll() {
    !this.isSelectAll && this.selectionMode === "multiple" && this.state.setSelectedKeys("all");
  }
  /**
  * Removes all keys from the selection.
  */
  clearSelection() {
    !this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new se());
  }
  /**
  * Toggles between select all and an empty selection.
  */
  toggleSelectAll() {
    this.isSelectAll ? this.clearSelection() : this.selectAll();
  }
  select(e, n) {
    this.selectionMode !== "none" && (this.selectionMode === "single" ? this.isSelected(e) && !this.disallowEmptySelection ? this.toggleSelection(e) : this.replaceSelection(e) : this.selectionBehavior === "toggle" || n && (n.pointerType === "touch" || n.pointerType === "virtual") ? this.toggleSelection(e) : this.replaceSelection(e));
  }
  /**
  * Returns whether the current selection is equal to the given selection.
  */
  isSelectionEqual(e) {
    if (e === this.state.selectedKeys) return !0;
    let n = this.selectedKeys;
    if (e.size !== n.size) return !1;
    for (let l of e)
      if (!n.has(l)) return !1;
    for (let l of n)
      if (!e.has(l)) return !1;
    return !0;
  }
  canSelectItem(e) {
    var n;
    if (this.state.selectionMode === "none" || this.state.disabledKeys.has(e)) return !1;
    let l = this.collection.getItem(e);
    return !(!l || !(l == null || (n = l.props) === null || n === void 0) && n.isDisabled || l.type === "cell" && !this.allowsCellSelection);
  }
  isDisabled(e) {
    var n, l;
    return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(e) || !!(!((l = this.collection.getItem(e)) === null || l === void 0 || (n = l.props) === null || n === void 0) && n.isDisabled));
  }
  isLink(e) {
    var n, l;
    return !!(!((l = this.collection.getItem(e)) === null || l === void 0 || (n = l.props) === null || n === void 0) && n.href);
  }
  getItemProps(e) {
    var n;
    return (n = this.collection.getItem(e)) === null || n === void 0 ? void 0 : n.props;
  }
  withCollection(e) {
    return new Cn(e, this.state, {
      allowsCellSelection: this.allowsCellSelection,
      layoutDelegate: this.layoutDelegate || void 0
    });
  }
  constructor(e, n, l) {
    this.collection = e, this.state = n;
    var i;
    this.allowsCellSelection = (i = l?.allowsCellSelection) !== null && i !== void 0 ? i : !1, this._isSelectAll = null, this.layoutDelegate = l?.layoutDelegate || null;
  }
}
function Ys(t) {
  let { filter: e, layoutDelegate: n } = t, l = qs(t), i = V(() => t.disabledKeys ? new Set(t.disabledKeys) : /* @__PURE__ */ new Set(), [
    t.disabledKeys
  ]), r = z((c) => e ? new $l(e(c)) : new $l(c), [
    e
  ]), o = V(() => ({
    suppressTextValueWarning: t.suppressTextValueWarning
  }), [
    t.suppressTextValueWarning
  ]), u = Ts(t, r, o), s = V(() => new Cn(u, l, {
    layoutDelegate: n
  }), [
    u,
    l,
    n
  ]);
  return Xs(u, s), {
    collection: u,
    disabledKeys: i,
    selectionManager: s
  };
}
function Xs(t, e) {
  const n = k(null);
  O(() => {
    if (e.focusedKey != null && !t.getItem(e.focusedKey) && n.current) {
      const f = n.current.getItem(e.focusedKey), d = [
        ...n.current.getKeys()
      ].map((g) => {
        const E = n.current.getItem(g);
        return E?.type === "item" ? E : null;
      }).filter((g) => g !== null), p = [
        ...t.getKeys()
      ].map((g) => {
        const E = t.getItem(g);
        return E?.type === "item" ? E : null;
      }).filter((g) => g !== null);
      var l, i;
      const h = ((l = d?.length) !== null && l !== void 0 ? l : 0) - ((i = p?.length) !== null && i !== void 0 ? i : 0);
      var r, o, u;
      let b = Math.min(h > 1 ? Math.max(((r = f?.index) !== null && r !== void 0 ? r : 0) - h + 1, 0) : (o = f?.index) !== null && o !== void 0 ? o : 0, ((u = p?.length) !== null && u !== void 0 ? u : 0) - 1), x = null, m = !1;
      for (; b >= 0; ) {
        if (!e.isDisabled(p[b].key)) {
          x = p[b];
          break;
        }
        if (b < p.length - 1 && !m) b++;
        else {
          m = !0;
          var s, c;
          b > ((s = f?.index) !== null && s !== void 0 ? s : 0) && (b = (c = f?.index) !== null && c !== void 0 ? c : 0), b--;
        }
      }
      e.setFocusedKey(x ? x.key : null);
    }
    n.current = t;
  }, [
    t,
    e
  ]);
}
function Zs(t) {
  let [e, n] = pn(t.isOpen, t.defaultOpen || !1, t.onOpenChange);
  const l = z(() => {
    n(!0);
  }, [
    n
  ]), i = z(() => {
    n(!1);
  }, [
    n
  ]), r = z(() => {
    n(!e);
  }, [
    n,
    e
  ]);
  return {
    isOpen: e,
    setOpen: n,
    open: l,
    close: i,
    toggle: r
  };
}
const Js = 1500, yl = 500;
let Ce = {}, Qs = 0, Ve = !1, fe = null, we = null;
function Kr(t = {}) {
  let { delay: e = Js, closeDelay: n = yl } = t, { isOpen: l, open: i, close: r } = Zs(t), o = V(() => `${++Qs}`, []), u = k(null), s = k(r), c = () => {
    Ce[o] = p;
  }, f = () => {
    for (let b in Ce) b !== o && (Ce[b](!0), delete Ce[b]);
  }, d = () => {
    u.current && clearTimeout(u.current), u.current = null, f(), c(), Ve = !0, i(), fe && (clearTimeout(fe), fe = null), we && (clearTimeout(we), we = null);
  }, p = (b) => {
    b || n <= 0 ? (u.current && clearTimeout(u.current), u.current = null, s.current()) : u.current || (u.current = setTimeout(() => {
      u.current = null, s.current();
    }, n)), fe && (clearTimeout(fe), fe = null), Ve && (we && clearTimeout(we), we = setTimeout(() => {
      delete Ce[o], we = null, Ve = !1;
    }, Math.max(yl, n)));
  }, h = () => {
    f(), c(), !l && !fe && !Ve ? fe = setTimeout(() => {
      fe = null, Ve = !0, d();
    }, e) : l || d();
  };
  return O(() => {
    s.current = r;
  }, [
    r
  ]), O(() => () => {
    u.current && clearTimeout(u.current), Ce[o] && delete Ce[o];
  }, [
    o
  ]), {
    isOpen: l,
    open: (b) => {
      !b && e > 0 && !u.current ? h() : d();
    },
    close: p
  };
}
const Br = {
  CollectionRoot({ collection: t, renderDropIndicator: e }) {
    return gl(t, null, e);
  },
  CollectionBranch({ collection: t, parent: e, renderDropIndicator: n }) {
    return gl(t, e, n);
  }
};
function gl(t, e, n) {
  return Ol({
    items: e ? t.getChildren(e.key) : t,
    dependencies: [
      n
    ],
    children(l) {
      let i = l.render(l);
      return !n || l.type !== "item" ? i : /* @__PURE__ */ C.createElement(C.Fragment, null, n({
        type: "item",
        key: l.key,
        dropPosition: "before"
      }), i, ea(t, l, n));
    }
  });
}
function ea(t, e, n) {
  let l = e.key, i = t.getKeyAfter(l), r = i != null ? t.getItem(i) : null;
  for (; r != null && r.type !== "item"; )
    i = t.getKeyAfter(r.key), r = i != null ? t.getItem(i) : null;
  let o = e.nextKey != null ? t.getItem(e.nextKey) : null;
  for (; o != null && o.type !== "item"; ) o = o.nextKey != null ? t.getItem(o.nextKey) : null;
  let u = [];
  if (o == null) {
    let s = e;
    for (; s && (!r || s.parentKey !== r.parentKey && r.level < s.level); ) {
      let c = n({
        type: "item",
        key: s.key,
        dropPosition: "after"
      });
      /* @__PURE__ */ Mr(c) && u.push(/* @__PURE__ */ xl(c, {
        key: `${s.key}-after`
      })), s = s.parentKey != null ? t.getItem(s.parentKey) : null;
    }
  }
  return u;
}
const Ar = /* @__PURE__ */ Y(Br);
function ta(t) {
  return V(() => t != null ? /* @__PURE__ */ new Set([
    t
  ]) : null, [
    t
  ]);
}
const na = /* @__PURE__ */ Y(null), $a = /* @__PURE__ */ ve(function(e, n) {
  [e, n] = Be(e, n, na);
  let l = e.href && !e.isDisabled ? "a" : "span", { linkProps: i, isPressed: r } = wu({
    ...e,
    elementType: l
  }, n), { hoverProps: o, isHovered: u } = ze(e), { focusProps: s, isFocused: c, isFocusVisible: f } = Qe(), d = xe({
    ...e,
    defaultClassName: "react-aria-Link",
    values: {
      isCurrent: !!e["aria-current"],
      isDisabled: e.isDisabled || !1,
      isPressed: r,
      isHovered: u,
      isFocused: c,
      isFocusVisible: f
    }
  }), p = ee(e, {
    global: !0
  });
  return delete p.onClick, /* @__PURE__ */ C.createElement(l, {
    ref: n,
    slot: e.slot || void 0,
    ...L(p, d, i, o, s),
    "data-focused": c || void 0,
    "data-hovered": u || void 0,
    "data-pressed": r || void 0,
    "data-focus-visible": f || void 0,
    "data-current": !!e["aria-current"] || void 0,
    "data-disabled": e.isDisabled || void 0
  }, d.children);
}), et = /* @__PURE__ */ Y(null);
Jl("loader", function(e, n, l) {
  let i = H(et), { isLoading: r, onLoadMore: o, scrollOffset: u, ...s } = e, c = k(null), f = V(() => ({
    onLoadMore: o,
    collection: i?.collection,
    sentinelRef: c,
    scrollOffset: u
  }), [
    o,
    u,
    i?.collection
  ]);
  Do(f, c);
  let d = xe({
    ...s,
    id: void 0,
    children: l.rendered,
    defaultClassName: "react-aria-ListBoxLoadingIndicator",
    values: null
  }), p = {
    // For Android talkback
    tabIndex: -1
  };
  return /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement("div", {
    style: {
      position: "relative",
      width: 0,
      height: 0
    },
    inert: To(!0)
  }, /* @__PURE__ */ C.createElement("div", {
    "data-testid": "loadMoreSentinel",
    ref: c,
    style: {
      position: "absolute",
      height: 1,
      width: 1
    }
  })), r && d.children && /* @__PURE__ */ C.createElement("div", {
    ...L(ee(e, {
      global: !0
    }), p),
    ...d,
    // aria-selected isn't needed here since this option is not selectable.
    // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
    role: "option",
    ref: n
  }, d.children));
});
const la = /* @__PURE__ */ Y({
  placement: "bottom"
}), ia = /* @__PURE__ */ Y(null), Fr = /* @__PURE__ */ Y(null), ma = /* @__PURE__ */ ve(function(e, n) {
  return [e, n] = Be(e, n, ia), /* @__PURE__ */ C.createElement($u, {
    content: e.children
  }, (l) => /* @__PURE__ */ C.createElement(ra, {
    props: e,
    forwardedRef: n,
    collection: l
  }));
});
function ra({ props: t, forwardedRef: e, collection: n }) {
  let l = k(null), [i, r] = Nl(!t["aria-label"] && !t["aria-labelledby"]), o = Ys({
    ...t,
    children: void 0,
    collection: n
  }), u = ee(t, {
    global: !0
  }), s = Object.fromEntries(Object.entries(u).map(([b]) => [
    b,
    void 0
  ])), { gridProps: c, labelProps: f, descriptionProps: d, errorMessageProps: p } = zs({
    ...t,
    ...s,
    label: r
  }, o, l);
  var h;
  return /* @__PURE__ */ C.createElement("div", {
    ...u,
    ref: e,
    slot: t.slot || void 0,
    className: (h = t.className) !== null && h !== void 0 ? h : "react-aria-TagGroup",
    style: t.style
  }, /* @__PURE__ */ C.createElement(vn, {
    values: [
      [
        Dr,
        {
          ...f,
          elementType: "span",
          ref: i
        }
      ],
      [
        Fr,
        {
          ...c,
          ref: l
        }
      ],
      [
        et,
        o
      ],
      [
        _s,
        {
          slots: {
            description: d,
            errorMessage: p
          }
        }
      ]
    ]
  }, t.children));
}
const ya = /* @__PURE__ */ ve(function(e, n) {
  return H(et) ? /* @__PURE__ */ C.createElement(oa, {
    props: e,
    forwardedRef: n
  }) : /* @__PURE__ */ C.createElement(Pu, e);
});
function oa({ props: t, forwardedRef: e }) {
  let n = H(et), { CollectionRoot: l } = H(Ar), [i, r] = Be({}, e, Fr), { focusProps: o, isFocused: u, isFocusVisible: s } = Qe(), c = {
    isEmpty: n.collection.size === 0,
    isFocused: u,
    isFocusVisible: s,
    state: n
  }, f = xe({
    className: t.className,
    style: t.style,
    defaultClassName: "react-aria-TagList",
    values: c
  }), d = ta(n.selectionManager.focusedKey), p = ee(t, {
    global: !0
  });
  return /* @__PURE__ */ C.createElement("div", {
    ...L(p, f, i, o),
    ref: r,
    "data-empty": n.collection.size === 0 || void 0,
    "data-focused": u || void 0,
    "data-focus-visible": s || void 0
  }, n.collection.size === 0 && t.renderEmptyState ? t.renderEmptyState(c) : /* @__PURE__ */ C.createElement(l, {
    collection: n.collection,
    persistedKeys: d
  }));
}
const ga = /* @__PURE__ */ Jl("item", (t, e, n) => {
  let l = H(et), i = Pt(e), { focusProps: r, isFocusVisible: o } = Qe({
    within: !1
  }), { rowProps: u, gridCellProps: s, removeButtonProps: c, ...f } = Vs({
    item: n
  }, l, i), { hoverProps: d, isHovered: p } = ze({
    isDisabled: !f.allowsSelection,
    onHoverStart: n.props.onHoverStart,
    onHoverChange: n.props.onHoverChange,
    onHoverEnd: n.props.onHoverEnd
  }), h = xe({
    ...t,
    id: void 0,
    children: n.rendered,
    defaultClassName: "react-aria-Tag",
    values: {
      ...f,
      isFocusVisible: o,
      isHovered: p,
      selectionMode: l.selectionManager.selectionMode,
      selectionBehavior: l.selectionManager.selectionBehavior
    }
  });
  O(() => {
    !n.textValue && process.env.NODE_ENV !== "production" && console.warn("A `textValue` prop is required for <Tag> elements with non-plain text children for accessibility.");
  }, [
    n.textValue
  ]);
  let b = ee(t, {
    global: !0
  });
  return delete b.id, delete b.onClick, /* @__PURE__ */ C.createElement("div", {
    ref: i,
    ...L(b, h, u, r, d),
    "data-selected": f.isSelected || void 0,
    "data-disabled": f.isDisabled || void 0,
    "data-hovered": p || void 0,
    "data-focused": f.isFocused || void 0,
    "data-focus-visible": o || void 0,
    "data-pressed": f.isPressed || void 0,
    "data-allows-removing": f.allowsRemoving || void 0,
    "data-selection-mode": l.selectionManager.selectionMode === "none" ? void 0 : l.selectionManager.selectionMode
  }, /* @__PURE__ */ C.createElement("div", {
    ...s,
    style: {
      display: "contents"
    }
  }, /* @__PURE__ */ C.createElement(vn, {
    values: [
      [
        kr,
        {
          slots: {
            remove: c
          }
        }
      ],
      [
        Ar,
        Br
      ]
    ]
  }, h.children)));
}), ua = /* @__PURE__ */ Y(null), sa = /* @__PURE__ */ Y({}), xa = /* @__PURE__ */ ve(function(e, n) {
  [e, n] = Be(e, n, sa);
  let l = H(ua), i = Ju(l && e.id != null ? {
    isSelected: l.selectedKeys.has(e.id),
    onChange(m) {
      l.setSelected(e.id, m);
    }
  } : e), { buttonProps: r, isPressed: o, isSelected: u, isDisabled: s } = l && e.id != null ? Yu({
    ...e,
    id: e.id
  }, l, n) : ni({
    ...e,
    id: e.id != null ? String(e.id) : void 0
  }, i, n), { focusProps: c, isFocused: f, isFocusVisible: d } = Qe(e), { hoverProps: p, isHovered: h } = ze(e), b = xe({
    ...e,
    id: void 0,
    values: {
      isHovered: h,
      isPressed: o,
      isFocused: f,
      isSelected: i.isSelected,
      isFocusVisible: d,
      isDisabled: s,
      state: i
    },
    defaultClassName: "react-aria-ToggleButton"
  }), x = ee(e, {
    global: !0
  });
  return delete x.id, delete x.onClick, /* @__PURE__ */ C.createElement("button", {
    ...L(x, b, r, c, p),
    ref: n,
    slot: e.slot || void 0,
    "data-focused": f || void 0,
    "data-disabled": s || void 0,
    "data-pressed": o || void 0,
    "data-selected": u || void 0,
    "data-hovered": h || void 0,
    "data-focus-visible": d || void 0
  });
}), wn = /* @__PURE__ */ Y(null), Ir = /* @__PURE__ */ Y(null);
function Ea(t) {
  let e = Kr(t), n = k(null), { triggerProps: l, tooltipProps: i } = Us(t, e, n);
  return /* @__PURE__ */ C.createElement(vn, {
    values: [
      [
        wn,
        e
      ],
      [
        Ir,
        {
          ...i,
          triggerRef: n
        }
      ]
    ]
  }, /* @__PURE__ */ C.createElement(au, {
    ...l,
    ref: n
  }, t.children));
}
const Sa = /* @__PURE__ */ ve(function({ UNSTABLE_portalContainer: e, ...n }, l) {
  [n, l] = Be(n, l, Ir);
  let i = H(wn), r = Kr(n), o = n.isOpen != null || n.defaultOpen != null || !i ? r : i, u = Ao(l, o.isOpen) || n.isExiting || !1;
  return !o.isOpen && !u ? null : /* @__PURE__ */ C.createElement($s, {
    portalContainer: e
  }, /* @__PURE__ */ C.createElement(aa, {
    ...n,
    tooltipRef: l,
    isExiting: u
  }));
});
function aa(t) {
  let e = H(wn), n = k(null), [l, i] = W(0);
  Z(() => {
    n.current && e.isOpen && i(n.current.getBoundingClientRect().width);
  }, [
    e.isOpen,
    n
  ]);
  let { overlayProps: r, arrowProps: o, placement: u } = ss({
    placement: t.placement || "top",
    targetRef: t.triggerRef,
    overlayRef: t.tooltipRef,
    offset: t.offset,
    crossOffset: t.crossOffset,
    isOpen: e.isOpen,
    arrowSize: l,
    arrowBoundaryOffset: t.arrowBoundaryOffset,
    shouldFlip: t.shouldFlip,
    onClose: () => e.close(!0)
  }), s = Bo(t.tooltipRef, !!u) || t.isEntering || !1, c = xe({
    ...t,
    defaultClassName: "react-aria-Tooltip",
    values: {
      placement: u,
      isEntering: s,
      isExiting: t.isExiting,
      state: e
    }
  });
  t = L(t, r);
  let { tooltipProps: f } = js(t, e), d = ee(t, {
    global: !0
  });
  return /* @__PURE__ */ C.createElement("div", {
    ...L(d, c, f),
    ref: t.tooltipRef,
    style: {
      ...r.style,
      ...c.style
    },
    "data-placement": u ?? void 0,
    "data-entering": s || void 0,
    "data-exiting": t.isExiting || void 0
  }, /* @__PURE__ */ C.createElement(la.Provider, {
    value: {
      ...o,
      placement: u,
      ref: n
    }
  }, c.children));
}
export {
  va as $,
  xa as a,
  $a as b,
  Or as c,
  fa as d,
  ba as e,
  ae as f,
  ha as g,
  Qe as h,
  ze as i,
  L as j,
  pa as k,
  Sa as l,
  Ea as m,
  ma as n,
  ya as o,
  ga as p
};
//# sourceMappingURL=vendor-Blw3V4C-.js.map
